/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './tanstack_routes/__root'
import { Route as IndexRouteImport } from './tanstack_routes/index'
import { Route as SplatRouteImport } from './tanstack_routes/$'
import { Route as MinimalRouteRouteImport } from './tanstack_routes/_minimal/route'
import { Route as ProtectedRouteRouteImport } from './tanstack_routes/_protected/route'
import { Route as FeedRouteImport } from './tanstack_routes/feed'
import { Route as HomeRouteImport } from './tanstack_routes/home'
import { Route as MinimalDownload_appRouteImport } from './tanstack_routes/_minimal/download_app'
import { Route as MinimalEclipseRouteImport } from './tanstack_routes/_minimal/eclipse'
import { Route as MinimalTwo_faRouteImport } from './tanstack_routes/_minimal/two_fa'
import { Route as ProtectedDynamicLayoutRouteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/route'
import { Route as ProtectedEmbedRouteRouteImport } from './tanstack_routes/_protected/_embed/route'
import { Route as ProtectedSettingsLayoutRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/route'
import { Route as ProtectedAccountRouteRouteImport } from './tanstack_routes/_protected/account/route'
import { Route as ProtectedAiRouteRouteImport } from './tanstack_routes/_protected/ai/route'
import { Route as ProtectedBookmarksRouteImport } from './tanstack_routes/_protected/bookmarks'
import { Route as ProtectedConnectionsRouteImport } from './tanstack_routes/_protected/connections'
import { Route as ProtectedDiscoverRouteImport } from './tanstack_routes/_protected/discover'
import { Route as ProtectedLeaderboardRouteImport } from './tanstack_routes/_protected/leaderboard'
import { Route as ProtectedMembersRouteRouteImport } from './tanstack_routes/_protected/members/route'
import { Route as ProtectedMessagesRouteRouteImport } from './tanstack_routes/_protected/messages/route'
import { Route as ProtectedNotificationsRouteImport } from './tanstack_routes/_protected/notifications'
import { Route as ProtectedThreadsRouteImport } from './tanstack_routes/_protected/threads'
import { Route as FeedWelcomeRouteImport } from './tanstack_routes/feed_.welcome'
import { Route as Marketing_emailsMarketing_email_preferenceRouteImport } from './tanstack_routes/marketing_emails/marketing_email_preference'
import { Route as Marketing_emailsUnsubscribeRouteImport } from './tanstack_routes/marketing_emails/unsubscribe'
import { Route as PublicUnsubscribeRouteImport } from './tanstack_routes/public/unsubscribe'
import { Route as MinimalLiveRoomSlugRouteRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/route'
import { Route as MinimalQuestionsAiIndexRouteImport } from './tanstack_routes/_minimal/questions-ai/index'
import { Route as MinimalSettingsCancelPlanRouteImport } from './tanstack_routes/_minimal/settings/cancel-plan'
import { Route as ProtectedDynamicLayoutAdminSettingsRouteImport } from './tanstack_routes/_protected/_dynamicLayout/admin-settings'
import { Route as ProtectedDynamicLayoutCoursesRouteImport } from './tanstack_routes/_protected/_dynamicLayout/courses'
import { Route as ProtectedDynamicLayoutEventsRouteImport } from './tanstack_routes/_protected/_dynamicLayout/events'
import { Route as ProtectedDynamicLayoutSearchRouteImport } from './tanstack_routes/_protected/_dynamicLayout/search'
import { Route as ProtectedDynamicLayoutSpacesRouteImport } from './tanstack_routes/_protected/_dynamicLayout/spaces'
import { Route as ProtectedAccountTabBodyRouteRouteImport } from './tanstack_routes/_protected/account/_tabBody/route'
import { Route as ProtectedAccountAffiliateRouteImport } from './tanstack_routes/_protected/account/affiliate'
import { Route as ProtectedAccountBillingRouteImport } from './tanstack_routes/_protected/account/billing'
import { Route as ProtectedAccountPartner_programRouteImport } from './tanstack_routes/_protected/account/partner_program'
import { Route as ProtectedAiIndexRouteImport } from './tanstack_routes/_protected/ai/index'
import { Route as ProtectedAiConversationIdRouteImport } from './tanstack_routes/_protected/ai/$conversationId'
import { Route as ProtectedAiBotsRouteRouteImport } from './tanstack_routes/_protected/ai/bots/route'
import { Route as ProtectedAiBriefsRouteRouteImport } from './tanstack_routes/_protected/ai/briefs/route'
import { Route as ProtectedAiDailyBriefsRouteRouteImport } from './tanstack_routes/_protected/ai/daily-briefs/route'
import { Route as ProtectedAiProjectsRouteRouteImport } from './tanstack_routes/_protected/ai/projects/route'
import { Route as ProtectedAiSkillsRouteImport } from './tanstack_routes/_protected/ai/skills'
import { Route as ProtectedGettingStartedIndexRouteImport } from './tanstack_routes/_protected/getting-started/index'
import { Route as ProtectedGettingStartedAiRouteImport } from './tanstack_routes/_protected/getting-started/ai'
import { Route as ProtectedMembersIndexRouteImport } from './tanstack_routes/_protected/members/index'
import { Route as ProtectedMembersSplatRouteImport } from './tanstack_routes/_protected/members/$'
import { Route as ProtectedMembersConnectionsRouteImport } from './tanstack_routes/_protected/members/connections'
import { Route as ProtectedMembersManageRouteImport } from './tanstack_routes/_protected/members/manage'
import { Route as ProtectedMembersMapRouteImport } from './tanstack_routes/_protected/members/map'
import { Route as ProtectedMessagesIndexRouteImport } from './tanstack_routes/_protected/messages/index'
import { Route as ProtectedMessagesUuidRouteImport } from './tanstack_routes/_protected/messages/$uuid'
import { Route as ProtectedSettingsInboxRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/route'
import { Route as NewsletterPostsSlugRouteImport } from './tanstack_routes/newsletter/posts/$slug'
import { Route as MinimalCustom_loginsDebug_sessionsUuidRouteImport } from './tanstack_routes/_minimal/custom_logins/debug_sessions/$uuid'
import { Route as MinimalLiveRoomSlugProtectedRouteRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/_protected/route'
import { Route as MinimalLiveRoomSlugPublicRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/public'
import { Route as MinimalLiveRoomSlugRecordRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/record'
import { Route as ProtectedDynamicLayoutCSpaceSlugRouteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/route'
import { Route as ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/s/$spaceGroupSlug/route'
import { Route as ProtectedDynamicLayoutUPublicUidRouteImport } from './tanstack_routes/_protected/_dynamicLayout/u/$publicUid'
import { Route as ProtectedEmbedCEmbedSpaceSlugRouteRouteImport } from './tanstack_routes/_protected/_embed/c/$embedSpaceSlug/route'
import { Route as ProtectedSettingsLayoutAudienceManageRouteImport } from './tanstack_routes/_protected/_settingsLayout/audience/manage'
import { Route as ProtectedSettingsLayoutContactsImportRouteImport } from './tanstack_routes/_protected/_settingsLayout/contacts/import'
import { Route as ProtectedSettingsLayoutSettingsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/index'
import { Route as ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_affiliatesLayout/route'
import { Route as ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_billingLayout/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/route'
import { Route as ProtectedSettingsLayoutSettingsApiRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/api/route'
import { Route as ProtectedSettingsLayoutSettingsBranded_appsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/branded_apps'
import { Route as ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/branded_apps_builder_landing_page'
import { Route as ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/branded_apps_builder_ui'
import { Route as ProtectedSettingsLayoutSettingsCode_snippetsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/code_snippets'
import { Route as ProtectedSettingsLayoutSettingsCommunity_aiRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/community_ai'
import { Route as ProtectedSettingsLayoutSettingsConnectRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/connect'
import { Route as ProtectedSettingsLayoutSettingsConversion_trackingRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/conversion_tracking'
import { Route as ProtectedSettingsLayoutSettingsCoursesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/courses/route'
import { Route as ProtectedSettingsLayoutSettingsCustom_domainRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/custom_domain'
import { Route as ProtectedSettingsLayoutSettingsDashboardRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/dashboard'
import { Route as ProtectedSettingsLayoutSettingsDevelopersRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/developers/route'
import { Route as ProtectedSettingsLayoutSettingsDiscoverRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/discover'
import { Route as ProtectedSettingsLayoutSettingsEmbedRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/embed'
import { Route as ProtectedSettingsLayoutSettingsFilesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/files/route'
import { Route as ProtectedSettingsLayoutSettingsGamificationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/gamification'
import { Route as ProtectedSettingsLayoutSettingsGeneralRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/general'
import { Route as ProtectedSettingsLayoutSettingsHomeRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/home'
import { Route as ProtectedSettingsLayoutSettingsLegalRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/legal'
import { Route as ProtectedSettingsLayoutSettingsLive_streamsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/live_streams/route'
import { Route as ProtectedSettingsLayoutSettingsMobile_appRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/mobile_app'
import { Route as ProtectedSettingsLayoutSettingsNavigationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/navigation'
import { Route as ProtectedSettingsLayoutSettingsNewsletterRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/route'
import { Route as ProtectedSettingsLayoutSettingsPaywall_bulk_logsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_bulk_logs'
import { Route as ProtectedSettingsLayoutSettingsPaywall_chargesRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_charges'
import { Route as ProtectedSettingsLayoutSettingsPaywall_groupsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_groups'
import { Route as ProtectedSettingsLayoutSettingsPaywall_payment_settingsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_payment_settings'
import { Route as ProtectedSettingsLayoutSettingsPaywall_subscriptionsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_subscriptions'
import { Route as ProtectedSettingsLayoutSettingsPaywall_tax_settingsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywall_tax_settings'
import { Route as ProtectedSettingsLayoutSettingsPlansRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plans/route'
import { Route as ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/profile_fields/route'
import { Route as ProtectedSettingsLayoutSettingsRecap2025RouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/recap-2025'
import { Route as ProtectedSettingsLayoutSettingsRedirectsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/redirects'
import { Route as ProtectedSettingsLayoutSettingsSegmentsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/segments/route'
import { Route as ProtectedSettingsLayoutSettingsSeoRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/seo'
import { Route as ProtectedSettingsLayoutSettingsSpacesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/spaces/route'
import { Route as ProtectedSettingsLayoutSettingsTopicsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/topics/route'
import { Route as ProtectedSettingsLayoutSettingsWeekly_digestRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/weekly_digest'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/route'
import { Route as ProtectedAccountTabBodyIndexRouteImport } from './tanstack_routes/_protected/account/_tabBody/index'
import { Route as ProtectedAccountTabBodyAuthenticationRouteImport } from './tanstack_routes/_protected/account/_tabBody/authentication'
import { Route as ProtectedAccountTabBodyNotificationsRouteImport } from './tanstack_routes/_protected/account/_tabBody/notifications'
import { Route as ProtectedAccountTabBodyPrivacyRouteImport } from './tanstack_routes/_protected/account/_tabBody/privacy'
import { Route as ProtectedAiBotsIndexRouteImport } from './tanstack_routes/_protected/ai/bots/index'
import { Route as ProtectedAiBotsHistoryRouteImport } from './tanstack_routes/_protected/ai/bots/history'
import { Route as ProtectedAiBriefsIndexRouteImport } from './tanstack_routes/_protected/ai/briefs/index'
import { Route as ProtectedAiDailyBriefsDailyBriefIdRouteImport } from './tanstack_routes/_protected/ai/daily-briefs/$dailyBriefId'
import { Route as ProtectedAiProjectsIndexRouteImport } from './tanstack_routes/_protected/ai/projects/index'
import { Route as ProtectedAiProjectsProjectIdRouteImport } from './tanstack_routes/_protected/ai/projects/$projectId'
import { Route as ProtectedMessagesBotIdRouteImport } from './tanstack_routes/_protected/messages/bot/$id'
import { Route as ProtectedSettingsInboxIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/index'
import { Route as ProtectedSettingsInboxAiRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/ai/route'
import { Route as ProtectedSettingsInboxChatThreadsRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/chat-threads/route'
import { Route as ProtectedSettingsInboxConnectionRequestsRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/connection-requests/route'
import { Route as ProtectedSettingsInboxCourseCommentsRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/course-comments/route'
import { Route as ProtectedSettingsInboxHumanSupportRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/human-support/route'
import { Route as ProtectedSettingsInboxMessagesRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/messages/route'
import { Route as ProtectedSettingsInboxModerationRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/moderation/route'
import { Route as ProtectedSettingsInboxNotificationsRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/notifications/route'
import { Route as ProtectedSettingsInboxPriorityRouteRouteImport } from './tanstack_routes/_protected/settings/inbox/priority/route'
import { Route as MinimalLiveRoomSlugProtectedIndexRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/_protected/index'
import { Route as MinimalLiveRoomSlugProtectedMobileRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/_protected/mobile'
import { Route as MinimalLiveRoomSlugProtectedNot_supportedRouteImport } from './tanstack_routes/_minimal/live/$roomSlug/_protected/not_supported'
import { Route as MinimalSettingsMembersOnboardingPreviewRouteImport } from './tanstack_routes/_minimal/settings/members/onboarding/preview'
import { Route as ProtectedDynamicLayoutCSpaceSlugPostSlugRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/$postSlug'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/route'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/route'
import { Route as ProtectedDynamicLayoutSSpaceGroupSlugIndexRouteImport } from './tanstack_routes/_protected/_dynamicLayout/s/$spaceGroupSlug/index'
import { Route as ProtectedDynamicLayoutSSpaceGroupSlugEditRouteImport } from './tanstack_routes/_protected/_dynamicLayout/s/$spaceGroupSlug/edit'
import { Route as ProtectedEmbedCEmbedSpaceSlugIndexRouteImport } from './tanstack_routes/_protected/_embed/c/$embedSpaceSlug/index'
import { Route as ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRouteImport } from './tanstack_routes/_protected/_embed/c/$embedSpaceSlug/$embedPostSlug'
import { Route as ProtectedSettingsLayoutMembersInvitation_linksIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/invitation_links/index'
import { Route as ProtectedSettingsLayoutMembersInvitation_linksSplatRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/invitation_links/$'
import { Route as ProtectedSettingsLayoutMembersInviteSplatRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/invite/$'
import { Route as ProtectedSettingsLayoutMembersOnboardingSplatRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/onboarding/$'
import { Route as ProtectedSettingsLayoutMembersProfile_fieldsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/profile_fields/index'
import { Route as ProtectedSettingsLayoutMembersProfile_fieldsSplatRouteImport } from './tanstack_routes/_protected/_settingsLayout/members/profile_fields/$'
import { Route as ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_commissions'
import { Route as ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_directory'
import { Route as ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_settings'
import { Route as ProtectedSettingsLayoutSettingsBillingLayoutBillingRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_billingLayout/billing'
import { Route as ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_billingLayout/invoices'
import { Route as ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/_billingLayout/payment_details'
import { Route as ProtectedSettingsLayoutSettingsAccess_groupsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/access_groups/index'
import { Route as ProtectedSettingsLayoutSettingsAiInboxIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-inbox/index'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/index'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/ai_agents/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/courses/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/devices/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/events/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/members/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/messages/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/payments/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/post_comments/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/reviews/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/spaces/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/videos/route'
import { Route as ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/analytics/website/route'
import { Route as ProtectedSettingsLayoutSettingsApiIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/api/index'
import { Route as ProtectedSettingsLayoutSettingsApiNewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/api/new/route'
import { Route as ProtectedSettingsLayoutSettingsAudienceConnectRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/audience/connect'
import { Route as ProtectedSettingsLayoutSettingsAudienceManageRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/audience/manage'
import { Route as ProtectedSettingsLayoutSettingsContactsImportRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/contacts/import'
import { Route as ProtectedSettingsLayoutSettingsCouponsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/index'
import { Route as ProtectedSettingsLayoutSettingsCouponsNewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/new/route'
import { Route as ProtectedSettingsLayoutSettingsCoursesIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/courses/index'
import { Route as ProtectedSettingsLayoutSettingsCoursesOverviewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/courses/overview'
import { Route as ProtectedSettingsLayoutSettingsEmailsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/route'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/route'
import { Route as ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/templates/route'
import { Route as ProtectedSettingsLayoutSettingsEventsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/events/index'
import { Route as ProtectedSettingsLayoutSettingsIntegrationsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/integrations/index'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/index'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/route'
import { Route as ProtectedSettingsLayoutSettingsLive_streamsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/live_streams/index'
import { Route as ProtectedSettingsLayoutSettingsLive_streamsIdRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/live_streams/$id'
import { Route as ProtectedSettingsLayoutSettingsMember_tagsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/member_tags/index'
import { Route as ProtectedSettingsLayoutSettingsMember_tagsNewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/member_tags/new'
import { Route as ProtectedSettingsLayoutSettingsMembersActivity_logsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/activity_logs'
import { Route as ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/bulk_import_tasks'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/route'
import { Route as ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/onboarding/route'
import { Route as ProtectedSettingsLayoutSettingsModerationIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/moderation/index'
import { Route as ProtectedSettingsLayoutSettingsModerationEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/moderation/edit'
import { Route as ProtectedSettingsLayoutSettingsNewsletterIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/index'
import { Route as ProtectedSettingsLayoutSettingsNewsletterActivateRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/activate'
import { Route as ProtectedSettingsLayoutSettingsOnboardingIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/onboarding/index'
import { Route as ProtectedSettingsLayoutSettingsPagesIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/index'
import { Route as ProtectedSettingsLayoutSettingsPaywallsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/index'
import { Route as ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/new/route'
import { Route as ProtectedSettingsLayoutSettingsPaywallsOnboardingRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/onboarding'
import { Route as ProtectedSettingsLayoutSettingsPlansIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plans/index'
import { Route as ProtectedSettingsLayoutSettingsPlusIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/index'
import { Route as ProtectedSettingsLayoutSettingsPlusAppSettingsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/app-settings'
import { Route as ProtectedSettingsLayoutSettingsPlusInsightsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/insights'
import { Route as ProtectedSettingsLayoutSettingsPlusLiteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/lite'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/route'
import { Route as ProtectedSettingsLayoutSettingsPostsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/posts/index'
import { Route as ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/posts/bulk_actions/route'
import { Route as ProtectedSettingsLayoutSettingsProfile_fieldsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/profile_fields/index'
import { Route as ProtectedSettingsLayoutSettingsProfile_fieldsManageRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/profile_fields/manage'
import { Route as ProtectedSettingsLayoutSettingsProfile_fieldsNewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/profile_fields/new'
import { Route as ProtectedSettingsLayoutSettingsSegmentsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/segments/index'
import { Route as ProtectedSettingsLayoutSettingsSegmentsIdRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/segments/$id'
import { Route as ProtectedSettingsLayoutSettingsSpacesSplatRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/spaces/$'
import { Route as ProtectedSettingsLayoutSettingsSsoIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/sso/index'
import { Route as ProtectedSettingsLayoutSettingsThemeIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/theme/index'
import { Route as ProtectedSettingsLayoutSettingsTopicsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/topics/index'
import { Route as ProtectedSettingsLayoutSettingsTopicsNewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/topics/new'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsHistoryRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/history'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/route'
import { Route as ProtectedAdminAudienceSqidIndexRouteImport } from './tanstack_routes/_protected/admin/audience/$sqid/index'
import { Route as ProtectedAdminAudienceSqidSplatRouteImport } from './tanstack_routes/_protected/admin/audience/$sqid/$'
import { Route as ProtectedAiBotsBotIdIndexRouteImport } from './tanstack_routes/_protected/ai/bots/$botId/index'
import { Route as ProtectedSettingsAdminAudienceSqidRouteRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/route'
import { Route as ProtectedSettingsInboxAiIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/ai/index'
import { Route as ProtectedSettingsInboxChatThreadsIdRouteImport } from './tanstack_routes/_protected/settings/inbox/chat-threads/$id'
import { Route as ProtectedSettingsInboxConnectionRequestsIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/connection-requests/index'
import { Route as ProtectedSettingsInboxConnectionRequestsIdRouteImport } from './tanstack_routes/_protected/settings/inbox/connection-requests/$id'
import { Route as ProtectedSettingsInboxCourseCommentsIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/course-comments/index'
import { Route as ProtectedSettingsInboxCourseCommentsChatRoomUuidRouteImport } from './tanstack_routes/_protected/settings/inbox/course-comments/$chatRoomUuid'
import { Route as ProtectedSettingsInboxHumanSupportIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/human-support/index'
import { Route as ProtectedSettingsInboxMessagesIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/messages/index'
import { Route as ProtectedSettingsInboxMessagesUuidRouteImport } from './tanstack_routes/_protected/settings/inbox/messages/$uuid'
import { Route as ProtectedSettingsInboxModerationIndexRouteImport } from './tanstack_routes/_protected/settings/inbox/moderation/index'
import { Route as ProtectedSettingsInboxModerationIdRouteImport } from './tanstack_routes/_protected/settings/inbox/moderation/$id'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/index'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/invite'
import { Route as ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/access_groups/$id/index'
import { Route as ProtectedSettingsLayoutSettingsAccess_groupsIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/access_groups/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/agents/index'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/route'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/knowledge/index'
import { Route as ProtectedSettingsLayoutSettingsAiInboxConversationsIdRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-inbox/conversations/$id'
import { Route as ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/$id/edit/route'
import { Route as ProtectedSettingsLayoutSettingsCouponsNewIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/new/index'
import { Route as ProtectedSettingsLayoutSettingsCouponsNewTabRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/new/$tab'
import { Route as ProtectedSettingsLayoutSettingsCoursesIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/courses/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/route'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/$id/route'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsNewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/new'
import { Route as ProtectedSettingsLayoutSettingsEmailsSettingsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/settings/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/templates/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/templates/$id/route'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/route'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/index'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/access'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/details'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/paywalls'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/subscription'
import { Route as ProtectedSettingsLayoutSettingsMember_tagsIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/member_tags/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/index'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteAccessRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/access'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteDetailsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/details'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteEmailsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/emails'
import { Route as ProtectedSettingsLayoutSettingsMembersInviteNewslettersRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/newsletters'
import { Route as ProtectedSettingsLayoutSettingsMembersInvitePaywallsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/paywalls'
import { Route as ProtectedSettingsLayoutSettingsMembersInvitePermissionsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/invite/permissions'
import { Route as ProtectedSettingsLayoutSettingsMembersOnboardingIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/onboarding/index'
import { Route as ProtectedSettingsLayoutSettingsMembersOnboardingTabRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/members/onboarding/$tab'
import { Route as ProtectedSettingsLayoutSettingsNewsletterListsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/lists/index'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/index'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/route'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/route'
import { Route as ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/$id/edit/route'
import { Route as ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125RouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/new/{-$tab}'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/index'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/$id/route'
import { Route as ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/profile_fields/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsTopicsTopicIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/topics/$topicId/edit'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/edit/$id/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/select_type'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/view/$id/route'
import { Route as ProtectedAiBotsBotIdConversationsConversationIdRouteImport } from './tanstack_routes/_protected/ai/bots/$botId/conversations/$conversationId'
import { Route as ProtectedSettingsAdminAudienceSqidIndexRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/index'
import { Route as ProtectedSettingsAdminAudienceSqidSplatRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/$'
import { Route as ProtectedSettingsAdminAudienceSqidAccessRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/access'
import { Route as ProtectedSettingsAdminAudienceSqidActivity_logsRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/activity_logs'
import { Route as ProtectedSettingsAdminAudienceSqidAffiliateRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/affiliate'
import { Route as ProtectedSettingsAdminAudienceSqidGamificationRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/gamification'
import { Route as ProtectedSettingsAdminAudienceSqidInfoRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/info'
import { Route as ProtectedSettingsAdminAudienceSqidNotesRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/notes'
import { Route as ProtectedSettingsInboxAiConversationsIdRouteImport } from './tanstack_routes/_protected/settings/inbox/ai/conversations/$id'
import { Route as ProtectedSettingsInboxHumanSupportConversationsIdRouteImport } from './tanstack_routes/_protected/settings/inbox/human-support/conversations/$id'
import { Route as ProtectedSettingsInboxMessagesBotIdRouteImport } from './tanstack_routes/_protected/settings/inbox/messages/bot/$id'
import { Route as ProtectedSettingsInboxPriorityKindUuidRouteImport } from './tanstack_routes/_protected/settings/inbox/priority/$kind/$uuid'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/audience'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/automations'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/behavior'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/customize'
import { Route as ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge'
import { Route as ProtectedSettingsLayoutSettingsCouponsIdEditIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/$id/edit/index'
import { Route as ProtectedSettingsLayoutSettingsCouponsIdEditTabRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/coupons/$id/edit/$tab'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/content'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/view/route'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/visual-builder'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/$id/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsFormsIdTabRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/forms/$id/$tab'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/index'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/access'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/details'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/paywalls'
import { Route as ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/subscription'
import { Route as ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/lists/$listId/index'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/index'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/content'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/overview'
import { Route as ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/settings'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/index'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/route'
import { Route as ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125RouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/$id/edit/{-$tab}'
import { Route as ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/new/checkout/customization'
import { Route as ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/new/upsell/customization'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/$id/edit'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/edit/$id/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/one_time/$id/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/preview.$id'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/view/$id/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/view/$id/runs'
import { Route as ProtectedSettingsAdminAudienceSqidBillingIndexRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/billing/index'
import { Route as ProtectedSettingsCoursesIdLessonsLessonIdEditRouteImport } from './tanstack_routes/_protected/settings/courses/$id/lessons/$lessonId/edit'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/view/index'
import { Route as ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/emails/broadcast/$id/view/analytics'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/index'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/code_snippets'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/defaults'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/navigation'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/redirects'
import { Route as ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/pages/edit/$id/settings/seo'
import { Route as ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/$id/edit/checkout/customization'
import { Route as ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/paywalls/$id/edit/upsell/customization'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/index'
import { Route as ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/analytics'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/one_time/$id/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/index'
import { Route as ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRouteImport } from './tanstack_routes/_protected/settings/admin/audience/$sqid/billing/subscriptions/new'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/route'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/route'
import { Route as ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRouteImport } from './tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/edit-lesson/sections/$sectionId/lessons/$lessonId'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/index'
import { Route as ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRouteImport } from './tanstack_routes/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const MinimalRouteRoute = MinimalRouteRouteImport.update({
  id: '/_minimal',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const MinimalDownload_appRoute = MinimalDownload_appRouteImport.update({
  id: '/download_app',
  path: '/download_app',
  getParentRoute: () => MinimalRouteRoute,
} as any)
const MinimalEclipseRoute = MinimalEclipseRouteImport.update({
  id: '/eclipse',
  path: '/eclipse',
  getParentRoute: () => MinimalRouteRoute,
} as any)
const MinimalTwo_faRoute = MinimalTwo_faRouteImport.update({
  id: '/two_fa',
  path: '/two_fa',
  getParentRoute: () => MinimalRouteRoute,
} as any)
const ProtectedDynamicLayoutRouteRoute =
  ProtectedDynamicLayoutRouteRouteImport.update({
    id: '/_dynamicLayout',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedEmbedRouteRoute = ProtectedEmbedRouteRouteImport.update({
  id: '/_embed',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedSettingsLayoutRouteRoute =
  ProtectedSettingsLayoutRouteRouteImport.update({
    id: '/_settingsLayout',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedAccountRouteRoute = ProtectedAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAiRouteRoute = ProtectedAiRouteRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedBookmarksRoute = ProtectedBookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedConnectionsRoute = ProtectedConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedDiscoverRoute = ProtectedDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedLeaderboardRoute = ProtectedLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedMembersRouteRoute = ProtectedMembersRouteRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedMessagesRouteRoute = ProtectedMessagesRouteRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedNotificationsRoute = ProtectedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedThreadsRoute = ProtectedThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const FeedWelcomeRoute = FeedWelcomeRouteImport.update({
  id: '/feed_/welcome',
  path: '/feed/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const Marketing_emailsMarketing_email_preferenceRoute =
  Marketing_emailsMarketing_email_preferenceRouteImport.update({
    id: '/marketing_emails/marketing_email_preference',
    path: '/marketing_emails/marketing_email_preference',
    getParentRoute: () => rootRouteImport,
  } as any)
const Marketing_emailsUnsubscribeRoute =
  Marketing_emailsUnsubscribeRouteImport.update({
    id: '/marketing_emails/unsubscribe',
    path: '/marketing_emails/unsubscribe',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicUnsubscribeRoute = PublicUnsubscribeRouteImport.update({
  id: '/public/unsubscribe',
  path: '/public/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const MinimalLiveRoomSlugRouteRoute =
  MinimalLiveRoomSlugRouteRouteImport.update({
    id: '/live/$roomSlug',
    path: '/live/$roomSlug',
    getParentRoute: () => MinimalRouteRoute,
  } as any)
const MinimalQuestionsAiIndexRoute = MinimalQuestionsAiIndexRouteImport.update({
  id: '/questions-ai/',
  path: '/questions-ai/',
  getParentRoute: () => MinimalRouteRoute,
} as any)
const MinimalSettingsCancelPlanRoute =
  MinimalSettingsCancelPlanRouteImport.update({
    id: '/settings/cancel-plan',
    path: '/settings/cancel-plan',
    getParentRoute: () => MinimalRouteRoute,
  } as any)
const ProtectedDynamicLayoutAdminSettingsRoute =
  ProtectedDynamicLayoutAdminSettingsRouteImport.update({
    id: '/admin-settings',
    path: '/admin-settings',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutCoursesRoute =
  ProtectedDynamicLayoutCoursesRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutEventsRoute =
  ProtectedDynamicLayoutEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutSearchRoute =
  ProtectedDynamicLayoutSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutSpacesRoute =
  ProtectedDynamicLayoutSpacesRouteImport.update({
    id: '/spaces',
    path: '/spaces',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedAccountTabBodyRouteRoute =
  ProtectedAccountTabBodyRouteRouteImport.update({
    id: '/_tabBody',
    getParentRoute: () => ProtectedAccountRouteRoute,
  } as any)
const ProtectedAccountAffiliateRoute =
  ProtectedAccountAffiliateRouteImport.update({
    id: '/affiliate',
    path: '/affiliate',
    getParentRoute: () => ProtectedAccountRouteRoute,
  } as any)
const ProtectedAccountBillingRoute = ProtectedAccountBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => ProtectedAccountRouteRoute,
} as any)
const ProtectedAccountPartner_programRoute =
  ProtectedAccountPartner_programRouteImport.update({
    id: '/partner_program',
    path: '/partner_program',
    getParentRoute: () => ProtectedAccountRouteRoute,
  } as any)
const ProtectedAiIndexRoute = ProtectedAiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAiRouteRoute,
} as any)
const ProtectedAiConversationIdRoute =
  ProtectedAiConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => ProtectedAiRouteRoute,
  } as any)
const ProtectedAiBotsRouteRoute = ProtectedAiBotsRouteRouteImport.update({
  id: '/bots',
  path: '/bots',
  getParentRoute: () => ProtectedAiRouteRoute,
} as any)
const ProtectedAiBriefsRouteRoute = ProtectedAiBriefsRouteRouteImport.update({
  id: '/briefs',
  path: '/briefs',
  getParentRoute: () => ProtectedAiRouteRoute,
} as any)
const ProtectedAiDailyBriefsRouteRoute =
  ProtectedAiDailyBriefsRouteRouteImport.update({
    id: '/daily-briefs',
    path: '/daily-briefs',
    getParentRoute: () => ProtectedAiRouteRoute,
  } as any)
const ProtectedAiProjectsRouteRoute =
  ProtectedAiProjectsRouteRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => ProtectedAiRouteRoute,
  } as any)
const ProtectedAiSkillsRoute = ProtectedAiSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => ProtectedAiRouteRoute,
} as any)
const ProtectedGettingStartedIndexRoute =
  ProtectedGettingStartedIndexRouteImport.update({
    id: '/getting-started/',
    path: '/getting-started/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedGettingStartedAiRoute =
  ProtectedGettingStartedAiRouteImport.update({
    id: '/getting-started/ai',
    path: '/getting-started/ai',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedMembersIndexRoute = ProtectedMembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedMembersRouteRoute,
} as any)
const ProtectedMembersSplatRoute = ProtectedMembersSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ProtectedMembersRouteRoute,
} as any)
const ProtectedMembersConnectionsRoute =
  ProtectedMembersConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => ProtectedMembersRouteRoute,
  } as any)
const ProtectedMembersManageRoute = ProtectedMembersManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => ProtectedMembersRouteRoute,
} as any)
const ProtectedMembersMapRoute = ProtectedMembersMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => ProtectedMembersRouteRoute,
} as any)
const ProtectedMessagesIndexRoute = ProtectedMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedMessagesRouteRoute,
} as any)
const ProtectedMessagesUuidRoute = ProtectedMessagesUuidRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => ProtectedMessagesRouteRoute,
} as any)
const ProtectedSettingsInboxRouteRoute =
  ProtectedSettingsInboxRouteRouteImport.update({
    id: '/settings/inbox',
    path: '/settings/inbox',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const NewsletterPostsSlugRoute = NewsletterPostsSlugRouteImport.update({
  id: '/newsletter/posts/$slug',
  path: '/newsletter/posts/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const MinimalCustom_loginsDebug_sessionsUuidRoute =
  MinimalCustom_loginsDebug_sessionsUuidRouteImport.update({
    id: '/custom_logins/debug_sessions/$uuid',
    path: '/custom_logins/debug_sessions/$uuid',
    getParentRoute: () => MinimalRouteRoute,
  } as any)
const MinimalLiveRoomSlugProtectedRouteRoute =
  MinimalLiveRoomSlugProtectedRouteRouteImport.update({
    id: '/_protected',
    getParentRoute: () => MinimalLiveRoomSlugRouteRoute,
  } as any)
const MinimalLiveRoomSlugPublicRoute =
  MinimalLiveRoomSlugPublicRouteImport.update({
    id: '/public',
    path: '/public',
    getParentRoute: () => MinimalLiveRoomSlugRouteRoute,
  } as any)
const MinimalLiveRoomSlugRecordRoute =
  MinimalLiveRoomSlugRecordRouteImport.update({
    id: '/record',
    path: '/record',
    getParentRoute: () => MinimalLiveRoomSlugRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugRouteRoute =
  ProtectedDynamicLayoutCSpaceSlugRouteRouteImport.update({
    id: '/c/$spaceSlug',
    path: '/c/$spaceSlug',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute =
  ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteImport.update({
    id: '/s/$spaceGroupSlug',
    path: '/s/$spaceGroupSlug',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutUPublicUidRoute =
  ProtectedDynamicLayoutUPublicUidRouteImport.update({
    id: '/u/$publicUid',
    path: '/u/$publicUid',
    getParentRoute: () => ProtectedDynamicLayoutRouteRoute,
  } as any)
const ProtectedEmbedCEmbedSpaceSlugRouteRoute =
  ProtectedEmbedCEmbedSpaceSlugRouteRouteImport.update({
    id: '/c/$embedSpaceSlug',
    path: '/c/$embedSpaceSlug',
    getParentRoute: () => ProtectedEmbedRouteRoute,
  } as any)
const ProtectedSettingsLayoutAudienceManageRoute =
  ProtectedSettingsLayoutAudienceManageRouteImport.update({
    id: '/audience/manage',
    path: '/audience/manage',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutContactsImportRoute =
  ProtectedSettingsLayoutContactsImportRouteImport.update({
    id: '/contacts/import',
    path: '/contacts/import',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsIndexRoute =
  ProtectedSettingsLayoutSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute =
  ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteImport.update({
    id: '/settings/_affiliatesLayout',
    path: '/settings',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute =
  ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteImport.update({
    id: '/settings/_billingLayout',
    path: '/settings',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsRouteRouteImport.update({
    id: '/settings/analytics',
    path: '/settings/analytics',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsApiRouteRoute =
  ProtectedSettingsLayoutSettingsApiRouteRouteImport.update({
    id: '/settings/api',
    path: '/settings/api',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsBranded_appsRoute =
  ProtectedSettingsLayoutSettingsBranded_appsRouteImport.update({
    id: '/settings/branded_apps',
    path: '/settings/branded_apps',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute =
  ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRouteImport.update(
    {
      id: '/settings/branded_apps_builder_landing_page',
      path: '/settings/branded_apps_builder_landing_page',
      getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute =
  ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRouteImport.update({
    id: '/settings/branded_apps_builder_ui',
    path: '/settings/branded_apps_builder_ui',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCode_snippetsRoute =
  ProtectedSettingsLayoutSettingsCode_snippetsRouteImport.update({
    id: '/settings/code_snippets',
    path: '/settings/code_snippets',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCommunity_aiRoute =
  ProtectedSettingsLayoutSettingsCommunity_aiRouteImport.update({
    id: '/settings/community_ai',
    path: '/settings/community_ai',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsConnectRoute =
  ProtectedSettingsLayoutSettingsConnectRouteImport.update({
    id: '/settings/connect',
    path: '/settings/connect',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsConversion_trackingRoute =
  ProtectedSettingsLayoutSettingsConversion_trackingRouteImport.update({
    id: '/settings/conversion_tracking',
    path: '/settings/conversion_tracking',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCoursesRouteRoute =
  ProtectedSettingsLayoutSettingsCoursesRouteRouteImport.update({
    id: '/settings/courses',
    path: '/settings/courses',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCustom_domainRoute =
  ProtectedSettingsLayoutSettingsCustom_domainRouteImport.update({
    id: '/settings/custom_domain',
    path: '/settings/custom_domain',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsDashboardRoute =
  ProtectedSettingsLayoutSettingsDashboardRouteImport.update({
    id: '/settings/dashboard',
    path: '/settings/dashboard',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsDevelopersRouteRoute =
  ProtectedSettingsLayoutSettingsDevelopersRouteRouteImport.update({
    id: '/settings/developers',
    path: '/settings/developers',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsDiscoverRoute =
  ProtectedSettingsLayoutSettingsDiscoverRouteImport.update({
    id: '/settings/discover',
    path: '/settings/discover',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmbedRoute =
  ProtectedSettingsLayoutSettingsEmbedRouteImport.update({
    id: '/settings/embed',
    path: '/settings/embed',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsFilesRouteRoute =
  ProtectedSettingsLayoutSettingsFilesRouteRouteImport.update({
    id: '/settings/files',
    path: '/settings/files',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsGamificationRoute =
  ProtectedSettingsLayoutSettingsGamificationRouteImport.update({
    id: '/settings/gamification',
    path: '/settings/gamification',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsGeneralRoute =
  ProtectedSettingsLayoutSettingsGeneralRouteImport.update({
    id: '/settings/general',
    path: '/settings/general',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsHomeRoute =
  ProtectedSettingsLayoutSettingsHomeRouteImport.update({
    id: '/settings/home',
    path: '/settings/home',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsLegalRoute =
  ProtectedSettingsLayoutSettingsLegalRouteImport.update({
    id: '/settings/legal',
    path: '/settings/legal',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsLive_streamsRouteRoute =
  ProtectedSettingsLayoutSettingsLive_streamsRouteRouteImport.update({
    id: '/settings/live_streams',
    path: '/settings/live_streams',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMobile_appRoute =
  ProtectedSettingsLayoutSettingsMobile_appRouteImport.update({
    id: '/settings/mobile_app',
    path: '/settings/mobile_app',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNavigationRoute =
  ProtectedSettingsLayoutSettingsNavigationRouteImport.update({
    id: '/settings/navigation',
    path: '/settings/navigation',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterRouteRoute =
  ProtectedSettingsLayoutSettingsNewsletterRouteRouteImport.update({
    id: '/settings/newsletter',
    path: '/settings/newsletter',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute =
  ProtectedSettingsLayoutSettingsPaywall_bulk_logsRouteImport.update({
    id: '/settings/paywall_bulk_logs',
    path: '/settings/paywall_bulk_logs',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_chargesRoute =
  ProtectedSettingsLayoutSettingsPaywall_chargesRouteImport.update({
    id: '/settings/paywall_charges',
    path: '/settings/paywall_charges',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_groupsRoute =
  ProtectedSettingsLayoutSettingsPaywall_groupsRouteImport.update({
    id: '/settings/paywall_groups',
    path: '/settings/paywall_groups',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute =
  ProtectedSettingsLayoutSettingsPaywall_payment_settingsRouteImport.update({
    id: '/settings/paywall_payment_settings',
    path: '/settings/paywall_payment_settings',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute =
  ProtectedSettingsLayoutSettingsPaywall_subscriptionsRouteImport.update({
    id: '/settings/paywall_subscriptions',
    path: '/settings/paywall_subscriptions',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute =
  ProtectedSettingsLayoutSettingsPaywall_tax_settingsRouteImport.update({
    id: '/settings/paywall_tax_settings',
    path: '/settings/paywall_tax_settings',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlansRouteRoute =
  ProtectedSettingsLayoutSettingsPlansRouteRouteImport.update({
    id: '/settings/plans',
    path: '/settings/plans',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute =
  ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteImport.update({
    id: '/settings/profile_fields',
    path: '/settings/profile_fields',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsRecap2025Route =
  ProtectedSettingsLayoutSettingsRecap2025RouteImport.update({
    id: '/settings/recap-2025',
    path: '/settings/recap-2025',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsRedirectsRoute =
  ProtectedSettingsLayoutSettingsRedirectsRouteImport.update({
    id: '/settings/redirects',
    path: '/settings/redirects',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSegmentsRouteRoute =
  ProtectedSettingsLayoutSettingsSegmentsRouteRouteImport.update({
    id: '/settings/segments',
    path: '/settings/segments',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSeoRoute =
  ProtectedSettingsLayoutSettingsSeoRouteImport.update({
    id: '/settings/seo',
    path: '/settings/seo',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSpacesRouteRoute =
  ProtectedSettingsLayoutSettingsSpacesRouteRouteImport.update({
    id: '/settings/spaces',
    path: '/settings/spaces',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsTopicsRouteRoute =
  ProtectedSettingsLayoutSettingsTopicsRouteRouteImport.update({
    id: '/settings/topics',
    path: '/settings/topics',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWeekly_digestRoute =
  ProtectedSettingsLayoutSettingsWeekly_digestRouteImport.update({
    id: '/settings/weekly_digest',
    path: '/settings/weekly_digest',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsRouteRouteImport.update({
    id: '/settings/workflows',
    path: '/settings/workflows',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedAccountTabBodyIndexRoute =
  ProtectedAccountTabBodyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAccountTabBodyRouteRoute,
  } as any)
const ProtectedAccountTabBodyAuthenticationRoute =
  ProtectedAccountTabBodyAuthenticationRouteImport.update({
    id: '/authentication',
    path: '/authentication',
    getParentRoute: () => ProtectedAccountTabBodyRouteRoute,
  } as any)
const ProtectedAccountTabBodyNotificationsRoute =
  ProtectedAccountTabBodyNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedAccountTabBodyRouteRoute,
  } as any)
const ProtectedAccountTabBodyPrivacyRoute =
  ProtectedAccountTabBodyPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => ProtectedAccountTabBodyRouteRoute,
  } as any)
const ProtectedAiBotsIndexRoute = ProtectedAiBotsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAiBotsRouteRoute,
} as any)
const ProtectedAiBotsHistoryRoute = ProtectedAiBotsHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => ProtectedAiBotsRouteRoute,
} as any)
const ProtectedAiBriefsIndexRoute = ProtectedAiBriefsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAiBriefsRouteRoute,
} as any)
const ProtectedAiDailyBriefsDailyBriefIdRoute =
  ProtectedAiDailyBriefsDailyBriefIdRouteImport.update({
    id: '/$dailyBriefId',
    path: '/$dailyBriefId',
    getParentRoute: () => ProtectedAiDailyBriefsRouteRoute,
  } as any)
const ProtectedAiProjectsIndexRoute =
  ProtectedAiProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedAiProjectsRouteRoute,
  } as any)
const ProtectedAiProjectsProjectIdRoute =
  ProtectedAiProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => ProtectedAiProjectsRouteRoute,
  } as any)
const ProtectedMessagesBotIdRoute = ProtectedMessagesBotIdRouteImport.update({
  id: '/bot/$id',
  path: '/bot/$id',
  getParentRoute: () => ProtectedMessagesRouteRoute,
} as any)
const ProtectedSettingsInboxIndexRoute =
  ProtectedSettingsInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxAiRouteRoute =
  ProtectedSettingsInboxAiRouteRouteImport.update({
    id: '/ai',
    path: '/ai',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxChatThreadsRouteRoute =
  ProtectedSettingsInboxChatThreadsRouteRouteImport.update({
    id: '/chat-threads',
    path: '/chat-threads',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxConnectionRequestsRouteRoute =
  ProtectedSettingsInboxConnectionRequestsRouteRouteImport.update({
    id: '/connection-requests',
    path: '/connection-requests',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxCourseCommentsRouteRoute =
  ProtectedSettingsInboxCourseCommentsRouteRouteImport.update({
    id: '/course-comments',
    path: '/course-comments',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxHumanSupportRouteRoute =
  ProtectedSettingsInboxHumanSupportRouteRouteImport.update({
    id: '/human-support',
    path: '/human-support',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxMessagesRouteRoute =
  ProtectedSettingsInboxMessagesRouteRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxModerationRouteRoute =
  ProtectedSettingsInboxModerationRouteRouteImport.update({
    id: '/moderation',
    path: '/moderation',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxNotificationsRouteRoute =
  ProtectedSettingsInboxNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const ProtectedSettingsInboxPriorityRouteRoute =
  ProtectedSettingsInboxPriorityRouteRouteImport.update({
    id: '/priority',
    path: '/priority',
    getParentRoute: () => ProtectedSettingsInboxRouteRoute,
  } as any)
const MinimalLiveRoomSlugProtectedIndexRoute =
  MinimalLiveRoomSlugProtectedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MinimalLiveRoomSlugProtectedRouteRoute,
  } as any)
const MinimalLiveRoomSlugProtectedMobileRoute =
  MinimalLiveRoomSlugProtectedMobileRouteImport.update({
    id: '/mobile',
    path: '/mobile',
    getParentRoute: () => MinimalLiveRoomSlugProtectedRouteRoute,
  } as any)
const MinimalLiveRoomSlugProtectedNot_supportedRoute =
  MinimalLiveRoomSlugProtectedNot_supportedRouteImport.update({
    id: '/not_supported',
    path: '/not_supported',
    getParentRoute: () => MinimalLiveRoomSlugProtectedRouteRoute,
  } as any)
const MinimalSettingsMembersOnboardingPreviewRoute =
  MinimalSettingsMembersOnboardingPreviewRouteImport.update({
    id: '/settings/members/onboarding/preview',
    path: '/settings/members/onboarding/preview',
    getParentRoute: () => MinimalRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugPostSlugRoute =
  ProtectedDynamicLayoutCSpaceSlugPostSlugRouteImport.update({
    id: '/$postSlug',
    path: '/$postSlug',
    getParentRoute: () => ProtectedDynamicLayoutCSpaceSlugRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteImport.update({
    id: '/_spaceLayout',
    getParentRoute: () => ProtectedDynamicLayoutCSpaceSlugRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteImport.update({
    id: '/_spaceLockGuard',
    getParentRoute: () => ProtectedDynamicLayoutCSpaceSlugRouteRoute,
  } as any)
const ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute =
  ProtectedDynamicLayoutSSpaceGroupSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute,
  } as any)
const ProtectedDynamicLayoutSSpaceGroupSlugEditRoute =
  ProtectedDynamicLayoutSSpaceGroupSlugEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute,
  } as any)
const ProtectedEmbedCEmbedSpaceSlugIndexRoute =
  ProtectedEmbedCEmbedSpaceSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedEmbedCEmbedSpaceSlugRouteRoute,
  } as any)
const ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute =
  ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRouteImport.update({
    id: '/$embedPostSlug',
    path: '/$embedPostSlug',
    getParentRoute: () => ProtectedEmbedCEmbedSpaceSlugRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersInvitation_linksIndexRoute =
  ProtectedSettingsLayoutMembersInvitation_linksIndexRouteImport.update({
    id: '/members/invitation_links/',
    path: '/members/invitation_links/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersInvitation_linksSplatRoute =
  ProtectedSettingsLayoutMembersInvitation_linksSplatRouteImport.update({
    id: '/members/invitation_links/$',
    path: '/members/invitation_links/$',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersInviteSplatRoute =
  ProtectedSettingsLayoutMembersInviteSplatRouteImport.update({
    id: '/members/invite/$',
    path: '/members/invite/$',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersOnboardingSplatRoute =
  ProtectedSettingsLayoutMembersOnboardingSplatRouteImport.update({
    id: '/members/onboarding/$',
    path: '/members/onboarding/$',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute =
  ProtectedSettingsLayoutMembersProfile_fieldsIndexRouteImport.update({
    id: '/members/profile_fields/',
    path: '/members/profile_fields/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute =
  ProtectedSettingsLayoutMembersProfile_fieldsSplatRouteImport.update({
    id: '/members/profile_fields/$',
    path: '/members/profile_fields/$',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute =
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRouteImport.update(
    {
      id: '/affiliates_commissions',
      path: '/affiliates_commissions',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute =
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRouteImport.update(
    {
      id: '/affiliates_directory',
      path: '/affiliates_directory',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute =
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRouteImport.update(
    {
      id: '/affiliates_settings',
      path: '/affiliates_settings',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute =
  ProtectedSettingsLayoutSettingsBillingLayoutBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute =
  ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute =
  ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRouteImport.update(
    {
      id: '/payment_details',
      path: '/payment_details',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute =
  ProtectedSettingsLayoutSettingsAccess_groupsIndexRouteImport.update({
    id: '/settings/access_groups/',
    path: '/settings/access_groups/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAiInboxIndexRoute =
  ProtectedSettingsLayoutSettingsAiInboxIndexRouteImport.update({
    id: '/settings/ai-inbox/',
    path: '/settings/ai-inbox/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsIndexRoute =
  ProtectedSettingsLayoutSettingsAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRouteImport.update({
    id: '/ai_agents',
    path: '/ai_agents',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRouteImport.update({
    id: '/post_comments',
    path: '/post_comments',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRouteImport.update({
    id: '/spaces',
    path: '/spaces',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRouteImport.update({
    id: '/videos',
    path: '/videos',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute =
  ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRouteImport.update({
    id: '/website',
    path: '/website',
    getParentRoute: () => ProtectedSettingsLayoutSettingsAnalyticsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsApiIndexRoute =
  ProtectedSettingsLayoutSettingsApiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsApiRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsApiNewRouteRoute =
  ProtectedSettingsLayoutSettingsApiNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedSettingsLayoutSettingsApiRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAudienceConnectRoute =
  ProtectedSettingsLayoutSettingsAudienceConnectRouteImport.update({
    id: '/settings/audience/connect',
    path: '/settings/audience/connect',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAudienceManageRoute =
  ProtectedSettingsLayoutSettingsAudienceManageRouteImport.update({
    id: '/settings/audience/manage',
    path: '/settings/audience/manage',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsContactsImportRoute =
  ProtectedSettingsLayoutSettingsContactsImportRouteImport.update({
    id: '/settings/contacts/import',
    path: '/settings/contacts/import',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsIndexRoute =
  ProtectedSettingsLayoutSettingsCouponsIndexRouteImport.update({
    id: '/settings/coupons/',
    path: '/settings/coupons/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsNewRouteRoute =
  ProtectedSettingsLayoutSettingsCouponsNewRouteRouteImport.update({
    id: '/settings/coupons/new',
    path: '/settings/coupons/new',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCoursesIndexRoute =
  ProtectedSettingsLayoutSettingsCoursesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsCoursesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCoursesOverviewRoute =
  ProtectedSettingsLayoutSettingsCoursesOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ProtectedSettingsLayoutSettingsCoursesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsIndexRouteImport.update({
    id: '/settings/emails/',
    path: '/settings/emails/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteImport.update({
    id: '/settings/emails/broadcast',
    path: '/settings/emails/broadcast',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteImport.update({
    id: '/settings/emails/forms',
    path: '/settings/emails/forms',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteImport.update({
    id: '/settings/emails/templates',
    path: '/settings/emails/templates',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEventsIndexRoute =
  ProtectedSettingsLayoutSettingsEventsIndexRouteImport.update({
    id: '/settings/events/',
    path: '/settings/events/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsIntegrationsIndexRoute =
  ProtectedSettingsLayoutSettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIndexRouteImport.update({
    id: '/settings/invitation_links/',
    path: '/settings/invitation_links/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteImport.update({
    id: '/settings/invitation_links/new',
    path: '/settings/invitation_links/new',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsLive_streamsIndexRoute =
  ProtectedSettingsLayoutSettingsLive_streamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsLive_streamsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsLive_streamsIdRoute =
  ProtectedSettingsLayoutSettingsLive_streamsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsLive_streamsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMember_tagsIndexRoute =
  ProtectedSettingsLayoutSettingsMember_tagsIndexRouteImport.update({
    id: '/settings/member_tags/',
    path: '/settings/member_tags/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMember_tagsNewRoute =
  ProtectedSettingsLayoutSettingsMember_tagsNewRouteImport.update({
    id: '/settings/member_tags/new',
    path: '/settings/member_tags/new',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersActivity_logsRoute =
  ProtectedSettingsLayoutSettingsMembersActivity_logsRouteImport.update({
    id: '/settings/members/activity_logs',
    path: '/settings/members/activity_logs',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute =
  ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRouteImport.update({
    id: '/settings/members/bulk_import_tasks',
    path: '/settings/members/bulk_import_tasks',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteRouteRoute =
  ProtectedSettingsLayoutSettingsMembersInviteRouteRouteImport.update({
    id: '/settings/members/invite',
    path: '/settings/members/invite',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute =
  ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteImport.update({
    id: '/settings/members/onboarding',
    path: '/settings/members/onboarding',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsModerationIndexRoute =
  ProtectedSettingsLayoutSettingsModerationIndexRouteImport.update({
    id: '/settings/moderation/',
    path: '/settings/moderation/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsModerationEditRoute =
  ProtectedSettingsLayoutSettingsModerationEditRouteImport.update({
    id: '/settings/moderation/edit',
    path: '/settings/moderation/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterIndexRoute =
  ProtectedSettingsLayoutSettingsNewsletterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterActivateRoute =
  ProtectedSettingsLayoutSettingsNewsletterActivateRouteImport.update({
    id: '/activate',
    path: '/activate',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsOnboardingIndexRoute =
  ProtectedSettingsLayoutSettingsOnboardingIndexRouteImport.update({
    id: '/settings/onboarding/',
    path: '/settings/onboarding/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesIndexRoute =
  ProtectedSettingsLayoutSettingsPagesIndexRouteImport.update({
    id: '/settings/pages/',
    path: '/settings/pages/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsIndexRoute =
  ProtectedSettingsLayoutSettingsPaywallsIndexRouteImport.update({
    id: '/settings/paywalls/',
    path: '/settings/paywalls/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute =
  ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteImport.update({
    id: '/settings/paywalls/new',
    path: '/settings/paywalls/new',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute =
  ProtectedSettingsLayoutSettingsPaywallsOnboardingRouteImport.update({
    id: '/settings/paywalls/onboarding',
    path: '/settings/paywalls/onboarding',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlansIndexRoute =
  ProtectedSettingsLayoutSettingsPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsPlansRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusIndexRoute =
  ProtectedSettingsLayoutSettingsPlusIndexRouteImport.update({
    id: '/settings/plus/',
    path: '/settings/plus/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusAppSettingsRoute =
  ProtectedSettingsLayoutSettingsPlusAppSettingsRouteImport.update({
    id: '/settings/plus/app-settings',
    path: '/settings/plus/app-settings',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusInsightsRoute =
  ProtectedSettingsLayoutSettingsPlusInsightsRouteImport.update({
    id: '/settings/plus/insights',
    path: '/settings/plus/insights',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusLiteRoute =
  ProtectedSettingsLayoutSettingsPlusLiteRouteImport.update({
    id: '/settings/plus/lite',
    path: '/settings/plus/lite',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteImport.update({
    id: '/settings/plus/push-notifications',
    path: '/settings/plus/push-notifications',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPostsIndexRoute =
  ProtectedSettingsLayoutSettingsPostsIndexRouteImport.update({
    id: '/settings/posts/',
    path: '/settings/posts/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute =
  ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRouteImport.update({
    id: '/settings/posts/bulk_actions',
    path: '/settings/posts/bulk_actions',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute =
  ProtectedSettingsLayoutSettingsProfile_fieldsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute =
  ProtectedSettingsLayoutSettingsProfile_fieldsManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute =
  ProtectedSettingsLayoutSettingsProfile_fieldsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSegmentsIndexRoute =
  ProtectedSettingsLayoutSettingsSegmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsSegmentsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSegmentsIdRoute =
  ProtectedSettingsLayoutSettingsSegmentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsSegmentsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSpacesSplatRoute =
  ProtectedSettingsLayoutSettingsSpacesSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ProtectedSettingsLayoutSettingsSpacesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsSsoIndexRoute =
  ProtectedSettingsLayoutSettingsSsoIndexRouteImport.update({
    id: '/settings/sso/',
    path: '/settings/sso/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsThemeIndexRoute =
  ProtectedSettingsLayoutSettingsThemeIndexRouteImport.update({
    id: '/settings/theme/',
    path: '/settings/theme/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsTopicsIndexRoute =
  ProtectedSettingsLayoutSettingsTopicsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsTopicsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsTopicsNewRoute =
  ProtectedSettingsLayoutSettingsTopicsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedSettingsLayoutSettingsTopicsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute =
  ProtectedSettingsLayoutSettingsWorkflowsHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsRouteRoute,
  } as any)
const ProtectedAdminAudienceSqidIndexRoute =
  ProtectedAdminAudienceSqidIndexRouteImport.update({
    id: '/admin/audience/$sqid/',
    path: '/admin/audience/$sqid/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedAdminAudienceSqidSplatRoute =
  ProtectedAdminAudienceSqidSplatRouteImport.update({
    id: '/admin/audience/$sqid/$',
    path: '/admin/audience/$sqid/$',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedAiBotsBotIdIndexRoute =
  ProtectedAiBotsBotIdIndexRouteImport.update({
    id: '/$botId/',
    path: '/$botId/',
    getParentRoute: () => ProtectedAiBotsRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidRouteRoute =
  ProtectedSettingsAdminAudienceSqidRouteRouteImport.update({
    id: '/settings/admin/audience/$sqid',
    path: '/settings/admin/audience/$sqid',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSettingsInboxAiIndexRoute =
  ProtectedSettingsInboxAiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxAiRouteRoute,
  } as any)
const ProtectedSettingsInboxChatThreadsIdRoute =
  ProtectedSettingsInboxChatThreadsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsInboxChatThreadsRouteRoute,
  } as any)
const ProtectedSettingsInboxConnectionRequestsIndexRoute =
  ProtectedSettingsInboxConnectionRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxConnectionRequestsRouteRoute,
  } as any)
const ProtectedSettingsInboxConnectionRequestsIdRoute =
  ProtectedSettingsInboxConnectionRequestsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsInboxConnectionRequestsRouteRoute,
  } as any)
const ProtectedSettingsInboxCourseCommentsIndexRoute =
  ProtectedSettingsInboxCourseCommentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxCourseCommentsRouteRoute,
  } as any)
const ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute =
  ProtectedSettingsInboxCourseCommentsChatRoomUuidRouteImport.update({
    id: '/$chatRoomUuid',
    path: '/$chatRoomUuid',
    getParentRoute: () => ProtectedSettingsInboxCourseCommentsRouteRoute,
  } as any)
const ProtectedSettingsInboxHumanSupportIndexRoute =
  ProtectedSettingsInboxHumanSupportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxHumanSupportRouteRoute,
  } as any)
const ProtectedSettingsInboxMessagesIndexRoute =
  ProtectedSettingsInboxMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxMessagesRouteRoute,
  } as any)
const ProtectedSettingsInboxMessagesUuidRoute =
  ProtectedSettingsInboxMessagesUuidRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => ProtectedSettingsInboxMessagesRouteRoute,
  } as any)
const ProtectedSettingsInboxModerationIndexRoute =
  ProtectedSettingsInboxModerationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsInboxModerationRouteRoute,
  } as any)
const ProtectedSettingsInboxModerationIdRoute =
  ProtectedSettingsInboxModerationIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsInboxModerationRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute =
  ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRouteImport.update({
    id: '/settings/access_groups/$id/',
    path: '/settings/access_groups/$id/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute =
  ProtectedSettingsLayoutSettingsAccess_groupsIdEditRouteImport.update({
    id: '/settings/access_groups/$id/edit',
    path: '/settings/access_groups/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute =
  ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRouteImport.update({
    id: '/settings/ai-agents/agents/',
    path: '/settings/ai-agents/agents/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteImport.update(
    {
      id: '/settings/ai-agents/edit/$botPublicId',
      path: '/settings/ai-agents/edit/$botPublicId',
      getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute =
  ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRouteImport.update({
    id: '/settings/ai-agents/knowledge/',
    path: '/settings/ai-agents/knowledge/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute =
  ProtectedSettingsLayoutSettingsAiInboxConversationsIdRouteImport.update({
    id: '/settings/ai-inbox/conversations/$id',
    path: '/settings/ai-inbox/conversations/$id',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute =
  ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteImport.update({
    id: '/settings/coupons/$id/edit',
    path: '/settings/coupons/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsNewIndexRoute =
  ProtectedSettingsLayoutSettingsCouponsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsCouponsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsNewTabRoute =
  ProtectedSettingsLayoutSettingsCouponsNewTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => ProtectedSettingsLayoutSettingsCouponsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCoursesIdEditRoute =
  ProtectedSettingsLayoutSettingsCoursesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutSettingsCoursesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsFormsNewRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsSettingsIndexRouteImport.update({
    id: '/settings/emails/settings/',
    path: '/settings/emails/settings/',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteImport.update({
    id: '/settings/invitation_links/$id/edit',
    path: '/settings/invitation_links/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRouteImport.update({
    id: '/paywalls',
    path: '/paywalls',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRouteImport.update(
    {
      id: '/subscription',
      path: '/subscription',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute =
  ProtectedSettingsLayoutSettingsMember_tagsIdEditRouteImport.update({
    id: '/settings/member_tags/$id/edit',
    path: '/settings/member_tags/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteIndexRoute =
  ProtectedSettingsLayoutSettingsMembersInviteIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteAccessRoute =
  ProtectedSettingsLayoutSettingsMembersInviteAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute =
  ProtectedSettingsLayoutSettingsMembersInviteDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute =
  ProtectedSettingsLayoutSettingsMembersInviteEmailsRouteImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute =
  ProtectedSettingsLayoutSettingsMembersInviteNewslettersRouteImport.update({
    id: '/newsletters',
    path: '/newsletters',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute =
  ProtectedSettingsLayoutSettingsMembersInvitePaywallsRouteImport.update({
    id: '/paywalls',
    path: '/paywalls',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute =
  ProtectedSettingsLayoutSettingsMembersInvitePermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersInviteRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute =
  ProtectedSettingsLayoutSettingsMembersOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute =
  ProtectedSettingsLayoutSettingsMembersOnboardingTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute =
  ProtectedSettingsLayoutSettingsNewsletterListsIndexRouteImport.update({
    id: '/lists/',
    path: '/lists/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIndexRouteImport.update({
    id: '/posts/',
    path: '/posts/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteImport.update({
    id: '/posts/$id',
    path: '/posts/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteImport.update({
    id: '/settings/pages/edit/$id',
    path: '/settings/pages/edit/$id',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute =
  ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteImport.update({
    id: '/settings/paywalls/$id/edit',
    path: '/settings/paywalls/$id/edit',
    getParentRoute: () => ProtectedSettingsLayoutRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route =
  ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125RouteImport.update(
    {
      id: '/{-$tab}',
      path: '/{-$tab}',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteImport.update(
    {
      id: '/$id',
      path: '/$id',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute =
  ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute =
  ProtectedSettingsLayoutSettingsTopicsTopicIdEditRouteImport.update({
    id: '/$topicId/edit',
    path: '/$topicId/edit',
    getParentRoute: () => ProtectedSettingsLayoutSettingsTopicsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRouteImport.update({
    id: '/select_type',
    path: '/select_type',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteImport.update({
    id: '/view/$id',
    path: '/view/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsRouteRoute,
  } as any)
const ProtectedAiBotsBotIdConversationsConversationIdRoute =
  ProtectedAiBotsBotIdConversationsConversationIdRouteImport.update({
    id: '/$botId/conversations/$conversationId',
    path: '/$botId/conversations/$conversationId',
    getParentRoute: () => ProtectedAiBotsRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidIndexRoute =
  ProtectedSettingsAdminAudienceSqidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidSplatRoute =
  ProtectedSettingsAdminAudienceSqidSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidAccessRoute =
  ProtectedSettingsAdminAudienceSqidAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidActivity_logsRoute =
  ProtectedSettingsAdminAudienceSqidActivity_logsRouteImport.update({
    id: '/activity_logs',
    path: '/activity_logs',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidAffiliateRoute =
  ProtectedSettingsAdminAudienceSqidAffiliateRouteImport.update({
    id: '/affiliate',
    path: '/affiliate',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidGamificationRoute =
  ProtectedSettingsAdminAudienceSqidGamificationRouteImport.update({
    id: '/gamification',
    path: '/gamification',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidInfoRoute =
  ProtectedSettingsAdminAudienceSqidInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidNotesRoute =
  ProtectedSettingsAdminAudienceSqidNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsInboxAiConversationsIdRoute =
  ProtectedSettingsInboxAiConversationsIdRouteImport.update({
    id: '/conversations/$id',
    path: '/conversations/$id',
    getParentRoute: () => ProtectedSettingsInboxAiRouteRoute,
  } as any)
const ProtectedSettingsInboxHumanSupportConversationsIdRoute =
  ProtectedSettingsInboxHumanSupportConversationsIdRouteImport.update({
    id: '/conversations/$id',
    path: '/conversations/$id',
    getParentRoute: () => ProtectedSettingsInboxHumanSupportRouteRoute,
  } as any)
const ProtectedSettingsInboxMessagesBotIdRoute =
  ProtectedSettingsInboxMessagesBotIdRouteImport.update({
    id: '/bot/$id',
    path: '/bot/$id',
    getParentRoute: () => ProtectedSettingsInboxMessagesRouteRoute,
  } as any)
const ProtectedSettingsInboxPriorityKindUuidRoute =
  ProtectedSettingsInboxPriorityKindUuidRouteImport.update({
    id: '/$kind/$uuid',
    path: '/$kind/$uuid',
    getParentRoute: () => ProtectedSettingsInboxPriorityRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRouteImport.update(
    {
      id: '/audience',
      path: '/audience',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRouteImport.update(
    {
      id: '/automations',
      path: '/automations',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRouteImport.update(
    {
      id: '/behavior',
      path: '/behavior',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRouteImport.update(
    {
      id: '/customize',
      path: '/customize',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRouteImport.update(
    {
      id: '/knowledge',
      path: '/knowledge',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute =
  ProtectedSettingsLayoutSettingsCouponsIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute =
  ProtectedSettingsLayoutSettingsCouponsIdEditTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteImport.update({
    id: '/view',
    path: '/view',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRouteImport.update(
    {
      id: '/visual-builder',
      path: '/visual-builder',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute =
  ProtectedSettingsLayoutSettingsEmailsFormsIdTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRouteImport.update(
    {
      id: '/access',
      path: '/access',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRouteImport.update(
    {
      id: '/details',
      path: '/details',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRouteImport.update(
    {
      id: '/paywalls',
      path: '/paywalls',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRouteImport.update(
    {
      id: '/subscription',
      path: '/subscription',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute =
  ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRouteImport.update({
    id: '/lists/$listId/',
    path: '/lists/$listId/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsNewsletterRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route =
  ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125RouteImport.update(
    {
      id: '/{-$tab}',
      path: '/{-$tab}',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute =
  ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRouteImport.update(
    {
      id: '/checkout/customization',
      path: '/checkout/customization',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute =
  ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRouteImport.update(
    {
      id: '/upsell/customization',
      path: '/upsell/customization',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteImport.update(
    {
      id: '/view',
      path: '/view',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteImport.update({
    id: '/dynamic/$id',
    path: '/dynamic/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteImport.update({
    id: '/one_time/$id',
    path: '/one_time/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRouteImport.update({
    id: '/preview/$id',
    path: '/preview/$id',
    getParentRoute: () => ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteImport.update(
    {
      id: '/scheduled/$id',
      path: '/scheduled/$id',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute =
  ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute,
  } as any)
const ProtectedSettingsAdminAudienceSqidBillingIndexRoute =
  ProtectedSettingsAdminAudienceSqidBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedSettingsCoursesIdLessonsLessonIdEditRoute =
  ProtectedSettingsCoursesIdLessonsLessonIdEditRouteImport.update({
    id: '/settings/courses/$id/lessons/$lessonId/edit',
    path: '/settings/courses/$id/lessons/$lessonId/edit',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRouteImport.update(
    {
      id: '/analytics',
      path: '/analytics',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRouteImport.update(
    {
      id: '/code_snippets',
      path: '/code_snippets',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRouteImport.update({
    id: '/defaults',
    path: '/defaults',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRouteImport.update(
    {
      id: '/navigation',
      path: '/navigation',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRouteImport.update(
    {
      id: '/redirects',
      path: '/redirects',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRouteImport.update({
    id: '/seo',
    path: '/seo',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute =
  ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRouteImport.update(
    {
      id: '/checkout/customization',
      path: '/checkout/customization',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute =
  ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRouteImport.update(
    {
      id: '/upsell/customization',
      path: '/upsell/customization',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRouteImport.update(
    {
      id: '/analytics',
      path: '/analytics',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteImport.update(
    {
      id: '/send-email/$broadcastId',
      path: '/send-email/$broadcastId',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute,
  } as any)
const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute,
    } as any,
  )
const ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute =
  ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRouteImport.update({
    id: '/billing/subscriptions/new',
    path: '/billing/subscriptions/new',
    getParentRoute: () => ProtectedSettingsAdminAudienceSqidRouteRoute,
  } as any)
const ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRouteImport.update(
    {
      id: '/sections/$sectionId/lessons/$lessonId',
      path: '/sections/$sectionId/lessons/$lessonId',
      getParentRoute: () =>
        ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRouteImport.update(
    {
      id: '/visual-builder',
      path: '/visual-builder',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteImport.update(
    {
      id: '/send-email/$broadcastId',
      path: '/send-email/$broadcastId',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteImport.update(
    {
      id: '/send-email/$broadcastId',
      path: '/send-email/$broadcastId',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteImport.update(
    {
      id: '/send-email/$broadcastId',
      path: '/send-email/$broadcastId',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute,
    } as any,
  )
const ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute =
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRouteImport.update(
    {
      id: '/edit-lesson/sections/$sectionId/lessons/$lessonId',
      path: '/edit-lesson/sections/$sectionId/lessons/$lessonId',
      getParentRoute: () =>
        ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRouteImport.update(
    {
      id: '/visual-builder',
      path: '/visual-builder',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRouteImport.update(
    {
      id: '/visual-builder',
      path: '/visual-builder',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )
const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRouteImport.update(
    {
      id: '/visual-builder',
      path: '/visual-builder',
      getParentRoute: () =>
        ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/feed': typeof FeedRoute
  '/home': typeof HomeRoute
  '/account': typeof ProtectedAccountRouteRouteWithChildren
  '/ai': typeof ProtectedAiRouteRouteWithChildren
  '/members': typeof ProtectedMembersRouteRouteWithChildren
  '/messages': typeof ProtectedMessagesRouteRouteWithChildren
  '/download_app': typeof MinimalDownload_appRoute
  '/eclipse': typeof MinimalEclipseRoute
  '/two_fa': typeof MinimalTwo_faRoute
  '/bookmarks': typeof ProtectedBookmarksRoute
  '/connections': typeof ProtectedConnectionsRoute
  '/discover': typeof ProtectedDiscoverRoute
  '/leaderboard': typeof ProtectedLeaderboardRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/threads': typeof ProtectedThreadsRoute
  '/feed/welcome': typeof FeedWelcomeRoute
  '/marketing_emails/marketing_email_preference': typeof Marketing_emailsMarketing_email_preferenceRoute
  '/marketing_emails/unsubscribe': typeof Marketing_emailsUnsubscribeRoute
  '/public/unsubscribe': typeof PublicUnsubscribeRoute
  '/live/$roomSlug': typeof MinimalLiveRoomSlugRouteRouteWithChildren
  '/ai/bots': typeof ProtectedAiBotsRouteRouteWithChildren
  '/ai/briefs': typeof ProtectedAiBriefsRouteRouteWithChildren
  '/ai/daily-briefs': typeof ProtectedAiDailyBriefsRouteRouteWithChildren
  '/ai/projects': typeof ProtectedAiProjectsRouteRouteWithChildren
  '/settings/inbox': typeof ProtectedSettingsInboxRouteRouteWithChildren
  '/settings/cancel-plan': typeof MinimalSettingsCancelPlanRoute
  '/admin-settings': typeof ProtectedDynamicLayoutAdminSettingsRoute
  '/courses': typeof ProtectedDynamicLayoutCoursesRoute
  '/events': typeof ProtectedDynamicLayoutEventsRoute
  '/search': typeof ProtectedDynamicLayoutSearchRoute
  '/spaces': typeof ProtectedDynamicLayoutSpacesRoute
  '/account/affiliate': typeof ProtectedAccountAffiliateRoute
  '/account/billing': typeof ProtectedAccountBillingRoute
  '/account/partner_program': typeof ProtectedAccountPartner_programRoute
  '/ai/$conversationId': typeof ProtectedAiConversationIdRoute
  '/ai/skills': typeof ProtectedAiSkillsRoute
  '/getting-started/ai': typeof ProtectedGettingStartedAiRoute
  '/members/$': typeof ProtectedMembersSplatRoute
  '/members/connections': typeof ProtectedMembersConnectionsRoute
  '/members/manage': typeof ProtectedMembersManageRoute
  '/members/map': typeof ProtectedMembersMapRoute
  '/messages/$uuid': typeof ProtectedMessagesUuidRoute
  '/newsletter/posts/$slug': typeof NewsletterPostsSlugRoute
  '/questions-ai/': typeof MinimalQuestionsAiIndexRoute
  '/ai/': typeof ProtectedAiIndexRoute
  '/getting-started/': typeof ProtectedGettingStartedIndexRoute
  '/members/': typeof ProtectedMembersIndexRoute
  '/messages/': typeof ProtectedMessagesIndexRoute
  '/c/$spaceSlug': typeof ProtectedDynamicLayoutCSpaceSlugRouteRouteWithChildren
  '/s/$spaceGroupSlug': typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteWithChildren
  '/c/$embedSpaceSlug': typeof ProtectedEmbedCEmbedSpaceSlugRouteRouteWithChildren
  '/settings': typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteWithChildren
  '/settings/analytics': typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRouteWithChildren
  '/settings/api': typeof ProtectedSettingsLayoutSettingsApiRouteRouteWithChildren
  '/settings/courses': typeof ProtectedSettingsLayoutSettingsCoursesRouteRouteWithChildren
  '/settings/developers': typeof ProtectedSettingsLayoutSettingsDevelopersRouteRoute
  '/settings/files': typeof ProtectedSettingsLayoutSettingsFilesRouteRoute
  '/settings/live_streams': typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRouteWithChildren
  '/settings/newsletter': typeof ProtectedSettingsLayoutSettingsNewsletterRouteRouteWithChildren
  '/settings/plans': typeof ProtectedSettingsLayoutSettingsPlansRouteRouteWithChildren
  '/settings/profile_fields': typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteWithChildren
  '/settings/segments': typeof ProtectedSettingsLayoutSettingsSegmentsRouteRouteWithChildren
  '/settings/spaces': typeof ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren
  '/settings/topics': typeof ProtectedSettingsLayoutSettingsTopicsRouteRouteWithChildren
  '/settings/workflows': typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRouteWithChildren
  '/settings/inbox/ai': typeof ProtectedSettingsInboxAiRouteRouteWithChildren
  '/settings/inbox/chat-threads': typeof ProtectedSettingsInboxChatThreadsRouteRouteWithChildren
  '/settings/inbox/connection-requests': typeof ProtectedSettingsInboxConnectionRequestsRouteRouteWithChildren
  '/settings/inbox/course-comments': typeof ProtectedSettingsInboxCourseCommentsRouteRouteWithChildren
  '/settings/inbox/human-support': typeof ProtectedSettingsInboxHumanSupportRouteRouteWithChildren
  '/settings/inbox/messages': typeof ProtectedSettingsInboxMessagesRouteRouteWithChildren
  '/settings/inbox/moderation': typeof ProtectedSettingsInboxModerationRouteRouteWithChildren
  '/settings/inbox/notifications': typeof ProtectedSettingsInboxNotificationsRouteRoute
  '/settings/inbox/priority': typeof ProtectedSettingsInboxPriorityRouteRouteWithChildren
  '/custom_logins/debug_sessions/$uuid': typeof MinimalCustom_loginsDebug_sessionsUuidRoute
  '/live/$roomSlug/public': typeof MinimalLiveRoomSlugPublicRoute
  '/live/$roomSlug/record': typeof MinimalLiveRoomSlugRecordRoute
  '/u/$publicUid': typeof ProtectedDynamicLayoutUPublicUidRoute
  '/audience/manage': typeof ProtectedSettingsLayoutAudienceManageRoute
  '/contacts/import': typeof ProtectedSettingsLayoutContactsImportRoute
  '/settings/branded_apps': typeof ProtectedSettingsLayoutSettingsBranded_appsRoute
  '/settings/branded_apps_builder_landing_page': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute
  '/settings/branded_apps_builder_ui': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute
  '/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsCode_snippetsRoute
  '/settings/community_ai': typeof ProtectedSettingsLayoutSettingsCommunity_aiRoute
  '/settings/connect': typeof ProtectedSettingsLayoutSettingsConnectRoute
  '/settings/conversion_tracking': typeof ProtectedSettingsLayoutSettingsConversion_trackingRoute
  '/settings/custom_domain': typeof ProtectedSettingsLayoutSettingsCustom_domainRoute
  '/settings/dashboard': typeof ProtectedSettingsLayoutSettingsDashboardRoute
  '/settings/discover': typeof ProtectedSettingsLayoutSettingsDiscoverRoute
  '/settings/embed': typeof ProtectedSettingsLayoutSettingsEmbedRoute
  '/settings/gamification': typeof ProtectedSettingsLayoutSettingsGamificationRoute
  '/settings/general': typeof ProtectedSettingsLayoutSettingsGeneralRoute
  '/settings/home': typeof ProtectedSettingsLayoutSettingsHomeRoute
  '/settings/legal': typeof ProtectedSettingsLayoutSettingsLegalRoute
  '/settings/mobile_app': typeof ProtectedSettingsLayoutSettingsMobile_appRoute
  '/settings/navigation': typeof ProtectedSettingsLayoutSettingsNavigationRoute
  '/settings/paywall_bulk_logs': typeof ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute
  '/settings/paywall_charges': typeof ProtectedSettingsLayoutSettingsPaywall_chargesRoute
  '/settings/paywall_groups': typeof ProtectedSettingsLayoutSettingsPaywall_groupsRoute
  '/settings/paywall_payment_settings': typeof ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute
  '/settings/paywall_subscriptions': typeof ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute
  '/settings/paywall_tax_settings': typeof ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute
  '/settings/recap-2025': typeof ProtectedSettingsLayoutSettingsRecap2025Route
  '/settings/redirects': typeof ProtectedSettingsLayoutSettingsRedirectsRoute
  '/settings/seo': typeof ProtectedSettingsLayoutSettingsSeoRoute
  '/settings/weekly_digest': typeof ProtectedSettingsLayoutSettingsWeekly_digestRoute
  '/account/authentication': typeof ProtectedAccountTabBodyAuthenticationRoute
  '/account/notifications': typeof ProtectedAccountTabBodyNotificationsRoute
  '/account/privacy': typeof ProtectedAccountTabBodyPrivacyRoute
  '/ai/bots/history': typeof ProtectedAiBotsHistoryRoute
  '/ai/daily-briefs/$dailyBriefId': typeof ProtectedAiDailyBriefsDailyBriefIdRoute
  '/ai/projects/$projectId': typeof ProtectedAiProjectsProjectIdRoute
  '/messages/bot/$id': typeof ProtectedMessagesBotIdRoute
  '/settings/': typeof ProtectedSettingsLayoutSettingsIndexRoute
  '/account/': typeof ProtectedAccountTabBodyIndexRoute
  '/ai/bots/': typeof ProtectedAiBotsIndexRoute
  '/ai/briefs/': typeof ProtectedAiBriefsIndexRoute
  '/ai/projects/': typeof ProtectedAiProjectsIndexRoute
  '/settings/inbox/': typeof ProtectedSettingsInboxIndexRoute
  '/settings/analytics/ai_agents': typeof ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute
  '/settings/analytics/courses': typeof ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute
  '/settings/analytics/devices': typeof ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute
  '/settings/analytics/events': typeof ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute
  '/settings/analytics/members': typeof ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute
  '/settings/analytics/messages': typeof ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute
  '/settings/analytics/payments': typeof ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute
  '/settings/analytics/post_comments': typeof ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute
  '/settings/analytics/reviews': typeof ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute
  '/settings/analytics/spaces': typeof ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute
  '/settings/analytics/videos': typeof ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute
  '/settings/analytics/website': typeof ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute
  '/settings/api/new': typeof ProtectedSettingsLayoutSettingsApiNewRouteRoute
  '/settings/coupons/new': typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRouteWithChildren
  '/settings/emails/broadcast': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteWithChildren
  '/settings/emails/forms': typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteWithChildren
  '/settings/emails/templates': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteWithChildren
  '/settings/invitation_links/new': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteWithChildren
  '/settings/members/invite': typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRouteWithChildren
  '/settings/members/onboarding': typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteWithChildren
  '/settings/paywalls/new': typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren
  '/settings/plus/push-notifications': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteWithChildren
  '/settings/posts/bulk_actions': typeof ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute
  '/settings/workflows/new': typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteWithChildren
  '/settings/admin/audience/$sqid': typeof ProtectedSettingsAdminAudienceSqidRouteRouteWithChildren
  '/live/$roomSlug/mobile': typeof MinimalLiveRoomSlugProtectedMobileRoute
  '/live/$roomSlug/not_supported': typeof MinimalLiveRoomSlugProtectedNot_supportedRoute
  '/settings/members/onboarding/preview': typeof MinimalSettingsMembersOnboardingPreviewRoute
  '/c/$spaceSlug/$postSlug': typeof ProtectedDynamicLayoutCSpaceSlugPostSlugRoute
  '/s/$spaceGroupSlug/edit': typeof ProtectedDynamicLayoutSSpaceGroupSlugEditRoute
  '/c/$embedSpaceSlug/$embedPostSlug': typeof ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute
  '/members/invitation_links/$': typeof ProtectedSettingsLayoutMembersInvitation_linksSplatRoute
  '/members/invite/$': typeof ProtectedSettingsLayoutMembersInviteSplatRoute
  '/members/onboarding/$': typeof ProtectedSettingsLayoutMembersOnboardingSplatRoute
  '/members/profile_fields/$': typeof ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute
  '/settings/affiliates_commissions': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute
  '/settings/affiliates_directory': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute
  '/settings/affiliates_settings': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute
  '/settings/billing': typeof ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute
  '/settings/invoices': typeof ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute
  '/settings/payment_details': typeof ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute
  '/settings/audience/connect': typeof ProtectedSettingsLayoutSettingsAudienceConnectRoute
  '/settings/audience/manage': typeof ProtectedSettingsLayoutSettingsAudienceManageRoute
  '/settings/contacts/import': typeof ProtectedSettingsLayoutSettingsContactsImportRoute
  '/settings/courses/overview': typeof ProtectedSettingsLayoutSettingsCoursesOverviewRoute
  '/settings/live_streams/$id': typeof ProtectedSettingsLayoutSettingsLive_streamsIdRoute
  '/settings/member_tags/new': typeof ProtectedSettingsLayoutSettingsMember_tagsNewRoute
  '/settings/members/activity_logs': typeof ProtectedSettingsLayoutSettingsMembersActivity_logsRoute
  '/settings/members/bulk_import_tasks': typeof ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute
  '/settings/moderation/edit': typeof ProtectedSettingsLayoutSettingsModerationEditRoute
  '/settings/newsletter/activate': typeof ProtectedSettingsLayoutSettingsNewsletterActivateRoute
  '/settings/paywalls/onboarding': typeof ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute
  '/settings/plus/app-settings': typeof ProtectedSettingsLayoutSettingsPlusAppSettingsRoute
  '/settings/plus/insights': typeof ProtectedSettingsLayoutSettingsPlusInsightsRoute
  '/settings/plus/lite': typeof ProtectedSettingsLayoutSettingsPlusLiteRoute
  '/settings/profile_fields/manage': typeof ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute
  '/settings/profile_fields/new': typeof ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute
  '/settings/segments/$id': typeof ProtectedSettingsLayoutSettingsSegmentsIdRoute
  '/settings/spaces/$': typeof ProtectedSettingsLayoutSettingsSpacesSplatRoute
  '/settings/topics/new': typeof ProtectedSettingsLayoutSettingsTopicsNewRoute
  '/settings/workflows/history': typeof ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute
  '/admin/audience/$sqid/$': typeof ProtectedAdminAudienceSqidSplatRoute
  '/settings/inbox/chat-threads/$id': typeof ProtectedSettingsInboxChatThreadsIdRoute
  '/settings/inbox/connection-requests/$id': typeof ProtectedSettingsInboxConnectionRequestsIdRoute
  '/settings/inbox/course-comments/$chatRoomUuid': typeof ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute
  '/settings/inbox/messages/$uuid': typeof ProtectedSettingsInboxMessagesUuidRoute
  '/settings/inbox/moderation/$id': typeof ProtectedSettingsInboxModerationIdRoute
  '/live/$roomSlug/': typeof MinimalLiveRoomSlugProtectedIndexRoute
  '/s/$spaceGroupSlug/': typeof ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute
  '/c/$embedSpaceSlug/': typeof ProtectedEmbedCEmbedSpaceSlugIndexRoute
  '/members/invitation_links/': typeof ProtectedSettingsLayoutMembersInvitation_linksIndexRoute
  '/members/profile_fields/': typeof ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute
  '/settings/access_groups/': typeof ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute
  '/settings/ai-inbox/': typeof ProtectedSettingsLayoutSettingsAiInboxIndexRoute
  '/settings/analytics/': typeof ProtectedSettingsLayoutSettingsAnalyticsIndexRoute
  '/settings/api/': typeof ProtectedSettingsLayoutSettingsApiIndexRoute
  '/settings/coupons/': typeof ProtectedSettingsLayoutSettingsCouponsIndexRoute
  '/settings/courses/': typeof ProtectedSettingsLayoutSettingsCoursesIndexRoute
  '/settings/emails/': typeof ProtectedSettingsLayoutSettingsEmailsIndexRoute
  '/settings/events/': typeof ProtectedSettingsLayoutSettingsEventsIndexRoute
  '/settings/integrations/': typeof ProtectedSettingsLayoutSettingsIntegrationsIndexRoute
  '/settings/invitation_links/': typeof ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute
  '/settings/live_streams/': typeof ProtectedSettingsLayoutSettingsLive_streamsIndexRoute
  '/settings/member_tags/': typeof ProtectedSettingsLayoutSettingsMember_tagsIndexRoute
  '/settings/moderation/': typeof ProtectedSettingsLayoutSettingsModerationIndexRoute
  '/settings/newsletter/': typeof ProtectedSettingsLayoutSettingsNewsletterIndexRoute
  '/settings/onboarding/': typeof ProtectedSettingsLayoutSettingsOnboardingIndexRoute
  '/settings/pages/': typeof ProtectedSettingsLayoutSettingsPagesIndexRoute
  '/settings/paywalls/': typeof ProtectedSettingsLayoutSettingsPaywallsIndexRoute
  '/settings/plans/': typeof ProtectedSettingsLayoutSettingsPlansIndexRoute
  '/settings/plus/': typeof ProtectedSettingsLayoutSettingsPlusIndexRoute
  '/settings/posts/': typeof ProtectedSettingsLayoutSettingsPostsIndexRoute
  '/settings/profile_fields/': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute
  '/settings/segments/': typeof ProtectedSettingsLayoutSettingsSegmentsIndexRoute
  '/settings/sso/': typeof ProtectedSettingsLayoutSettingsSsoIndexRoute
  '/settings/theme/': typeof ProtectedSettingsLayoutSettingsThemeIndexRoute
  '/settings/topics/': typeof ProtectedSettingsLayoutSettingsTopicsIndexRoute
  '/settings/workflows/': typeof ProtectedSettingsLayoutSettingsWorkflowsIndexRoute
  '/admin/audience/$sqid/': typeof ProtectedAdminAudienceSqidIndexRoute
  '/ai/bots/$botId/': typeof ProtectedAiBotsBotIdIndexRoute
  '/settings/inbox/ai/': typeof ProtectedSettingsInboxAiIndexRoute
  '/settings/inbox/connection-requests/': typeof ProtectedSettingsInboxConnectionRequestsIndexRoute
  '/settings/inbox/course-comments/': typeof ProtectedSettingsInboxCourseCommentsIndexRoute
  '/settings/inbox/human-support/': typeof ProtectedSettingsInboxHumanSupportIndexRoute
  '/settings/inbox/messages/': typeof ProtectedSettingsInboxMessagesIndexRoute
  '/settings/inbox/moderation/': typeof ProtectedSettingsInboxModerationIndexRoute
  '/settings/ai-agents/edit/$botPublicId': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren
  '/settings/coupons/$id/edit': typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteWithChildren
  '/settings/emails/broadcast/$id': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteWithChildren
  '/settings/emails/forms/$id': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteWithChildren
  '/settings/emails/templates/$id': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute
  '/settings/invitation_links/$id/edit': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteWithChildren
  '/settings/newsletter/posts/$id': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteWithChildren
  '/settings/pages/edit/$id': typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteWithChildren
  '/settings/paywalls/$id/edit': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren
  '/settings/plus/push-notifications/$id': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren
  '/settings/workflows/edit/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteWithChildren
  '/settings/workflows/view/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteWithChildren
  '/c/$spaceSlug/invite': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute
  '/settings/access_groups/$id/edit': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute
  '/settings/ai-inbox/conversations/$id': typeof ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute
  '/settings/coupons/new/$tab': typeof ProtectedSettingsLayoutSettingsCouponsNewTabRoute
  '/settings/courses/$id/edit': typeof ProtectedSettingsLayoutSettingsCoursesIdEditRoute
  '/settings/emails/forms/new': typeof ProtectedSettingsLayoutSettingsEmailsFormsNewRoute
  '/settings/invitation_links/new/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute
  '/settings/invitation_links/new/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute
  '/settings/invitation_links/new/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute
  '/settings/invitation_links/new/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute
  '/settings/member_tags/$id/edit': typeof ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute
  '/settings/members/invite/access': typeof ProtectedSettingsLayoutSettingsMembersInviteAccessRoute
  '/settings/members/invite/details': typeof ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute
  '/settings/members/invite/emails': typeof ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute
  '/settings/members/invite/newsletters': typeof ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute
  '/settings/members/invite/paywalls': typeof ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute
  '/settings/members/invite/permissions': typeof ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute
  '/settings/members/onboarding/$tab': typeof ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute
  '/settings/paywalls/new/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route
  '/settings/profile_fields/$id/edit': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute
  '/settings/topics/$topicId/edit': typeof ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute
  '/settings/workflows/new/select_type': typeof ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute
  '/ai/bots/$botId/conversations/$conversationId': typeof ProtectedAiBotsBotIdConversationsConversationIdRoute
  '/settings/admin/audience/$sqid/$': typeof ProtectedSettingsAdminAudienceSqidSplatRoute
  '/settings/admin/audience/$sqid/access': typeof ProtectedSettingsAdminAudienceSqidAccessRoute
  '/settings/admin/audience/$sqid/activity_logs': typeof ProtectedSettingsAdminAudienceSqidActivity_logsRoute
  '/settings/admin/audience/$sqid/affiliate': typeof ProtectedSettingsAdminAudienceSqidAffiliateRoute
  '/settings/admin/audience/$sqid/gamification': typeof ProtectedSettingsAdminAudienceSqidGamificationRoute
  '/settings/admin/audience/$sqid/info': typeof ProtectedSettingsAdminAudienceSqidInfoRoute
  '/settings/admin/audience/$sqid/notes': typeof ProtectedSettingsAdminAudienceSqidNotesRoute
  '/settings/inbox/ai/conversations/$id': typeof ProtectedSettingsInboxAiConversationsIdRoute
  '/settings/inbox/human-support/conversations/$id': typeof ProtectedSettingsInboxHumanSupportConversationsIdRoute
  '/settings/inbox/messages/bot/$id': typeof ProtectedSettingsInboxMessagesBotIdRoute
  '/settings/inbox/priority/$kind/$uuid': typeof ProtectedSettingsInboxPriorityKindUuidRoute
  '/c/$spaceSlug/': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute
  '/settings/access_groups/$id/': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute
  '/settings/ai-agents/agents/': typeof ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute
  '/settings/ai-agents/knowledge/': typeof ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute
  '/settings/coupons/new/': typeof ProtectedSettingsLayoutSettingsCouponsNewIndexRoute
  '/settings/emails/broadcast/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute
  '/settings/emails/forms/': typeof ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute
  '/settings/emails/settings/': typeof ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute
  '/settings/emails/templates/': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute
  '/settings/invitation_links/new/': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute
  '/settings/members/invite/': typeof ProtectedSettingsLayoutSettingsMembersInviteIndexRoute
  '/settings/members/onboarding/': typeof ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute
  '/settings/newsletter/lists/': typeof ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute
  '/settings/newsletter/posts/': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute
  '/settings/plus/push-notifications/': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute
  '/settings/workflows/new/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute
  '/settings/admin/audience/$sqid/': typeof ProtectedSettingsAdminAudienceSqidIndexRoute
  '/settings/emails/broadcast/$id/view': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteWithChildren
  '/settings/pages/edit/$id/settings': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteWithChildren
  '/settings/plus/push-notifications/$id/view': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteWithChildren
  '/settings/workflows/new/dynamic/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteWithChildren
  '/settings/workflows/new/one_time/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteWithChildren
  '/settings/workflows/new/scheduled/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteWithChildren
  '/settings/ai-agents/edit/$botPublicId/audience': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute
  '/settings/ai-agents/edit/$botPublicId/automations': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute
  '/settings/ai-agents/edit/$botPublicId/behavior': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute
  '/settings/ai-agents/edit/$botPublicId/customize': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute
  '/settings/ai-agents/edit/$botPublicId/knowledge': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute
  '/settings/coupons/$id/edit/$tab': typeof ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute
  '/settings/emails/broadcast/$id/content': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute
  '/settings/emails/broadcast/$id/edit': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute
  '/settings/emails/broadcast/$id/visual-builder': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute
  '/settings/emails/forms/$id/$tab': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute
  '/settings/invitation_links/$id/edit/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute
  '/settings/invitation_links/$id/edit/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute
  '/settings/invitation_links/$id/edit/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute
  '/settings/invitation_links/$id/edit/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute
  '/settings/newsletter/posts/$id/content': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute
  '/settings/newsletter/posts/$id/overview': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute
  '/settings/newsletter/posts/$id/settings': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute
  '/settings/paywalls/$id/edit/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route
  '/settings/paywalls/new/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute
  '/settings/paywalls/new/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute
  '/settings/plus/push-notifications/$id/edit': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute
  '/settings/workflows/new/preview/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute
  '/settings/workflows/view/$id/runs': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute
  '/settings/courses/$id/lessons/$lessonId/edit': typeof ProtectedSettingsCoursesIdLessonsLessonIdEditRoute
  '/settings/coupons/$id/edit/': typeof ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute
  '/settings/emails/broadcast/$id/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute
  '/settings/emails/forms/$id/': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute
  '/settings/invitation_links/$id/edit/': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute
  '/settings/newsletter/lists/$listId/': typeof ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute
  '/settings/newsletter/posts/$id/': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute
  '/settings/pages/edit/$id/': typeof ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute
  '/settings/workflows/edit/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute
  '/settings/workflows/view/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute
  '/settings/admin/audience/$sqid/billing/': typeof ProtectedSettingsAdminAudienceSqidBillingIndexRoute
  '/settings/workflows/edit/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteWithChildren
  '/settings/emails/broadcast/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute
  '/settings/pages/edit/$id/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute
  '/settings/pages/edit/$id/settings/defaults': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute
  '/settings/pages/edit/$id/settings/navigation': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute
  '/settings/pages/edit/$id/settings/redirects': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute
  '/settings/pages/edit/$id/settings/seo': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute
  '/settings/paywalls/$id/edit/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute
  '/settings/paywalls/$id/edit/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute
  '/settings/plus/push-notifications/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute
  '/settings/admin/audience/$sqid/billing/subscriptions/new': typeof ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute
  '/settings/emails/broadcast/$id/view/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute
  '/settings/pages/edit/$id/settings/': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute
  '/settings/plus/push-notifications/$id/view/': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute
  '/settings/workflows/new/dynamic/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute
  '/settings/workflows/new/one_time/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute
  '/settings/workflows/new/scheduled/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute
  '/settings/workflows/new/dynamic/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteWithChildren
  '/settings/workflows/new/one_time/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteWithChildren
  '/settings/workflows/new/scheduled/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteWithChildren
  '/c/$spaceSlug/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute
  '/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/edit/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute
  '/c/$spaceSlug/edit-lesson/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute
  '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute
  '/settings/workflows/new/one_time/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute
  '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/feed': typeof FeedRoute
  '/home': typeof HomeRoute
  '/account': typeof ProtectedAccountTabBodyIndexRoute
  '/download_app': typeof MinimalDownload_appRoute
  '/eclipse': typeof MinimalEclipseRoute
  '/two_fa': typeof MinimalTwo_faRoute
  '/bookmarks': typeof ProtectedBookmarksRoute
  '/connections': typeof ProtectedConnectionsRoute
  '/discover': typeof ProtectedDiscoverRoute
  '/leaderboard': typeof ProtectedLeaderboardRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/threads': typeof ProtectedThreadsRoute
  '/feed/welcome': typeof FeedWelcomeRoute
  '/marketing_emails/marketing_email_preference': typeof Marketing_emailsMarketing_email_preferenceRoute
  '/marketing_emails/unsubscribe': typeof Marketing_emailsUnsubscribeRoute
  '/public/unsubscribe': typeof PublicUnsubscribeRoute
  '/live/$roomSlug': typeof MinimalLiveRoomSlugProtectedIndexRoute
  '/ai/daily-briefs': typeof ProtectedAiDailyBriefsRouteRouteWithChildren
  '/settings/cancel-plan': typeof MinimalSettingsCancelPlanRoute
  '/admin-settings': typeof ProtectedDynamicLayoutAdminSettingsRoute
  '/courses': typeof ProtectedDynamicLayoutCoursesRoute
  '/events': typeof ProtectedDynamicLayoutEventsRoute
  '/search': typeof ProtectedDynamicLayoutSearchRoute
  '/spaces': typeof ProtectedDynamicLayoutSpacesRoute
  '/account/affiliate': typeof ProtectedAccountAffiliateRoute
  '/account/billing': typeof ProtectedAccountBillingRoute
  '/account/partner_program': typeof ProtectedAccountPartner_programRoute
  '/ai/$conversationId': typeof ProtectedAiConversationIdRoute
  '/ai/skills': typeof ProtectedAiSkillsRoute
  '/getting-started/ai': typeof ProtectedGettingStartedAiRoute
  '/members/$': typeof ProtectedMembersSplatRoute
  '/members/connections': typeof ProtectedMembersConnectionsRoute
  '/members/manage': typeof ProtectedMembersManageRoute
  '/members/map': typeof ProtectedMembersMapRoute
  '/messages/$uuid': typeof ProtectedMessagesUuidRoute
  '/newsletter/posts/$slug': typeof NewsletterPostsSlugRoute
  '/questions-ai': typeof MinimalQuestionsAiIndexRoute
  '/ai': typeof ProtectedAiIndexRoute
  '/getting-started': typeof ProtectedGettingStartedIndexRoute
  '/members': typeof ProtectedMembersIndexRoute
  '/messages': typeof ProtectedMessagesIndexRoute
  '/c/$spaceSlug': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute
  '/settings': typeof ProtectedSettingsLayoutSettingsIndexRoute
  '/settings/developers': typeof ProtectedSettingsLayoutSettingsDevelopersRouteRoute
  '/settings/files': typeof ProtectedSettingsLayoutSettingsFilesRouteRoute
  '/settings/spaces': typeof ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren
  '/settings/inbox/chat-threads': typeof ProtectedSettingsInboxChatThreadsRouteRouteWithChildren
  '/settings/inbox/notifications': typeof ProtectedSettingsInboxNotificationsRouteRoute
  '/settings/inbox/priority': typeof ProtectedSettingsInboxPriorityRouteRouteWithChildren
  '/custom_logins/debug_sessions/$uuid': typeof MinimalCustom_loginsDebug_sessionsUuidRoute
  '/live/$roomSlug/public': typeof MinimalLiveRoomSlugPublicRoute
  '/live/$roomSlug/record': typeof MinimalLiveRoomSlugRecordRoute
  '/u/$publicUid': typeof ProtectedDynamicLayoutUPublicUidRoute
  '/audience/manage': typeof ProtectedSettingsLayoutAudienceManageRoute
  '/contacts/import': typeof ProtectedSettingsLayoutContactsImportRoute
  '/settings/branded_apps': typeof ProtectedSettingsLayoutSettingsBranded_appsRoute
  '/settings/branded_apps_builder_landing_page': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute
  '/settings/branded_apps_builder_ui': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute
  '/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsCode_snippetsRoute
  '/settings/community_ai': typeof ProtectedSettingsLayoutSettingsCommunity_aiRoute
  '/settings/connect': typeof ProtectedSettingsLayoutSettingsConnectRoute
  '/settings/conversion_tracking': typeof ProtectedSettingsLayoutSettingsConversion_trackingRoute
  '/settings/custom_domain': typeof ProtectedSettingsLayoutSettingsCustom_domainRoute
  '/settings/dashboard': typeof ProtectedSettingsLayoutSettingsDashboardRoute
  '/settings/discover': typeof ProtectedSettingsLayoutSettingsDiscoverRoute
  '/settings/embed': typeof ProtectedSettingsLayoutSettingsEmbedRoute
  '/settings/gamification': typeof ProtectedSettingsLayoutSettingsGamificationRoute
  '/settings/general': typeof ProtectedSettingsLayoutSettingsGeneralRoute
  '/settings/home': typeof ProtectedSettingsLayoutSettingsHomeRoute
  '/settings/legal': typeof ProtectedSettingsLayoutSettingsLegalRoute
  '/settings/mobile_app': typeof ProtectedSettingsLayoutSettingsMobile_appRoute
  '/settings/navigation': typeof ProtectedSettingsLayoutSettingsNavigationRoute
  '/settings/paywall_bulk_logs': typeof ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute
  '/settings/paywall_charges': typeof ProtectedSettingsLayoutSettingsPaywall_chargesRoute
  '/settings/paywall_groups': typeof ProtectedSettingsLayoutSettingsPaywall_groupsRoute
  '/settings/paywall_payment_settings': typeof ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute
  '/settings/paywall_subscriptions': typeof ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute
  '/settings/paywall_tax_settings': typeof ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute
  '/settings/recap-2025': typeof ProtectedSettingsLayoutSettingsRecap2025Route
  '/settings/redirects': typeof ProtectedSettingsLayoutSettingsRedirectsRoute
  '/settings/seo': typeof ProtectedSettingsLayoutSettingsSeoRoute
  '/settings/weekly_digest': typeof ProtectedSettingsLayoutSettingsWeekly_digestRoute
  '/account/authentication': typeof ProtectedAccountTabBodyAuthenticationRoute
  '/account/notifications': typeof ProtectedAccountTabBodyNotificationsRoute
  '/account/privacy': typeof ProtectedAccountTabBodyPrivacyRoute
  '/ai/bots/history': typeof ProtectedAiBotsHistoryRoute
  '/ai/daily-briefs/$dailyBriefId': typeof ProtectedAiDailyBriefsDailyBriefIdRoute
  '/ai/projects/$projectId': typeof ProtectedAiProjectsProjectIdRoute
  '/messages/bot/$id': typeof ProtectedMessagesBotIdRoute
  '/ai/bots': typeof ProtectedAiBotsIndexRoute
  '/ai/briefs': typeof ProtectedAiBriefsIndexRoute
  '/ai/projects': typeof ProtectedAiProjectsIndexRoute
  '/settings/inbox': typeof ProtectedSettingsInboxIndexRoute
  '/settings/analytics/ai_agents': typeof ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute
  '/settings/analytics/courses': typeof ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute
  '/settings/analytics/devices': typeof ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute
  '/settings/analytics/events': typeof ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute
  '/settings/analytics/members': typeof ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute
  '/settings/analytics/messages': typeof ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute
  '/settings/analytics/payments': typeof ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute
  '/settings/analytics/post_comments': typeof ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute
  '/settings/analytics/reviews': typeof ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute
  '/settings/analytics/spaces': typeof ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute
  '/settings/analytics/videos': typeof ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute
  '/settings/analytics/website': typeof ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute
  '/settings/api/new': typeof ProtectedSettingsLayoutSettingsApiNewRouteRoute
  '/settings/paywalls/new': typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren
  '/settings/posts/bulk_actions': typeof ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute
  '/live/$roomSlug/mobile': typeof MinimalLiveRoomSlugProtectedMobileRoute
  '/live/$roomSlug/not_supported': typeof MinimalLiveRoomSlugProtectedNot_supportedRoute
  '/settings/members/onboarding/preview': typeof MinimalSettingsMembersOnboardingPreviewRoute
  '/c/$spaceSlug/$postSlug': typeof ProtectedDynamicLayoutCSpaceSlugPostSlugRoute
  '/s/$spaceGroupSlug/edit': typeof ProtectedDynamicLayoutSSpaceGroupSlugEditRoute
  '/c/$embedSpaceSlug/$embedPostSlug': typeof ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute
  '/members/invitation_links/$': typeof ProtectedSettingsLayoutMembersInvitation_linksSplatRoute
  '/members/invite/$': typeof ProtectedSettingsLayoutMembersInviteSplatRoute
  '/members/onboarding/$': typeof ProtectedSettingsLayoutMembersOnboardingSplatRoute
  '/members/profile_fields/$': typeof ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute
  '/settings/affiliates_commissions': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute
  '/settings/affiliates_directory': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute
  '/settings/affiliates_settings': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute
  '/settings/billing': typeof ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute
  '/settings/invoices': typeof ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute
  '/settings/payment_details': typeof ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute
  '/settings/audience/connect': typeof ProtectedSettingsLayoutSettingsAudienceConnectRoute
  '/settings/audience/manage': typeof ProtectedSettingsLayoutSettingsAudienceManageRoute
  '/settings/contacts/import': typeof ProtectedSettingsLayoutSettingsContactsImportRoute
  '/settings/courses/overview': typeof ProtectedSettingsLayoutSettingsCoursesOverviewRoute
  '/settings/live_streams/$id': typeof ProtectedSettingsLayoutSettingsLive_streamsIdRoute
  '/settings/member_tags/new': typeof ProtectedSettingsLayoutSettingsMember_tagsNewRoute
  '/settings/members/activity_logs': typeof ProtectedSettingsLayoutSettingsMembersActivity_logsRoute
  '/settings/members/bulk_import_tasks': typeof ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute
  '/settings/moderation/edit': typeof ProtectedSettingsLayoutSettingsModerationEditRoute
  '/settings/newsletter/activate': typeof ProtectedSettingsLayoutSettingsNewsletterActivateRoute
  '/settings/paywalls/onboarding': typeof ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute
  '/settings/plus/app-settings': typeof ProtectedSettingsLayoutSettingsPlusAppSettingsRoute
  '/settings/plus/insights': typeof ProtectedSettingsLayoutSettingsPlusInsightsRoute
  '/settings/plus/lite': typeof ProtectedSettingsLayoutSettingsPlusLiteRoute
  '/settings/profile_fields/manage': typeof ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute
  '/settings/profile_fields/new': typeof ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute
  '/settings/segments/$id': typeof ProtectedSettingsLayoutSettingsSegmentsIdRoute
  '/settings/spaces/$': typeof ProtectedSettingsLayoutSettingsSpacesSplatRoute
  '/settings/topics/new': typeof ProtectedSettingsLayoutSettingsTopicsNewRoute
  '/settings/workflows/history': typeof ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute
  '/admin/audience/$sqid/$': typeof ProtectedAdminAudienceSqidSplatRoute
  '/settings/inbox/chat-threads/$id': typeof ProtectedSettingsInboxChatThreadsIdRoute
  '/settings/inbox/connection-requests/$id': typeof ProtectedSettingsInboxConnectionRequestsIdRoute
  '/settings/inbox/course-comments/$chatRoomUuid': typeof ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute
  '/settings/inbox/messages/$uuid': typeof ProtectedSettingsInboxMessagesUuidRoute
  '/settings/inbox/moderation/$id': typeof ProtectedSettingsInboxModerationIdRoute
  '/s/$spaceGroupSlug': typeof ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute
  '/c/$embedSpaceSlug': typeof ProtectedEmbedCEmbedSpaceSlugIndexRoute
  '/members/invitation_links': typeof ProtectedSettingsLayoutMembersInvitation_linksIndexRoute
  '/members/profile_fields': typeof ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute
  '/settings/access_groups': typeof ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute
  '/settings/ai-inbox': typeof ProtectedSettingsLayoutSettingsAiInboxIndexRoute
  '/settings/analytics': typeof ProtectedSettingsLayoutSettingsAnalyticsIndexRoute
  '/settings/api': typeof ProtectedSettingsLayoutSettingsApiIndexRoute
  '/settings/coupons': typeof ProtectedSettingsLayoutSettingsCouponsIndexRoute
  '/settings/courses': typeof ProtectedSettingsLayoutSettingsCoursesIndexRoute
  '/settings/emails': typeof ProtectedSettingsLayoutSettingsEmailsIndexRoute
  '/settings/events': typeof ProtectedSettingsLayoutSettingsEventsIndexRoute
  '/settings/integrations': typeof ProtectedSettingsLayoutSettingsIntegrationsIndexRoute
  '/settings/invitation_links': typeof ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute
  '/settings/live_streams': typeof ProtectedSettingsLayoutSettingsLive_streamsIndexRoute
  '/settings/member_tags': typeof ProtectedSettingsLayoutSettingsMember_tagsIndexRoute
  '/settings/moderation': typeof ProtectedSettingsLayoutSettingsModerationIndexRoute
  '/settings/newsletter': typeof ProtectedSettingsLayoutSettingsNewsletterIndexRoute
  '/settings/onboarding': typeof ProtectedSettingsLayoutSettingsOnboardingIndexRoute
  '/settings/pages': typeof ProtectedSettingsLayoutSettingsPagesIndexRoute
  '/settings/paywalls': typeof ProtectedSettingsLayoutSettingsPaywallsIndexRoute
  '/settings/plans': typeof ProtectedSettingsLayoutSettingsPlansIndexRoute
  '/settings/plus': typeof ProtectedSettingsLayoutSettingsPlusIndexRoute
  '/settings/posts': typeof ProtectedSettingsLayoutSettingsPostsIndexRoute
  '/settings/profile_fields': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute
  '/settings/segments': typeof ProtectedSettingsLayoutSettingsSegmentsIndexRoute
  '/settings/sso': typeof ProtectedSettingsLayoutSettingsSsoIndexRoute
  '/settings/theme': typeof ProtectedSettingsLayoutSettingsThemeIndexRoute
  '/settings/topics': typeof ProtectedSettingsLayoutSettingsTopicsIndexRoute
  '/settings/workflows': typeof ProtectedSettingsLayoutSettingsWorkflowsIndexRoute
  '/admin/audience/$sqid': typeof ProtectedAdminAudienceSqidIndexRoute
  '/ai/bots/$botId': typeof ProtectedAiBotsBotIdIndexRoute
  '/settings/inbox/ai': typeof ProtectedSettingsInboxAiIndexRoute
  '/settings/inbox/connection-requests': typeof ProtectedSettingsInboxConnectionRequestsIndexRoute
  '/settings/inbox/course-comments': typeof ProtectedSettingsInboxCourseCommentsIndexRoute
  '/settings/inbox/human-support': typeof ProtectedSettingsInboxHumanSupportIndexRoute
  '/settings/inbox/messages': typeof ProtectedSettingsInboxMessagesIndexRoute
  '/settings/inbox/moderation': typeof ProtectedSettingsInboxModerationIndexRoute
  '/settings/ai-agents/edit/$botPublicId': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren
  '/settings/emails/templates/$id': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute
  '/settings/paywalls/$id/edit': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren
  '/settings/plus/push-notifications/$id': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren
  '/c/$spaceSlug/invite': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute
  '/settings/access_groups/$id/edit': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute
  '/settings/ai-inbox/conversations/$id': typeof ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute
  '/settings/coupons/new/$tab': typeof ProtectedSettingsLayoutSettingsCouponsNewTabRoute
  '/settings/courses/$id/edit': typeof ProtectedSettingsLayoutSettingsCoursesIdEditRoute
  '/settings/emails/forms/new': typeof ProtectedSettingsLayoutSettingsEmailsFormsNewRoute
  '/settings/invitation_links/new/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute
  '/settings/invitation_links/new/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute
  '/settings/invitation_links/new/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute
  '/settings/invitation_links/new/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute
  '/settings/member_tags/$id/edit': typeof ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute
  '/settings/members/invite/access': typeof ProtectedSettingsLayoutSettingsMembersInviteAccessRoute
  '/settings/members/invite/details': typeof ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute
  '/settings/members/invite/emails': typeof ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute
  '/settings/members/invite/newsletters': typeof ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute
  '/settings/members/invite/paywalls': typeof ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute
  '/settings/members/invite/permissions': typeof ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute
  '/settings/members/onboarding/$tab': typeof ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute
  '/settings/paywalls/new/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route
  '/settings/profile_fields/$id/edit': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute
  '/settings/topics/$topicId/edit': typeof ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute
  '/settings/workflows/new/select_type': typeof ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute
  '/ai/bots/$botId/conversations/$conversationId': typeof ProtectedAiBotsBotIdConversationsConversationIdRoute
  '/settings/admin/audience/$sqid/$': typeof ProtectedSettingsAdminAudienceSqidSplatRoute
  '/settings/admin/audience/$sqid/access': typeof ProtectedSettingsAdminAudienceSqidAccessRoute
  '/settings/admin/audience/$sqid/activity_logs': typeof ProtectedSettingsAdminAudienceSqidActivity_logsRoute
  '/settings/admin/audience/$sqid/affiliate': typeof ProtectedSettingsAdminAudienceSqidAffiliateRoute
  '/settings/admin/audience/$sqid/gamification': typeof ProtectedSettingsAdminAudienceSqidGamificationRoute
  '/settings/admin/audience/$sqid/info': typeof ProtectedSettingsAdminAudienceSqidInfoRoute
  '/settings/admin/audience/$sqid/notes': typeof ProtectedSettingsAdminAudienceSqidNotesRoute
  '/settings/inbox/ai/conversations/$id': typeof ProtectedSettingsInboxAiConversationsIdRoute
  '/settings/inbox/human-support/conversations/$id': typeof ProtectedSettingsInboxHumanSupportConversationsIdRoute
  '/settings/inbox/messages/bot/$id': typeof ProtectedSettingsInboxMessagesBotIdRoute
  '/settings/inbox/priority/$kind/$uuid': typeof ProtectedSettingsInboxPriorityKindUuidRoute
  '/settings/access_groups/$id': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute
  '/settings/ai-agents/agents': typeof ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute
  '/settings/ai-agents/knowledge': typeof ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute
  '/settings/coupons/new': typeof ProtectedSettingsLayoutSettingsCouponsNewIndexRoute
  '/settings/emails/broadcast': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute
  '/settings/emails/forms': typeof ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute
  '/settings/emails/settings': typeof ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute
  '/settings/emails/templates': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute
  '/settings/invitation_links/new': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute
  '/settings/members/invite': typeof ProtectedSettingsLayoutSettingsMembersInviteIndexRoute
  '/settings/members/onboarding': typeof ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute
  '/settings/newsletter/lists': typeof ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute
  '/settings/newsletter/posts': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute
  '/settings/plus/push-notifications': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute
  '/settings/workflows/new': typeof ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute
  '/settings/admin/audience/$sqid': typeof ProtectedSettingsAdminAudienceSqidIndexRoute
  '/settings/ai-agents/edit/$botPublicId/audience': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute
  '/settings/ai-agents/edit/$botPublicId/automations': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute
  '/settings/ai-agents/edit/$botPublicId/behavior': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute
  '/settings/ai-agents/edit/$botPublicId/customize': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute
  '/settings/ai-agents/edit/$botPublicId/knowledge': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute
  '/settings/coupons/$id/edit/$tab': typeof ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute
  '/settings/emails/broadcast/$id/content': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute
  '/settings/emails/broadcast/$id/edit': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute
  '/settings/emails/broadcast/$id/visual-builder': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute
  '/settings/emails/forms/$id/$tab': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute
  '/settings/invitation_links/$id/edit/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute
  '/settings/invitation_links/$id/edit/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute
  '/settings/invitation_links/$id/edit/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute
  '/settings/invitation_links/$id/edit/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute
  '/settings/newsletter/posts/$id/content': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute
  '/settings/newsletter/posts/$id/overview': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute
  '/settings/newsletter/posts/$id/settings': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute
  '/settings/paywalls/$id/edit/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route
  '/settings/paywalls/new/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute
  '/settings/paywalls/new/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute
  '/settings/plus/push-notifications/$id/edit': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute
  '/settings/workflows/new/preview/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute
  '/settings/workflows/view/$id/runs': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute
  '/settings/courses/$id/lessons/$lessonId/edit': typeof ProtectedSettingsCoursesIdLessonsLessonIdEditRoute
  '/settings/coupons/$id/edit': typeof ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute
  '/settings/emails/broadcast/$id': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute
  '/settings/emails/forms/$id': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute
  '/settings/invitation_links/$id/edit': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute
  '/settings/newsletter/lists/$listId': typeof ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute
  '/settings/newsletter/posts/$id': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute
  '/settings/pages/edit/$id': typeof ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute
  '/settings/workflows/edit/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute
  '/settings/workflows/view/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute
  '/settings/admin/audience/$sqid/billing': typeof ProtectedSettingsAdminAudienceSqidBillingIndexRoute
  '/settings/emails/broadcast/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute
  '/settings/pages/edit/$id/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute
  '/settings/pages/edit/$id/settings/defaults': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute
  '/settings/pages/edit/$id/settings/navigation': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute
  '/settings/pages/edit/$id/settings/redirects': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute
  '/settings/pages/edit/$id/settings/seo': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute
  '/settings/paywalls/$id/edit/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute
  '/settings/paywalls/$id/edit/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute
  '/settings/plus/push-notifications/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute
  '/settings/admin/audience/$sqid/billing/subscriptions/new': typeof ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute
  '/settings/emails/broadcast/$id/view': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute
  '/settings/pages/edit/$id/settings': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute
  '/settings/plus/push-notifications/$id/view': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute
  '/settings/workflows/new/dynamic/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute
  '/settings/workflows/new/one_time/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute
  '/settings/workflows/new/scheduled/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute
  '/c/$spaceSlug/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute
  '/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/edit/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute
  '/c/$spaceSlug/edit-lesson/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute
  '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute
  '/settings/workflows/new/dynamic/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute
  '/settings/workflows/new/one_time/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute
  '/settings/workflows/new/scheduled/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_minimal': typeof MinimalRouteRouteWithChildren
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/feed': typeof FeedRoute
  '/home': typeof HomeRoute
  '/_protected/_dynamicLayout': typeof ProtectedDynamicLayoutRouteRouteWithChildren
  '/_protected/_embed': typeof ProtectedEmbedRouteRouteWithChildren
  '/_protected/_settingsLayout': typeof ProtectedSettingsLayoutRouteRouteWithChildren
  '/_protected/account': typeof ProtectedAccountRouteRouteWithChildren
  '/_protected/ai': typeof ProtectedAiRouteRouteWithChildren
  '/_protected/members': typeof ProtectedMembersRouteRouteWithChildren
  '/_protected/messages': typeof ProtectedMessagesRouteRouteWithChildren
  '/_minimal/download_app': typeof MinimalDownload_appRoute
  '/_minimal/eclipse': typeof MinimalEclipseRoute
  '/_minimal/two_fa': typeof MinimalTwo_faRoute
  '/_protected/bookmarks': typeof ProtectedBookmarksRoute
  '/_protected/connections': typeof ProtectedConnectionsRoute
  '/_protected/discover': typeof ProtectedDiscoverRoute
  '/_protected/leaderboard': typeof ProtectedLeaderboardRoute
  '/_protected/notifications': typeof ProtectedNotificationsRoute
  '/_protected/threads': typeof ProtectedThreadsRoute
  '/feed_/welcome': typeof FeedWelcomeRoute
  '/marketing_emails/marketing_email_preference': typeof Marketing_emailsMarketing_email_preferenceRoute
  '/marketing_emails/unsubscribe': typeof Marketing_emailsUnsubscribeRoute
  '/public/unsubscribe': typeof PublicUnsubscribeRoute
  '/_minimal/live/$roomSlug': typeof MinimalLiveRoomSlugRouteRouteWithChildren
  '/_protected/account/_tabBody': typeof ProtectedAccountTabBodyRouteRouteWithChildren
  '/_protected/ai/bots': typeof ProtectedAiBotsRouteRouteWithChildren
  '/_protected/ai/briefs': typeof ProtectedAiBriefsRouteRouteWithChildren
  '/_protected/ai/daily-briefs': typeof ProtectedAiDailyBriefsRouteRouteWithChildren
  '/_protected/ai/projects': typeof ProtectedAiProjectsRouteRouteWithChildren
  '/_protected/settings/inbox': typeof ProtectedSettingsInboxRouteRouteWithChildren
  '/_minimal/settings/cancel-plan': typeof MinimalSettingsCancelPlanRoute
  '/_protected/_dynamicLayout/admin-settings': typeof ProtectedDynamicLayoutAdminSettingsRoute
  '/_protected/_dynamicLayout/courses': typeof ProtectedDynamicLayoutCoursesRoute
  '/_protected/_dynamicLayout/events': typeof ProtectedDynamicLayoutEventsRoute
  '/_protected/_dynamicLayout/search': typeof ProtectedDynamicLayoutSearchRoute
  '/_protected/_dynamicLayout/spaces': typeof ProtectedDynamicLayoutSpacesRoute
  '/_protected/account/affiliate': typeof ProtectedAccountAffiliateRoute
  '/_protected/account/billing': typeof ProtectedAccountBillingRoute
  '/_protected/account/partner_program': typeof ProtectedAccountPartner_programRoute
  '/_protected/ai/$conversationId': typeof ProtectedAiConversationIdRoute
  '/_protected/ai/skills': typeof ProtectedAiSkillsRoute
  '/_protected/getting-started/ai': typeof ProtectedGettingStartedAiRoute
  '/_protected/members/$': typeof ProtectedMembersSplatRoute
  '/_protected/members/connections': typeof ProtectedMembersConnectionsRoute
  '/_protected/members/manage': typeof ProtectedMembersManageRoute
  '/_protected/members/map': typeof ProtectedMembersMapRoute
  '/_protected/messages/$uuid': typeof ProtectedMessagesUuidRoute
  '/newsletter/posts/$slug': typeof NewsletterPostsSlugRoute
  '/_minimal/questions-ai/': typeof MinimalQuestionsAiIndexRoute
  '/_protected/ai/': typeof ProtectedAiIndexRoute
  '/_protected/getting-started/': typeof ProtectedGettingStartedIndexRoute
  '/_protected/members/': typeof ProtectedMembersIndexRoute
  '/_protected/messages/': typeof ProtectedMessagesIndexRoute
  '/_minimal/live/$roomSlug/_protected': typeof MinimalLiveRoomSlugProtectedRouteRouteWithChildren
  '/_protected/_dynamicLayout/c/$spaceSlug': typeof ProtectedDynamicLayoutCSpaceSlugRouteRouteWithChildren
  '/_protected/_dynamicLayout/s/$spaceGroupSlug': typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteWithChildren
  '/_protected/_embed/c/$embedSpaceSlug': typeof ProtectedEmbedCEmbedSpaceSlugRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/_affiliatesLayout': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/_billingLayout': typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/analytics': typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/api': typeof ProtectedSettingsLayoutSettingsApiRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/courses': typeof ProtectedSettingsLayoutSettingsCoursesRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/developers': typeof ProtectedSettingsLayoutSettingsDevelopersRouteRoute
  '/_protected/_settingsLayout/settings/files': typeof ProtectedSettingsLayoutSettingsFilesRouteRoute
  '/_protected/_settingsLayout/settings/live_streams': typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/newsletter': typeof ProtectedSettingsLayoutSettingsNewsletterRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/plans': typeof ProtectedSettingsLayoutSettingsPlansRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/profile_fields': typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/segments': typeof ProtectedSettingsLayoutSettingsSegmentsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/spaces': typeof ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/topics': typeof ProtectedSettingsLayoutSettingsTopicsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows': typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRouteWithChildren
  '/_protected/settings/inbox/ai': typeof ProtectedSettingsInboxAiRouteRouteWithChildren
  '/_protected/settings/inbox/chat-threads': typeof ProtectedSettingsInboxChatThreadsRouteRouteWithChildren
  '/_protected/settings/inbox/connection-requests': typeof ProtectedSettingsInboxConnectionRequestsRouteRouteWithChildren
  '/_protected/settings/inbox/course-comments': typeof ProtectedSettingsInboxCourseCommentsRouteRouteWithChildren
  '/_protected/settings/inbox/human-support': typeof ProtectedSettingsInboxHumanSupportRouteRouteWithChildren
  '/_protected/settings/inbox/messages': typeof ProtectedSettingsInboxMessagesRouteRouteWithChildren
  '/_protected/settings/inbox/moderation': typeof ProtectedSettingsInboxModerationRouteRouteWithChildren
  '/_protected/settings/inbox/notifications': typeof ProtectedSettingsInboxNotificationsRouteRoute
  '/_protected/settings/inbox/priority': typeof ProtectedSettingsInboxPriorityRouteRouteWithChildren
  '/_minimal/custom_logins/debug_sessions/$uuid': typeof MinimalCustom_loginsDebug_sessionsUuidRoute
  '/_minimal/live/$roomSlug/public': typeof MinimalLiveRoomSlugPublicRoute
  '/_minimal/live/$roomSlug/record': typeof MinimalLiveRoomSlugRecordRoute
  '/_protected/_dynamicLayout/u/$publicUid': typeof ProtectedDynamicLayoutUPublicUidRoute
  '/_protected/_settingsLayout/audience/manage': typeof ProtectedSettingsLayoutAudienceManageRoute
  '/_protected/_settingsLayout/contacts/import': typeof ProtectedSettingsLayoutContactsImportRoute
  '/_protected/_settingsLayout/settings/branded_apps': typeof ProtectedSettingsLayoutSettingsBranded_appsRoute
  '/_protected/_settingsLayout/settings/branded_apps_builder_landing_page': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute
  '/_protected/_settingsLayout/settings/branded_apps_builder_ui': typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute
  '/_protected/_settingsLayout/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsCode_snippetsRoute
  '/_protected/_settingsLayout/settings/community_ai': typeof ProtectedSettingsLayoutSettingsCommunity_aiRoute
  '/_protected/_settingsLayout/settings/connect': typeof ProtectedSettingsLayoutSettingsConnectRoute
  '/_protected/_settingsLayout/settings/conversion_tracking': typeof ProtectedSettingsLayoutSettingsConversion_trackingRoute
  '/_protected/_settingsLayout/settings/custom_domain': typeof ProtectedSettingsLayoutSettingsCustom_domainRoute
  '/_protected/_settingsLayout/settings/dashboard': typeof ProtectedSettingsLayoutSettingsDashboardRoute
  '/_protected/_settingsLayout/settings/discover': typeof ProtectedSettingsLayoutSettingsDiscoverRoute
  '/_protected/_settingsLayout/settings/embed': typeof ProtectedSettingsLayoutSettingsEmbedRoute
  '/_protected/_settingsLayout/settings/gamification': typeof ProtectedSettingsLayoutSettingsGamificationRoute
  '/_protected/_settingsLayout/settings/general': typeof ProtectedSettingsLayoutSettingsGeneralRoute
  '/_protected/_settingsLayout/settings/home': typeof ProtectedSettingsLayoutSettingsHomeRoute
  '/_protected/_settingsLayout/settings/legal': typeof ProtectedSettingsLayoutSettingsLegalRoute
  '/_protected/_settingsLayout/settings/mobile_app': typeof ProtectedSettingsLayoutSettingsMobile_appRoute
  '/_protected/_settingsLayout/settings/navigation': typeof ProtectedSettingsLayoutSettingsNavigationRoute
  '/_protected/_settingsLayout/settings/paywall_bulk_logs': typeof ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute
  '/_protected/_settingsLayout/settings/paywall_charges': typeof ProtectedSettingsLayoutSettingsPaywall_chargesRoute
  '/_protected/_settingsLayout/settings/paywall_groups': typeof ProtectedSettingsLayoutSettingsPaywall_groupsRoute
  '/_protected/_settingsLayout/settings/paywall_payment_settings': typeof ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute
  '/_protected/_settingsLayout/settings/paywall_subscriptions': typeof ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute
  '/_protected/_settingsLayout/settings/paywall_tax_settings': typeof ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute
  '/_protected/_settingsLayout/settings/recap-2025': typeof ProtectedSettingsLayoutSettingsRecap2025Route
  '/_protected/_settingsLayout/settings/redirects': typeof ProtectedSettingsLayoutSettingsRedirectsRoute
  '/_protected/_settingsLayout/settings/seo': typeof ProtectedSettingsLayoutSettingsSeoRoute
  '/_protected/_settingsLayout/settings/weekly_digest': typeof ProtectedSettingsLayoutSettingsWeekly_digestRoute
  '/_protected/account/_tabBody/authentication': typeof ProtectedAccountTabBodyAuthenticationRoute
  '/_protected/account/_tabBody/notifications': typeof ProtectedAccountTabBodyNotificationsRoute
  '/_protected/account/_tabBody/privacy': typeof ProtectedAccountTabBodyPrivacyRoute
  '/_protected/ai/bots/history': typeof ProtectedAiBotsHistoryRoute
  '/_protected/ai/daily-briefs/$dailyBriefId': typeof ProtectedAiDailyBriefsDailyBriefIdRoute
  '/_protected/ai/projects/$projectId': typeof ProtectedAiProjectsProjectIdRoute
  '/_protected/messages/bot/$id': typeof ProtectedMessagesBotIdRoute
  '/_protected/_settingsLayout/settings/': typeof ProtectedSettingsLayoutSettingsIndexRoute
  '/_protected/account/_tabBody/': typeof ProtectedAccountTabBodyIndexRoute
  '/_protected/ai/bots/': typeof ProtectedAiBotsIndexRoute
  '/_protected/ai/briefs/': typeof ProtectedAiBriefsIndexRoute
  '/_protected/ai/projects/': typeof ProtectedAiProjectsIndexRoute
  '/_protected/settings/inbox/': typeof ProtectedSettingsInboxIndexRoute
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteWithChildren
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/analytics/ai_agents': typeof ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute
  '/_protected/_settingsLayout/settings/analytics/courses': typeof ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute
  '/_protected/_settingsLayout/settings/analytics/devices': typeof ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute
  '/_protected/_settingsLayout/settings/analytics/events': typeof ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute
  '/_protected/_settingsLayout/settings/analytics/members': typeof ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute
  '/_protected/_settingsLayout/settings/analytics/messages': typeof ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute
  '/_protected/_settingsLayout/settings/analytics/payments': typeof ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute
  '/_protected/_settingsLayout/settings/analytics/post_comments': typeof ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute
  '/_protected/_settingsLayout/settings/analytics/reviews': typeof ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute
  '/_protected/_settingsLayout/settings/analytics/spaces': typeof ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute
  '/_protected/_settingsLayout/settings/analytics/videos': typeof ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute
  '/_protected/_settingsLayout/settings/analytics/website': typeof ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute
  '/_protected/_settingsLayout/settings/api/new': typeof ProtectedSettingsLayoutSettingsApiNewRouteRoute
  '/_protected/_settingsLayout/settings/coupons/new': typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/broadcast': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/forms': typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/templates': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/invitation_links/new': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/members/invite': typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/members/onboarding': typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/paywalls/new': typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/plus/push-notifications': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/posts/bulk_actions': typeof ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute
  '/_protected/_settingsLayout/settings/workflows/new': typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteWithChildren
  '/_protected/settings/admin/audience/$sqid': typeof ProtectedSettingsAdminAudienceSqidRouteRouteWithChildren
  '/_minimal/live/$roomSlug/_protected/mobile': typeof MinimalLiveRoomSlugProtectedMobileRoute
  '/_minimal/live/$roomSlug/_protected/not_supported': typeof MinimalLiveRoomSlugProtectedNot_supportedRoute
  '/_minimal/settings/members/onboarding/preview': typeof MinimalSettingsMembersOnboardingPreviewRoute
  '/_protected/_dynamicLayout/c/$spaceSlug/$postSlug': typeof ProtectedDynamicLayoutCSpaceSlugPostSlugRoute
  '/_protected/_dynamicLayout/s/$spaceGroupSlug/edit': typeof ProtectedDynamicLayoutSSpaceGroupSlugEditRoute
  '/_protected/_embed/c/$embedSpaceSlug/$embedPostSlug': typeof ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute
  '/_protected/_settingsLayout/members/invitation_links/$': typeof ProtectedSettingsLayoutMembersInvitation_linksSplatRoute
  '/_protected/_settingsLayout/members/invite/$': typeof ProtectedSettingsLayoutMembersInviteSplatRoute
  '/_protected/_settingsLayout/members/onboarding/$': typeof ProtectedSettingsLayoutMembersOnboardingSplatRoute
  '/_protected/_settingsLayout/members/profile_fields/$': typeof ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute
  '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_commissions': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute
  '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_directory': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute
  '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_settings': typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute
  '/_protected/_settingsLayout/settings/_billingLayout/billing': typeof ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute
  '/_protected/_settingsLayout/settings/_billingLayout/invoices': typeof ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute
  '/_protected/_settingsLayout/settings/_billingLayout/payment_details': typeof ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute
  '/_protected/_settingsLayout/settings/audience/connect': typeof ProtectedSettingsLayoutSettingsAudienceConnectRoute
  '/_protected/_settingsLayout/settings/audience/manage': typeof ProtectedSettingsLayoutSettingsAudienceManageRoute
  '/_protected/_settingsLayout/settings/contacts/import': typeof ProtectedSettingsLayoutSettingsContactsImportRoute
  '/_protected/_settingsLayout/settings/courses/overview': typeof ProtectedSettingsLayoutSettingsCoursesOverviewRoute
  '/_protected/_settingsLayout/settings/live_streams/$id': typeof ProtectedSettingsLayoutSettingsLive_streamsIdRoute
  '/_protected/_settingsLayout/settings/member_tags/new': typeof ProtectedSettingsLayoutSettingsMember_tagsNewRoute
  '/_protected/_settingsLayout/settings/members/activity_logs': typeof ProtectedSettingsLayoutSettingsMembersActivity_logsRoute
  '/_protected/_settingsLayout/settings/members/bulk_import_tasks': typeof ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute
  '/_protected/_settingsLayout/settings/moderation/edit': typeof ProtectedSettingsLayoutSettingsModerationEditRoute
  '/_protected/_settingsLayout/settings/newsletter/activate': typeof ProtectedSettingsLayoutSettingsNewsletterActivateRoute
  '/_protected/_settingsLayout/settings/paywalls/onboarding': typeof ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute
  '/_protected/_settingsLayout/settings/plus/app-settings': typeof ProtectedSettingsLayoutSettingsPlusAppSettingsRoute
  '/_protected/_settingsLayout/settings/plus/insights': typeof ProtectedSettingsLayoutSettingsPlusInsightsRoute
  '/_protected/_settingsLayout/settings/plus/lite': typeof ProtectedSettingsLayoutSettingsPlusLiteRoute
  '/_protected/_settingsLayout/settings/profile_fields/manage': typeof ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute
  '/_protected/_settingsLayout/settings/profile_fields/new': typeof ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute
  '/_protected/_settingsLayout/settings/segments/$id': typeof ProtectedSettingsLayoutSettingsSegmentsIdRoute
  '/_protected/_settingsLayout/settings/spaces/$': typeof ProtectedSettingsLayoutSettingsSpacesSplatRoute
  '/_protected/_settingsLayout/settings/topics/new': typeof ProtectedSettingsLayoutSettingsTopicsNewRoute
  '/_protected/_settingsLayout/settings/workflows/history': typeof ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute
  '/_protected/admin/audience/$sqid/$': typeof ProtectedAdminAudienceSqidSplatRoute
  '/_protected/settings/inbox/chat-threads/$id': typeof ProtectedSettingsInboxChatThreadsIdRoute
  '/_protected/settings/inbox/connection-requests/$id': typeof ProtectedSettingsInboxConnectionRequestsIdRoute
  '/_protected/settings/inbox/course-comments/$chatRoomUuid': typeof ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute
  '/_protected/settings/inbox/messages/$uuid': typeof ProtectedSettingsInboxMessagesUuidRoute
  '/_protected/settings/inbox/moderation/$id': typeof ProtectedSettingsInboxModerationIdRoute
  '/_minimal/live/$roomSlug/_protected/': typeof MinimalLiveRoomSlugProtectedIndexRoute
  '/_protected/_dynamicLayout/s/$spaceGroupSlug/': typeof ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute
  '/_protected/_embed/c/$embedSpaceSlug/': typeof ProtectedEmbedCEmbedSpaceSlugIndexRoute
  '/_protected/_settingsLayout/members/invitation_links/': typeof ProtectedSettingsLayoutMembersInvitation_linksIndexRoute
  '/_protected/_settingsLayout/members/profile_fields/': typeof ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute
  '/_protected/_settingsLayout/settings/access_groups/': typeof ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute
  '/_protected/_settingsLayout/settings/ai-inbox/': typeof ProtectedSettingsLayoutSettingsAiInboxIndexRoute
  '/_protected/_settingsLayout/settings/analytics/': typeof ProtectedSettingsLayoutSettingsAnalyticsIndexRoute
  '/_protected/_settingsLayout/settings/api/': typeof ProtectedSettingsLayoutSettingsApiIndexRoute
  '/_protected/_settingsLayout/settings/coupons/': typeof ProtectedSettingsLayoutSettingsCouponsIndexRoute
  '/_protected/_settingsLayout/settings/courses/': typeof ProtectedSettingsLayoutSettingsCoursesIndexRoute
  '/_protected/_settingsLayout/settings/emails/': typeof ProtectedSettingsLayoutSettingsEmailsIndexRoute
  '/_protected/_settingsLayout/settings/events/': typeof ProtectedSettingsLayoutSettingsEventsIndexRoute
  '/_protected/_settingsLayout/settings/integrations/': typeof ProtectedSettingsLayoutSettingsIntegrationsIndexRoute
  '/_protected/_settingsLayout/settings/invitation_links/': typeof ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute
  '/_protected/_settingsLayout/settings/live_streams/': typeof ProtectedSettingsLayoutSettingsLive_streamsIndexRoute
  '/_protected/_settingsLayout/settings/member_tags/': typeof ProtectedSettingsLayoutSettingsMember_tagsIndexRoute
  '/_protected/_settingsLayout/settings/moderation/': typeof ProtectedSettingsLayoutSettingsModerationIndexRoute
  '/_protected/_settingsLayout/settings/newsletter/': typeof ProtectedSettingsLayoutSettingsNewsletterIndexRoute
  '/_protected/_settingsLayout/settings/onboarding/': typeof ProtectedSettingsLayoutSettingsOnboardingIndexRoute
  '/_protected/_settingsLayout/settings/pages/': typeof ProtectedSettingsLayoutSettingsPagesIndexRoute
  '/_protected/_settingsLayout/settings/paywalls/': typeof ProtectedSettingsLayoutSettingsPaywallsIndexRoute
  '/_protected/_settingsLayout/settings/plans/': typeof ProtectedSettingsLayoutSettingsPlansIndexRoute
  '/_protected/_settingsLayout/settings/plus/': typeof ProtectedSettingsLayoutSettingsPlusIndexRoute
  '/_protected/_settingsLayout/settings/posts/': typeof ProtectedSettingsLayoutSettingsPostsIndexRoute
  '/_protected/_settingsLayout/settings/profile_fields/': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute
  '/_protected/_settingsLayout/settings/segments/': typeof ProtectedSettingsLayoutSettingsSegmentsIndexRoute
  '/_protected/_settingsLayout/settings/sso/': typeof ProtectedSettingsLayoutSettingsSsoIndexRoute
  '/_protected/_settingsLayout/settings/theme/': typeof ProtectedSettingsLayoutSettingsThemeIndexRoute
  '/_protected/_settingsLayout/settings/topics/': typeof ProtectedSettingsLayoutSettingsTopicsIndexRoute
  '/_protected/_settingsLayout/settings/workflows/': typeof ProtectedSettingsLayoutSettingsWorkflowsIndexRoute
  '/_protected/admin/audience/$sqid/': typeof ProtectedAdminAudienceSqidIndexRoute
  '/_protected/ai/bots/$botId/': typeof ProtectedAiBotsBotIdIndexRoute
  '/_protected/settings/inbox/ai/': typeof ProtectedSettingsInboxAiIndexRoute
  '/_protected/settings/inbox/connection-requests/': typeof ProtectedSettingsInboxConnectionRequestsIndexRoute
  '/_protected/settings/inbox/course-comments/': typeof ProtectedSettingsInboxCourseCommentsIndexRoute
  '/_protected/settings/inbox/human-support/': typeof ProtectedSettingsInboxHumanSupportIndexRoute
  '/_protected/settings/inbox/messages/': typeof ProtectedSettingsInboxMessagesIndexRoute
  '/_protected/settings/inbox/moderation/': typeof ProtectedSettingsInboxModerationIndexRoute
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/coupons/$id/edit': typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/broadcast/$id': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/forms/$id': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/templates/$id': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/newsletter/posts/$id': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/pages/edit/$id': typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/paywalls/$id/edit': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/plus/push-notifications/$id': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/edit/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/view/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteWithChildren
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/invite': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute
  '/_protected/_settingsLayout/settings/access_groups/$id/edit': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute
  '/_protected/_settingsLayout/settings/ai-inbox/conversations/$id': typeof ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute
  '/_protected/_settingsLayout/settings/coupons/new/$tab': typeof ProtectedSettingsLayoutSettingsCouponsNewTabRoute
  '/_protected/_settingsLayout/settings/courses/$id/edit': typeof ProtectedSettingsLayoutSettingsCoursesIdEditRoute
  '/_protected/_settingsLayout/settings/emails/forms/new': typeof ProtectedSettingsLayoutSettingsEmailsFormsNewRoute
  '/_protected/_settingsLayout/settings/invitation_links/new/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute
  '/_protected/_settingsLayout/settings/invitation_links/new/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute
  '/_protected/_settingsLayout/settings/invitation_links/new/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute
  '/_protected/_settingsLayout/settings/invitation_links/new/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute
  '/_protected/_settingsLayout/settings/member_tags/$id/edit': typeof ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute
  '/_protected/_settingsLayout/settings/members/invite/access': typeof ProtectedSettingsLayoutSettingsMembersInviteAccessRoute
  '/_protected/_settingsLayout/settings/members/invite/details': typeof ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute
  '/_protected/_settingsLayout/settings/members/invite/emails': typeof ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute
  '/_protected/_settingsLayout/settings/members/invite/newsletters': typeof ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute
  '/_protected/_settingsLayout/settings/members/invite/paywalls': typeof ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute
  '/_protected/_settingsLayout/settings/members/invite/permissions': typeof ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute
  '/_protected/_settingsLayout/settings/members/onboarding/$tab': typeof ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute
  '/_protected/_settingsLayout/settings/paywalls/new/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route
  '/_protected/_settingsLayout/settings/profile_fields/$id/edit': typeof ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute
  '/_protected/_settingsLayout/settings/topics/$topicId/edit': typeof ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute
  '/_protected/_settingsLayout/settings/workflows/new/select_type': typeof ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute
  '/_protected/ai/bots/$botId/conversations/$conversationId': typeof ProtectedAiBotsBotIdConversationsConversationIdRoute
  '/_protected/settings/admin/audience/$sqid/$': typeof ProtectedSettingsAdminAudienceSqidSplatRoute
  '/_protected/settings/admin/audience/$sqid/access': typeof ProtectedSettingsAdminAudienceSqidAccessRoute
  '/_protected/settings/admin/audience/$sqid/activity_logs': typeof ProtectedSettingsAdminAudienceSqidActivity_logsRoute
  '/_protected/settings/admin/audience/$sqid/affiliate': typeof ProtectedSettingsAdminAudienceSqidAffiliateRoute
  '/_protected/settings/admin/audience/$sqid/gamification': typeof ProtectedSettingsAdminAudienceSqidGamificationRoute
  '/_protected/settings/admin/audience/$sqid/info': typeof ProtectedSettingsAdminAudienceSqidInfoRoute
  '/_protected/settings/admin/audience/$sqid/notes': typeof ProtectedSettingsAdminAudienceSqidNotesRoute
  '/_protected/settings/inbox/ai/conversations/$id': typeof ProtectedSettingsInboxAiConversationsIdRoute
  '/_protected/settings/inbox/human-support/conversations/$id': typeof ProtectedSettingsInboxHumanSupportConversationsIdRoute
  '/_protected/settings/inbox/messages/bot/$id': typeof ProtectedSettingsInboxMessagesBotIdRoute
  '/_protected/settings/inbox/priority/$kind/$uuid': typeof ProtectedSettingsInboxPriorityKindUuidRoute
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute
  '/_protected/_settingsLayout/settings/access_groups/$id/': typeof ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute
  '/_protected/_settingsLayout/settings/ai-agents/agents/': typeof ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute
  '/_protected/_settingsLayout/settings/ai-agents/knowledge/': typeof ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute
  '/_protected/_settingsLayout/settings/coupons/new/': typeof ProtectedSettingsLayoutSettingsCouponsNewIndexRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute
  '/_protected/_settingsLayout/settings/emails/forms/': typeof ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute
  '/_protected/_settingsLayout/settings/emails/settings/': typeof ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute
  '/_protected/_settingsLayout/settings/emails/templates/': typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute
  '/_protected/_settingsLayout/settings/invitation_links/new/': typeof ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute
  '/_protected/_settingsLayout/settings/members/invite/': typeof ProtectedSettingsLayoutSettingsMembersInviteIndexRoute
  '/_protected/_settingsLayout/settings/members/onboarding/': typeof ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute
  '/_protected/_settingsLayout/settings/newsletter/lists/': typeof ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute
  '/_protected/_settingsLayout/settings/newsletter/posts/': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute
  '/_protected/_settingsLayout/settings/plus/push-notifications/': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute
  '/_protected/settings/admin/audience/$sqid/': typeof ProtectedSettingsAdminAudienceSqidIndexRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/view': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/new/one_time/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/audience': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/automations': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/behavior': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/customize': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute
  '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge': typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute
  '/_protected/_settingsLayout/settings/coupons/$id/edit/$tab': typeof ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/content': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/edit': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/visual-builder': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute
  '/_protected/_settingsLayout/settings/emails/forms/$id/$tab': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit/access': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit/details': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit/paywalls': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit/subscription': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute
  '/_protected/_settingsLayout/settings/newsletter/posts/$id/content': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute
  '/_protected/_settingsLayout/settings/newsletter/posts/$id/overview': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute
  '/_protected/_settingsLayout/settings/newsletter/posts/$id/settings': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute
  '/_protected/_settingsLayout/settings/paywalls/$id/edit/{-$tab}': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route
  '/_protected/_settingsLayout/settings/paywalls/new/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute
  '/_protected/_settingsLayout/settings/paywalls/new/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute
  '/_protected/_settingsLayout/settings/plus/push-notifications/$id/edit': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute
  '/_protected/_settingsLayout/settings/workflows/new/preview/$id': typeof ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute
  '/_protected/_settingsLayout/settings/workflows/view/$id/runs': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute
  '/_protected/settings/courses/$id/lessons/$lessonId/edit': typeof ProtectedSettingsCoursesIdLessonsLessonIdEditRoute
  '/_protected/_settingsLayout/settings/coupons/$id/edit/': typeof ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute
  '/_protected/_settingsLayout/settings/emails/forms/$id/': typeof ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute
  '/_protected/_settingsLayout/settings/invitation_links/$id/edit/': typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute
  '/_protected/_settingsLayout/settings/newsletter/lists/$listId/': typeof ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute
  '/_protected/_settingsLayout/settings/newsletter/posts/$id/': typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/': typeof ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/edit/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/view/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute
  '/_protected/settings/admin/audience/$sqid/billing/': typeof ProtectedSettingsAdminAudienceSqidBillingIndexRoute
  '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/code_snippets': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/defaults': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/navigation': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/redirects': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/seo': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute
  '/_protected/_settingsLayout/settings/paywalls/$id/edit/checkout/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute
  '/_protected/_settingsLayout/settings/paywalls/$id/edit/upsell/customization': typeof ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute
  '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/analytics': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute
  '/_protected/settings/admin/audience/$sqid/billing/subscriptions/new': typeof ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute
  '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/': typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute
  '/_protected/_settingsLayout/settings/pages/edit/$id/settings/': typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute
  '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/': typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteWithChildren
  '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteWithChildren
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute
  '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute
  '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute
  '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/edit-lesson/sections/$sectionId/lessons/$lessonId': typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute
  '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute
  '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute
  '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute
  '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute
  '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/': typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/feed'
    | '/home'
    | '/account'
    | '/ai'
    | '/members'
    | '/messages'
    | '/download_app'
    | '/eclipse'
    | '/two_fa'
    | '/bookmarks'
    | '/connections'
    | '/discover'
    | '/leaderboard'
    | '/notifications'
    | '/threads'
    | '/feed/welcome'
    | '/marketing_emails/marketing_email_preference'
    | '/marketing_emails/unsubscribe'
    | '/public/unsubscribe'
    | '/live/$roomSlug'
    | '/ai/bots'
    | '/ai/briefs'
    | '/ai/daily-briefs'
    | '/ai/projects'
    | '/settings/inbox'
    | '/settings/cancel-plan'
    | '/admin-settings'
    | '/courses'
    | '/events'
    | '/search'
    | '/spaces'
    | '/account/affiliate'
    | '/account/billing'
    | '/account/partner_program'
    | '/ai/$conversationId'
    | '/ai/skills'
    | '/getting-started/ai'
    | '/members/$'
    | '/members/connections'
    | '/members/manage'
    | '/members/map'
    | '/messages/$uuid'
    | '/newsletter/posts/$slug'
    | '/questions-ai/'
    | '/ai/'
    | '/getting-started/'
    | '/members/'
    | '/messages/'
    | '/c/$spaceSlug'
    | '/s/$spaceGroupSlug'
    | '/c/$embedSpaceSlug'
    | '/settings'
    | '/settings/analytics'
    | '/settings/api'
    | '/settings/courses'
    | '/settings/developers'
    | '/settings/files'
    | '/settings/live_streams'
    | '/settings/newsletter'
    | '/settings/plans'
    | '/settings/profile_fields'
    | '/settings/segments'
    | '/settings/spaces'
    | '/settings/topics'
    | '/settings/workflows'
    | '/settings/inbox/ai'
    | '/settings/inbox/chat-threads'
    | '/settings/inbox/connection-requests'
    | '/settings/inbox/course-comments'
    | '/settings/inbox/human-support'
    | '/settings/inbox/messages'
    | '/settings/inbox/moderation'
    | '/settings/inbox/notifications'
    | '/settings/inbox/priority'
    | '/custom_logins/debug_sessions/$uuid'
    | '/live/$roomSlug/public'
    | '/live/$roomSlug/record'
    | '/u/$publicUid'
    | '/audience/manage'
    | '/contacts/import'
    | '/settings/branded_apps'
    | '/settings/branded_apps_builder_landing_page'
    | '/settings/branded_apps_builder_ui'
    | '/settings/code_snippets'
    | '/settings/community_ai'
    | '/settings/connect'
    | '/settings/conversion_tracking'
    | '/settings/custom_domain'
    | '/settings/dashboard'
    | '/settings/discover'
    | '/settings/embed'
    | '/settings/gamification'
    | '/settings/general'
    | '/settings/home'
    | '/settings/legal'
    | '/settings/mobile_app'
    | '/settings/navigation'
    | '/settings/paywall_bulk_logs'
    | '/settings/paywall_charges'
    | '/settings/paywall_groups'
    | '/settings/paywall_payment_settings'
    | '/settings/paywall_subscriptions'
    | '/settings/paywall_tax_settings'
    | '/settings/recap-2025'
    | '/settings/redirects'
    | '/settings/seo'
    | '/settings/weekly_digest'
    | '/account/authentication'
    | '/account/notifications'
    | '/account/privacy'
    | '/ai/bots/history'
    | '/ai/daily-briefs/$dailyBriefId'
    | '/ai/projects/$projectId'
    | '/messages/bot/$id'
    | '/settings/'
    | '/account/'
    | '/ai/bots/'
    | '/ai/briefs/'
    | '/ai/projects/'
    | '/settings/inbox/'
    | '/settings/analytics/ai_agents'
    | '/settings/analytics/courses'
    | '/settings/analytics/devices'
    | '/settings/analytics/events'
    | '/settings/analytics/members'
    | '/settings/analytics/messages'
    | '/settings/analytics/payments'
    | '/settings/analytics/post_comments'
    | '/settings/analytics/reviews'
    | '/settings/analytics/spaces'
    | '/settings/analytics/videos'
    | '/settings/analytics/website'
    | '/settings/api/new'
    | '/settings/coupons/new'
    | '/settings/emails/broadcast'
    | '/settings/emails/forms'
    | '/settings/emails/templates'
    | '/settings/invitation_links/new'
    | '/settings/members/invite'
    | '/settings/members/onboarding'
    | '/settings/paywalls/new'
    | '/settings/plus/push-notifications'
    | '/settings/posts/bulk_actions'
    | '/settings/workflows/new'
    | '/settings/admin/audience/$sqid'
    | '/live/$roomSlug/mobile'
    | '/live/$roomSlug/not_supported'
    | '/settings/members/onboarding/preview'
    | '/c/$spaceSlug/$postSlug'
    | '/s/$spaceGroupSlug/edit'
    | '/c/$embedSpaceSlug/$embedPostSlug'
    | '/members/invitation_links/$'
    | '/members/invite/$'
    | '/members/onboarding/$'
    | '/members/profile_fields/$'
    | '/settings/affiliates_commissions'
    | '/settings/affiliates_directory'
    | '/settings/affiliates_settings'
    | '/settings/billing'
    | '/settings/invoices'
    | '/settings/payment_details'
    | '/settings/audience/connect'
    | '/settings/audience/manage'
    | '/settings/contacts/import'
    | '/settings/courses/overview'
    | '/settings/live_streams/$id'
    | '/settings/member_tags/new'
    | '/settings/members/activity_logs'
    | '/settings/members/bulk_import_tasks'
    | '/settings/moderation/edit'
    | '/settings/newsletter/activate'
    | '/settings/paywalls/onboarding'
    | '/settings/plus/app-settings'
    | '/settings/plus/insights'
    | '/settings/plus/lite'
    | '/settings/profile_fields/manage'
    | '/settings/profile_fields/new'
    | '/settings/segments/$id'
    | '/settings/spaces/$'
    | '/settings/topics/new'
    | '/settings/workflows/history'
    | '/admin/audience/$sqid/$'
    | '/settings/inbox/chat-threads/$id'
    | '/settings/inbox/connection-requests/$id'
    | '/settings/inbox/course-comments/$chatRoomUuid'
    | '/settings/inbox/messages/$uuid'
    | '/settings/inbox/moderation/$id'
    | '/live/$roomSlug/'
    | '/s/$spaceGroupSlug/'
    | '/c/$embedSpaceSlug/'
    | '/members/invitation_links/'
    | '/members/profile_fields/'
    | '/settings/access_groups/'
    | '/settings/ai-inbox/'
    | '/settings/analytics/'
    | '/settings/api/'
    | '/settings/coupons/'
    | '/settings/courses/'
    | '/settings/emails/'
    | '/settings/events/'
    | '/settings/integrations/'
    | '/settings/invitation_links/'
    | '/settings/live_streams/'
    | '/settings/member_tags/'
    | '/settings/moderation/'
    | '/settings/newsletter/'
    | '/settings/onboarding/'
    | '/settings/pages/'
    | '/settings/paywalls/'
    | '/settings/plans/'
    | '/settings/plus/'
    | '/settings/posts/'
    | '/settings/profile_fields/'
    | '/settings/segments/'
    | '/settings/sso/'
    | '/settings/theme/'
    | '/settings/topics/'
    | '/settings/workflows/'
    | '/admin/audience/$sqid/'
    | '/ai/bots/$botId/'
    | '/settings/inbox/ai/'
    | '/settings/inbox/connection-requests/'
    | '/settings/inbox/course-comments/'
    | '/settings/inbox/human-support/'
    | '/settings/inbox/messages/'
    | '/settings/inbox/moderation/'
    | '/settings/ai-agents/edit/$botPublicId'
    | '/settings/coupons/$id/edit'
    | '/settings/emails/broadcast/$id'
    | '/settings/emails/forms/$id'
    | '/settings/emails/templates/$id'
    | '/settings/invitation_links/$id/edit'
    | '/settings/newsletter/posts/$id'
    | '/settings/pages/edit/$id'
    | '/settings/paywalls/$id/edit'
    | '/settings/plus/push-notifications/$id'
    | '/settings/workflows/edit/$id'
    | '/settings/workflows/view/$id'
    | '/c/$spaceSlug/invite'
    | '/settings/access_groups/$id/edit'
    | '/settings/ai-inbox/conversations/$id'
    | '/settings/coupons/new/$tab'
    | '/settings/courses/$id/edit'
    | '/settings/emails/forms/new'
    | '/settings/invitation_links/new/access'
    | '/settings/invitation_links/new/details'
    | '/settings/invitation_links/new/paywalls'
    | '/settings/invitation_links/new/subscription'
    | '/settings/member_tags/$id/edit'
    | '/settings/members/invite/access'
    | '/settings/members/invite/details'
    | '/settings/members/invite/emails'
    | '/settings/members/invite/newsletters'
    | '/settings/members/invite/paywalls'
    | '/settings/members/invite/permissions'
    | '/settings/members/onboarding/$tab'
    | '/settings/paywalls/new/{-$tab}'
    | '/settings/profile_fields/$id/edit'
    | '/settings/topics/$topicId/edit'
    | '/settings/workflows/new/select_type'
    | '/ai/bots/$botId/conversations/$conversationId'
    | '/settings/admin/audience/$sqid/$'
    | '/settings/admin/audience/$sqid/access'
    | '/settings/admin/audience/$sqid/activity_logs'
    | '/settings/admin/audience/$sqid/affiliate'
    | '/settings/admin/audience/$sqid/gamification'
    | '/settings/admin/audience/$sqid/info'
    | '/settings/admin/audience/$sqid/notes'
    | '/settings/inbox/ai/conversations/$id'
    | '/settings/inbox/human-support/conversations/$id'
    | '/settings/inbox/messages/bot/$id'
    | '/settings/inbox/priority/$kind/$uuid'
    | '/c/$spaceSlug/'
    | '/settings/access_groups/$id/'
    | '/settings/ai-agents/agents/'
    | '/settings/ai-agents/knowledge/'
    | '/settings/coupons/new/'
    | '/settings/emails/broadcast/'
    | '/settings/emails/forms/'
    | '/settings/emails/settings/'
    | '/settings/emails/templates/'
    | '/settings/invitation_links/new/'
    | '/settings/members/invite/'
    | '/settings/members/onboarding/'
    | '/settings/newsletter/lists/'
    | '/settings/newsletter/posts/'
    | '/settings/plus/push-notifications/'
    | '/settings/workflows/new/'
    | '/settings/admin/audience/$sqid/'
    | '/settings/emails/broadcast/$id/view'
    | '/settings/pages/edit/$id/settings'
    | '/settings/plus/push-notifications/$id/view'
    | '/settings/workflows/new/dynamic/$id'
    | '/settings/workflows/new/one_time/$id'
    | '/settings/workflows/new/scheduled/$id'
    | '/settings/ai-agents/edit/$botPublicId/audience'
    | '/settings/ai-agents/edit/$botPublicId/automations'
    | '/settings/ai-agents/edit/$botPublicId/behavior'
    | '/settings/ai-agents/edit/$botPublicId/customize'
    | '/settings/ai-agents/edit/$botPublicId/knowledge'
    | '/settings/coupons/$id/edit/$tab'
    | '/settings/emails/broadcast/$id/content'
    | '/settings/emails/broadcast/$id/edit'
    | '/settings/emails/broadcast/$id/visual-builder'
    | '/settings/emails/forms/$id/$tab'
    | '/settings/invitation_links/$id/edit/access'
    | '/settings/invitation_links/$id/edit/details'
    | '/settings/invitation_links/$id/edit/paywalls'
    | '/settings/invitation_links/$id/edit/subscription'
    | '/settings/newsletter/posts/$id/content'
    | '/settings/newsletter/posts/$id/overview'
    | '/settings/newsletter/posts/$id/settings'
    | '/settings/paywalls/$id/edit/{-$tab}'
    | '/settings/paywalls/new/checkout/customization'
    | '/settings/paywalls/new/upsell/customization'
    | '/settings/plus/push-notifications/$id/edit'
    | '/settings/workflows/new/preview/$id'
    | '/settings/workflows/view/$id/runs'
    | '/settings/courses/$id/lessons/$lessonId/edit'
    | '/settings/coupons/$id/edit/'
    | '/settings/emails/broadcast/$id/'
    | '/settings/emails/forms/$id/'
    | '/settings/invitation_links/$id/edit/'
    | '/settings/newsletter/lists/$listId/'
    | '/settings/newsletter/posts/$id/'
    | '/settings/pages/edit/$id/'
    | '/settings/workflows/edit/$id/'
    | '/settings/workflows/view/$id/'
    | '/settings/admin/audience/$sqid/billing/'
    | '/settings/workflows/edit/$id/send-email/$broadcastId'
    | '/settings/emails/broadcast/$id/view/analytics'
    | '/settings/pages/edit/$id/settings/code_snippets'
    | '/settings/pages/edit/$id/settings/defaults'
    | '/settings/pages/edit/$id/settings/navigation'
    | '/settings/pages/edit/$id/settings/redirects'
    | '/settings/pages/edit/$id/settings/seo'
    | '/settings/paywalls/$id/edit/checkout/customization'
    | '/settings/paywalls/$id/edit/upsell/customization'
    | '/settings/plus/push-notifications/$id/view/analytics'
    | '/settings/admin/audience/$sqid/billing/subscriptions/new'
    | '/settings/emails/broadcast/$id/view/'
    | '/settings/pages/edit/$id/settings/'
    | '/settings/plus/push-notifications/$id/view/'
    | '/settings/workflows/new/dynamic/$id/'
    | '/settings/workflows/new/one_time/$id/'
    | '/settings/workflows/new/scheduled/$id/'
    | '/settings/workflows/new/dynamic/$id/send-email/$broadcastId'
    | '/settings/workflows/new/one_time/$id/send-email/$broadcastId'
    | '/settings/workflows/new/scheduled/$id/send-email/$broadcastId'
    | '/c/$spaceSlug/sections/$sectionId/lessons/$lessonId'
    | '/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/edit/$id/send-email/$broadcastId/'
    | '/c/$spaceSlug/edit-lesson/sections/$sectionId/lessons/$lessonId'
    | '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/'
    | '/settings/workflows/new/one_time/$id/send-email/$broadcastId/'
    | '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/feed'
    | '/home'
    | '/account'
    | '/download_app'
    | '/eclipse'
    | '/two_fa'
    | '/bookmarks'
    | '/connections'
    | '/discover'
    | '/leaderboard'
    | '/notifications'
    | '/threads'
    | '/feed/welcome'
    | '/marketing_emails/marketing_email_preference'
    | '/marketing_emails/unsubscribe'
    | '/public/unsubscribe'
    | '/live/$roomSlug'
    | '/ai/daily-briefs'
    | '/settings/cancel-plan'
    | '/admin-settings'
    | '/courses'
    | '/events'
    | '/search'
    | '/spaces'
    | '/account/affiliate'
    | '/account/billing'
    | '/account/partner_program'
    | '/ai/$conversationId'
    | '/ai/skills'
    | '/getting-started/ai'
    | '/members/$'
    | '/members/connections'
    | '/members/manage'
    | '/members/map'
    | '/messages/$uuid'
    | '/newsletter/posts/$slug'
    | '/questions-ai'
    | '/ai'
    | '/getting-started'
    | '/members'
    | '/messages'
    | '/c/$spaceSlug'
    | '/settings'
    | '/settings/developers'
    | '/settings/files'
    | '/settings/spaces'
    | '/settings/inbox/chat-threads'
    | '/settings/inbox/notifications'
    | '/settings/inbox/priority'
    | '/custom_logins/debug_sessions/$uuid'
    | '/live/$roomSlug/public'
    | '/live/$roomSlug/record'
    | '/u/$publicUid'
    | '/audience/manage'
    | '/contacts/import'
    | '/settings/branded_apps'
    | '/settings/branded_apps_builder_landing_page'
    | '/settings/branded_apps_builder_ui'
    | '/settings/code_snippets'
    | '/settings/community_ai'
    | '/settings/connect'
    | '/settings/conversion_tracking'
    | '/settings/custom_domain'
    | '/settings/dashboard'
    | '/settings/discover'
    | '/settings/embed'
    | '/settings/gamification'
    | '/settings/general'
    | '/settings/home'
    | '/settings/legal'
    | '/settings/mobile_app'
    | '/settings/navigation'
    | '/settings/paywall_bulk_logs'
    | '/settings/paywall_charges'
    | '/settings/paywall_groups'
    | '/settings/paywall_payment_settings'
    | '/settings/paywall_subscriptions'
    | '/settings/paywall_tax_settings'
    | '/settings/recap-2025'
    | '/settings/redirects'
    | '/settings/seo'
    | '/settings/weekly_digest'
    | '/account/authentication'
    | '/account/notifications'
    | '/account/privacy'
    | '/ai/bots/history'
    | '/ai/daily-briefs/$dailyBriefId'
    | '/ai/projects/$projectId'
    | '/messages/bot/$id'
    | '/ai/bots'
    | '/ai/briefs'
    | '/ai/projects'
    | '/settings/inbox'
    | '/settings/analytics/ai_agents'
    | '/settings/analytics/courses'
    | '/settings/analytics/devices'
    | '/settings/analytics/events'
    | '/settings/analytics/members'
    | '/settings/analytics/messages'
    | '/settings/analytics/payments'
    | '/settings/analytics/post_comments'
    | '/settings/analytics/reviews'
    | '/settings/analytics/spaces'
    | '/settings/analytics/videos'
    | '/settings/analytics/website'
    | '/settings/api/new'
    | '/settings/paywalls/new'
    | '/settings/posts/bulk_actions'
    | '/live/$roomSlug/mobile'
    | '/live/$roomSlug/not_supported'
    | '/settings/members/onboarding/preview'
    | '/c/$spaceSlug/$postSlug'
    | '/s/$spaceGroupSlug/edit'
    | '/c/$embedSpaceSlug/$embedPostSlug'
    | '/members/invitation_links/$'
    | '/members/invite/$'
    | '/members/onboarding/$'
    | '/members/profile_fields/$'
    | '/settings/affiliates_commissions'
    | '/settings/affiliates_directory'
    | '/settings/affiliates_settings'
    | '/settings/billing'
    | '/settings/invoices'
    | '/settings/payment_details'
    | '/settings/audience/connect'
    | '/settings/audience/manage'
    | '/settings/contacts/import'
    | '/settings/courses/overview'
    | '/settings/live_streams/$id'
    | '/settings/member_tags/new'
    | '/settings/members/activity_logs'
    | '/settings/members/bulk_import_tasks'
    | '/settings/moderation/edit'
    | '/settings/newsletter/activate'
    | '/settings/paywalls/onboarding'
    | '/settings/plus/app-settings'
    | '/settings/plus/insights'
    | '/settings/plus/lite'
    | '/settings/profile_fields/manage'
    | '/settings/profile_fields/new'
    | '/settings/segments/$id'
    | '/settings/spaces/$'
    | '/settings/topics/new'
    | '/settings/workflows/history'
    | '/admin/audience/$sqid/$'
    | '/settings/inbox/chat-threads/$id'
    | '/settings/inbox/connection-requests/$id'
    | '/settings/inbox/course-comments/$chatRoomUuid'
    | '/settings/inbox/messages/$uuid'
    | '/settings/inbox/moderation/$id'
    | '/s/$spaceGroupSlug'
    | '/c/$embedSpaceSlug'
    | '/members/invitation_links'
    | '/members/profile_fields'
    | '/settings/access_groups'
    | '/settings/ai-inbox'
    | '/settings/analytics'
    | '/settings/api'
    | '/settings/coupons'
    | '/settings/courses'
    | '/settings/emails'
    | '/settings/events'
    | '/settings/integrations'
    | '/settings/invitation_links'
    | '/settings/live_streams'
    | '/settings/member_tags'
    | '/settings/moderation'
    | '/settings/newsletter'
    | '/settings/onboarding'
    | '/settings/pages'
    | '/settings/paywalls'
    | '/settings/plans'
    | '/settings/plus'
    | '/settings/posts'
    | '/settings/profile_fields'
    | '/settings/segments'
    | '/settings/sso'
    | '/settings/theme'
    | '/settings/topics'
    | '/settings/workflows'
    | '/admin/audience/$sqid'
    | '/ai/bots/$botId'
    | '/settings/inbox/ai'
    | '/settings/inbox/connection-requests'
    | '/settings/inbox/course-comments'
    | '/settings/inbox/human-support'
    | '/settings/inbox/messages'
    | '/settings/inbox/moderation'
    | '/settings/ai-agents/edit/$botPublicId'
    | '/settings/emails/templates/$id'
    | '/settings/paywalls/$id/edit'
    | '/settings/plus/push-notifications/$id'
    | '/c/$spaceSlug/invite'
    | '/settings/access_groups/$id/edit'
    | '/settings/ai-inbox/conversations/$id'
    | '/settings/coupons/new/$tab'
    | '/settings/courses/$id/edit'
    | '/settings/emails/forms/new'
    | '/settings/invitation_links/new/access'
    | '/settings/invitation_links/new/details'
    | '/settings/invitation_links/new/paywalls'
    | '/settings/invitation_links/new/subscription'
    | '/settings/member_tags/$id/edit'
    | '/settings/members/invite/access'
    | '/settings/members/invite/details'
    | '/settings/members/invite/emails'
    | '/settings/members/invite/newsletters'
    | '/settings/members/invite/paywalls'
    | '/settings/members/invite/permissions'
    | '/settings/members/onboarding/$tab'
    | '/settings/paywalls/new/{-$tab}'
    | '/settings/profile_fields/$id/edit'
    | '/settings/topics/$topicId/edit'
    | '/settings/workflows/new/select_type'
    | '/ai/bots/$botId/conversations/$conversationId'
    | '/settings/admin/audience/$sqid/$'
    | '/settings/admin/audience/$sqid/access'
    | '/settings/admin/audience/$sqid/activity_logs'
    | '/settings/admin/audience/$sqid/affiliate'
    | '/settings/admin/audience/$sqid/gamification'
    | '/settings/admin/audience/$sqid/info'
    | '/settings/admin/audience/$sqid/notes'
    | '/settings/inbox/ai/conversations/$id'
    | '/settings/inbox/human-support/conversations/$id'
    | '/settings/inbox/messages/bot/$id'
    | '/settings/inbox/priority/$kind/$uuid'
    | '/settings/access_groups/$id'
    | '/settings/ai-agents/agents'
    | '/settings/ai-agents/knowledge'
    | '/settings/coupons/new'
    | '/settings/emails/broadcast'
    | '/settings/emails/forms'
    | '/settings/emails/settings'
    | '/settings/emails/templates'
    | '/settings/invitation_links/new'
    | '/settings/members/invite'
    | '/settings/members/onboarding'
    | '/settings/newsletter/lists'
    | '/settings/newsletter/posts'
    | '/settings/plus/push-notifications'
    | '/settings/workflows/new'
    | '/settings/admin/audience/$sqid'
    | '/settings/ai-agents/edit/$botPublicId/audience'
    | '/settings/ai-agents/edit/$botPublicId/automations'
    | '/settings/ai-agents/edit/$botPublicId/behavior'
    | '/settings/ai-agents/edit/$botPublicId/customize'
    | '/settings/ai-agents/edit/$botPublicId/knowledge'
    | '/settings/coupons/$id/edit/$tab'
    | '/settings/emails/broadcast/$id/content'
    | '/settings/emails/broadcast/$id/edit'
    | '/settings/emails/broadcast/$id/visual-builder'
    | '/settings/emails/forms/$id/$tab'
    | '/settings/invitation_links/$id/edit/access'
    | '/settings/invitation_links/$id/edit/details'
    | '/settings/invitation_links/$id/edit/paywalls'
    | '/settings/invitation_links/$id/edit/subscription'
    | '/settings/newsletter/posts/$id/content'
    | '/settings/newsletter/posts/$id/overview'
    | '/settings/newsletter/posts/$id/settings'
    | '/settings/paywalls/$id/edit/{-$tab}'
    | '/settings/paywalls/new/checkout/customization'
    | '/settings/paywalls/new/upsell/customization'
    | '/settings/plus/push-notifications/$id/edit'
    | '/settings/workflows/new/preview/$id'
    | '/settings/workflows/view/$id/runs'
    | '/settings/courses/$id/lessons/$lessonId/edit'
    | '/settings/coupons/$id/edit'
    | '/settings/emails/broadcast/$id'
    | '/settings/emails/forms/$id'
    | '/settings/invitation_links/$id/edit'
    | '/settings/newsletter/lists/$listId'
    | '/settings/newsletter/posts/$id'
    | '/settings/pages/edit/$id'
    | '/settings/workflows/edit/$id'
    | '/settings/workflows/view/$id'
    | '/settings/admin/audience/$sqid/billing'
    | '/settings/emails/broadcast/$id/view/analytics'
    | '/settings/pages/edit/$id/settings/code_snippets'
    | '/settings/pages/edit/$id/settings/defaults'
    | '/settings/pages/edit/$id/settings/navigation'
    | '/settings/pages/edit/$id/settings/redirects'
    | '/settings/pages/edit/$id/settings/seo'
    | '/settings/paywalls/$id/edit/checkout/customization'
    | '/settings/paywalls/$id/edit/upsell/customization'
    | '/settings/plus/push-notifications/$id/view/analytics'
    | '/settings/admin/audience/$sqid/billing/subscriptions/new'
    | '/settings/emails/broadcast/$id/view'
    | '/settings/pages/edit/$id/settings'
    | '/settings/plus/push-notifications/$id/view'
    | '/settings/workflows/new/dynamic/$id'
    | '/settings/workflows/new/one_time/$id'
    | '/settings/workflows/new/scheduled/$id'
    | '/c/$spaceSlug/sections/$sectionId/lessons/$lessonId'
    | '/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/edit/$id/send-email/$broadcastId'
    | '/c/$spaceSlug/edit-lesson/sections/$sectionId/lessons/$lessonId'
    | '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'
    | '/settings/workflows/new/dynamic/$id/send-email/$broadcastId'
    | '/settings/workflows/new/one_time/$id/send-email/$broadcastId'
    | '/settings/workflows/new/scheduled/$id/send-email/$broadcastId'
  id:
    | '__root__'
    | '/'
    | '/_minimal'
    | '/_protected'
    | '/$'
    | '/feed'
    | '/home'
    | '/_protected/_dynamicLayout'
    | '/_protected/_embed'
    | '/_protected/_settingsLayout'
    | '/_protected/account'
    | '/_protected/ai'
    | '/_protected/members'
    | '/_protected/messages'
    | '/_minimal/download_app'
    | '/_minimal/eclipse'
    | '/_minimal/two_fa'
    | '/_protected/bookmarks'
    | '/_protected/connections'
    | '/_protected/discover'
    | '/_protected/leaderboard'
    | '/_protected/notifications'
    | '/_protected/threads'
    | '/feed_/welcome'
    | '/marketing_emails/marketing_email_preference'
    | '/marketing_emails/unsubscribe'
    | '/public/unsubscribe'
    | '/_minimal/live/$roomSlug'
    | '/_protected/account/_tabBody'
    | '/_protected/ai/bots'
    | '/_protected/ai/briefs'
    | '/_protected/ai/daily-briefs'
    | '/_protected/ai/projects'
    | '/_protected/settings/inbox'
    | '/_minimal/settings/cancel-plan'
    | '/_protected/_dynamicLayout/admin-settings'
    | '/_protected/_dynamicLayout/courses'
    | '/_protected/_dynamicLayout/events'
    | '/_protected/_dynamicLayout/search'
    | '/_protected/_dynamicLayout/spaces'
    | '/_protected/account/affiliate'
    | '/_protected/account/billing'
    | '/_protected/account/partner_program'
    | '/_protected/ai/$conversationId'
    | '/_protected/ai/skills'
    | '/_protected/getting-started/ai'
    | '/_protected/members/$'
    | '/_protected/members/connections'
    | '/_protected/members/manage'
    | '/_protected/members/map'
    | '/_protected/messages/$uuid'
    | '/newsletter/posts/$slug'
    | '/_minimal/questions-ai/'
    | '/_protected/ai/'
    | '/_protected/getting-started/'
    | '/_protected/members/'
    | '/_protected/messages/'
    | '/_minimal/live/$roomSlug/_protected'
    | '/_protected/_dynamicLayout/c/$spaceSlug'
    | '/_protected/_dynamicLayout/s/$spaceGroupSlug'
    | '/_protected/_embed/c/$embedSpaceSlug'
    | '/_protected/_settingsLayout/settings/_affiliatesLayout'
    | '/_protected/_settingsLayout/settings/_billingLayout'
    | '/_protected/_settingsLayout/settings/analytics'
    | '/_protected/_settingsLayout/settings/api'
    | '/_protected/_settingsLayout/settings/courses'
    | '/_protected/_settingsLayout/settings/developers'
    | '/_protected/_settingsLayout/settings/files'
    | '/_protected/_settingsLayout/settings/live_streams'
    | '/_protected/_settingsLayout/settings/newsletter'
    | '/_protected/_settingsLayout/settings/plans'
    | '/_protected/_settingsLayout/settings/profile_fields'
    | '/_protected/_settingsLayout/settings/segments'
    | '/_protected/_settingsLayout/settings/spaces'
    | '/_protected/_settingsLayout/settings/topics'
    | '/_protected/_settingsLayout/settings/workflows'
    | '/_protected/settings/inbox/ai'
    | '/_protected/settings/inbox/chat-threads'
    | '/_protected/settings/inbox/connection-requests'
    | '/_protected/settings/inbox/course-comments'
    | '/_protected/settings/inbox/human-support'
    | '/_protected/settings/inbox/messages'
    | '/_protected/settings/inbox/moderation'
    | '/_protected/settings/inbox/notifications'
    | '/_protected/settings/inbox/priority'
    | '/_minimal/custom_logins/debug_sessions/$uuid'
    | '/_minimal/live/$roomSlug/public'
    | '/_minimal/live/$roomSlug/record'
    | '/_protected/_dynamicLayout/u/$publicUid'
    | '/_protected/_settingsLayout/audience/manage'
    | '/_protected/_settingsLayout/contacts/import'
    | '/_protected/_settingsLayout/settings/branded_apps'
    | '/_protected/_settingsLayout/settings/branded_apps_builder_landing_page'
    | '/_protected/_settingsLayout/settings/branded_apps_builder_ui'
    | '/_protected/_settingsLayout/settings/code_snippets'
    | '/_protected/_settingsLayout/settings/community_ai'
    | '/_protected/_settingsLayout/settings/connect'
    | '/_protected/_settingsLayout/settings/conversion_tracking'
    | '/_protected/_settingsLayout/settings/custom_domain'
    | '/_protected/_settingsLayout/settings/dashboard'
    | '/_protected/_settingsLayout/settings/discover'
    | '/_protected/_settingsLayout/settings/embed'
    | '/_protected/_settingsLayout/settings/gamification'
    | '/_protected/_settingsLayout/settings/general'
    | '/_protected/_settingsLayout/settings/home'
    | '/_protected/_settingsLayout/settings/legal'
    | '/_protected/_settingsLayout/settings/mobile_app'
    | '/_protected/_settingsLayout/settings/navigation'
    | '/_protected/_settingsLayout/settings/paywall_bulk_logs'
    | '/_protected/_settingsLayout/settings/paywall_charges'
    | '/_protected/_settingsLayout/settings/paywall_groups'
    | '/_protected/_settingsLayout/settings/paywall_payment_settings'
    | '/_protected/_settingsLayout/settings/paywall_subscriptions'
    | '/_protected/_settingsLayout/settings/paywall_tax_settings'
    | '/_protected/_settingsLayout/settings/recap-2025'
    | '/_protected/_settingsLayout/settings/redirects'
    | '/_protected/_settingsLayout/settings/seo'
    | '/_protected/_settingsLayout/settings/weekly_digest'
    | '/_protected/account/_tabBody/authentication'
    | '/_protected/account/_tabBody/notifications'
    | '/_protected/account/_tabBody/privacy'
    | '/_protected/ai/bots/history'
    | '/_protected/ai/daily-briefs/$dailyBriefId'
    | '/_protected/ai/projects/$projectId'
    | '/_protected/messages/bot/$id'
    | '/_protected/_settingsLayout/settings/'
    | '/_protected/account/_tabBody/'
    | '/_protected/ai/bots/'
    | '/_protected/ai/briefs/'
    | '/_protected/ai/projects/'
    | '/_protected/settings/inbox/'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard'
    | '/_protected/_settingsLayout/settings/analytics/ai_agents'
    | '/_protected/_settingsLayout/settings/analytics/courses'
    | '/_protected/_settingsLayout/settings/analytics/devices'
    | '/_protected/_settingsLayout/settings/analytics/events'
    | '/_protected/_settingsLayout/settings/analytics/members'
    | '/_protected/_settingsLayout/settings/analytics/messages'
    | '/_protected/_settingsLayout/settings/analytics/payments'
    | '/_protected/_settingsLayout/settings/analytics/post_comments'
    | '/_protected/_settingsLayout/settings/analytics/reviews'
    | '/_protected/_settingsLayout/settings/analytics/spaces'
    | '/_protected/_settingsLayout/settings/analytics/videos'
    | '/_protected/_settingsLayout/settings/analytics/website'
    | '/_protected/_settingsLayout/settings/api/new'
    | '/_protected/_settingsLayout/settings/coupons/new'
    | '/_protected/_settingsLayout/settings/emails/broadcast'
    | '/_protected/_settingsLayout/settings/emails/forms'
    | '/_protected/_settingsLayout/settings/emails/templates'
    | '/_protected/_settingsLayout/settings/invitation_links/new'
    | '/_protected/_settingsLayout/settings/members/invite'
    | '/_protected/_settingsLayout/settings/members/onboarding'
    | '/_protected/_settingsLayout/settings/paywalls/new'
    | '/_protected/_settingsLayout/settings/plus/push-notifications'
    | '/_protected/_settingsLayout/settings/posts/bulk_actions'
    | '/_protected/_settingsLayout/settings/workflows/new'
    | '/_protected/settings/admin/audience/$sqid'
    | '/_minimal/live/$roomSlug/_protected/mobile'
    | '/_minimal/live/$roomSlug/_protected/not_supported'
    | '/_minimal/settings/members/onboarding/preview'
    | '/_protected/_dynamicLayout/c/$spaceSlug/$postSlug'
    | '/_protected/_dynamicLayout/s/$spaceGroupSlug/edit'
    | '/_protected/_embed/c/$embedSpaceSlug/$embedPostSlug'
    | '/_protected/_settingsLayout/members/invitation_links/$'
    | '/_protected/_settingsLayout/members/invite/$'
    | '/_protected/_settingsLayout/members/onboarding/$'
    | '/_protected/_settingsLayout/members/profile_fields/$'
    | '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_commissions'
    | '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_directory'
    | '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_settings'
    | '/_protected/_settingsLayout/settings/_billingLayout/billing'
    | '/_protected/_settingsLayout/settings/_billingLayout/invoices'
    | '/_protected/_settingsLayout/settings/_billingLayout/payment_details'
    | '/_protected/_settingsLayout/settings/audience/connect'
    | '/_protected/_settingsLayout/settings/audience/manage'
    | '/_protected/_settingsLayout/settings/contacts/import'
    | '/_protected/_settingsLayout/settings/courses/overview'
    | '/_protected/_settingsLayout/settings/live_streams/$id'
    | '/_protected/_settingsLayout/settings/member_tags/new'
    | '/_protected/_settingsLayout/settings/members/activity_logs'
    | '/_protected/_settingsLayout/settings/members/bulk_import_tasks'
    | '/_protected/_settingsLayout/settings/moderation/edit'
    | '/_protected/_settingsLayout/settings/newsletter/activate'
    | '/_protected/_settingsLayout/settings/paywalls/onboarding'
    | '/_protected/_settingsLayout/settings/plus/app-settings'
    | '/_protected/_settingsLayout/settings/plus/insights'
    | '/_protected/_settingsLayout/settings/plus/lite'
    | '/_protected/_settingsLayout/settings/profile_fields/manage'
    | '/_protected/_settingsLayout/settings/profile_fields/new'
    | '/_protected/_settingsLayout/settings/segments/$id'
    | '/_protected/_settingsLayout/settings/spaces/$'
    | '/_protected/_settingsLayout/settings/topics/new'
    | '/_protected/_settingsLayout/settings/workflows/history'
    | '/_protected/admin/audience/$sqid/$'
    | '/_protected/settings/inbox/chat-threads/$id'
    | '/_protected/settings/inbox/connection-requests/$id'
    | '/_protected/settings/inbox/course-comments/$chatRoomUuid'
    | '/_protected/settings/inbox/messages/$uuid'
    | '/_protected/settings/inbox/moderation/$id'
    | '/_minimal/live/$roomSlug/_protected/'
    | '/_protected/_dynamicLayout/s/$spaceGroupSlug/'
    | '/_protected/_embed/c/$embedSpaceSlug/'
    | '/_protected/_settingsLayout/members/invitation_links/'
    | '/_protected/_settingsLayout/members/profile_fields/'
    | '/_protected/_settingsLayout/settings/access_groups/'
    | '/_protected/_settingsLayout/settings/ai-inbox/'
    | '/_protected/_settingsLayout/settings/analytics/'
    | '/_protected/_settingsLayout/settings/api/'
    | '/_protected/_settingsLayout/settings/coupons/'
    | '/_protected/_settingsLayout/settings/courses/'
    | '/_protected/_settingsLayout/settings/emails/'
    | '/_protected/_settingsLayout/settings/events/'
    | '/_protected/_settingsLayout/settings/integrations/'
    | '/_protected/_settingsLayout/settings/invitation_links/'
    | '/_protected/_settingsLayout/settings/live_streams/'
    | '/_protected/_settingsLayout/settings/member_tags/'
    | '/_protected/_settingsLayout/settings/moderation/'
    | '/_protected/_settingsLayout/settings/newsletter/'
    | '/_protected/_settingsLayout/settings/onboarding/'
    | '/_protected/_settingsLayout/settings/pages/'
    | '/_protected/_settingsLayout/settings/paywalls/'
    | '/_protected/_settingsLayout/settings/plans/'
    | '/_protected/_settingsLayout/settings/plus/'
    | '/_protected/_settingsLayout/settings/posts/'
    | '/_protected/_settingsLayout/settings/profile_fields/'
    | '/_protected/_settingsLayout/settings/segments/'
    | '/_protected/_settingsLayout/settings/sso/'
    | '/_protected/_settingsLayout/settings/theme/'
    | '/_protected/_settingsLayout/settings/topics/'
    | '/_protected/_settingsLayout/settings/workflows/'
    | '/_protected/admin/audience/$sqid/'
    | '/_protected/ai/bots/$botId/'
    | '/_protected/settings/inbox/ai/'
    | '/_protected/settings/inbox/connection-requests/'
    | '/_protected/settings/inbox/course-comments/'
    | '/_protected/settings/inbox/human-support/'
    | '/_protected/settings/inbox/messages/'
    | '/_protected/settings/inbox/moderation/'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId'
    | '/_protected/_settingsLayout/settings/coupons/$id/edit'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id'
    | '/_protected/_settingsLayout/settings/emails/forms/$id'
    | '/_protected/_settingsLayout/settings/emails/templates/$id'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit'
    | '/_protected/_settingsLayout/settings/newsletter/posts/$id'
    | '/_protected/_settingsLayout/settings/pages/edit/$id'
    | '/_protected/_settingsLayout/settings/paywalls/$id/edit'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/$id'
    | '/_protected/_settingsLayout/settings/workflows/edit/$id'
    | '/_protected/_settingsLayout/settings/workflows/view/$id'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/invite'
    | '/_protected/_settingsLayout/settings/access_groups/$id/edit'
    | '/_protected/_settingsLayout/settings/ai-inbox/conversations/$id'
    | '/_protected/_settingsLayout/settings/coupons/new/$tab'
    | '/_protected/_settingsLayout/settings/courses/$id/edit'
    | '/_protected/_settingsLayout/settings/emails/forms/new'
    | '/_protected/_settingsLayout/settings/invitation_links/new/access'
    | '/_protected/_settingsLayout/settings/invitation_links/new/details'
    | '/_protected/_settingsLayout/settings/invitation_links/new/paywalls'
    | '/_protected/_settingsLayout/settings/invitation_links/new/subscription'
    | '/_protected/_settingsLayout/settings/member_tags/$id/edit'
    | '/_protected/_settingsLayout/settings/members/invite/access'
    | '/_protected/_settingsLayout/settings/members/invite/details'
    | '/_protected/_settingsLayout/settings/members/invite/emails'
    | '/_protected/_settingsLayout/settings/members/invite/newsletters'
    | '/_protected/_settingsLayout/settings/members/invite/paywalls'
    | '/_protected/_settingsLayout/settings/members/invite/permissions'
    | '/_protected/_settingsLayout/settings/members/onboarding/$tab'
    | '/_protected/_settingsLayout/settings/paywalls/new/{-$tab}'
    | '/_protected/_settingsLayout/settings/profile_fields/$id/edit'
    | '/_protected/_settingsLayout/settings/topics/$topicId/edit'
    | '/_protected/_settingsLayout/settings/workflows/new/select_type'
    | '/_protected/ai/bots/$botId/conversations/$conversationId'
    | '/_protected/settings/admin/audience/$sqid/$'
    | '/_protected/settings/admin/audience/$sqid/access'
    | '/_protected/settings/admin/audience/$sqid/activity_logs'
    | '/_protected/settings/admin/audience/$sqid/affiliate'
    | '/_protected/settings/admin/audience/$sqid/gamification'
    | '/_protected/settings/admin/audience/$sqid/info'
    | '/_protected/settings/admin/audience/$sqid/notes'
    | '/_protected/settings/inbox/ai/conversations/$id'
    | '/_protected/settings/inbox/human-support/conversations/$id'
    | '/_protected/settings/inbox/messages/bot/$id'
    | '/_protected/settings/inbox/priority/$kind/$uuid'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/'
    | '/_protected/_settingsLayout/settings/access_groups/$id/'
    | '/_protected/_settingsLayout/settings/ai-agents/agents/'
    | '/_protected/_settingsLayout/settings/ai-agents/knowledge/'
    | '/_protected/_settingsLayout/settings/coupons/new/'
    | '/_protected/_settingsLayout/settings/emails/broadcast/'
    | '/_protected/_settingsLayout/settings/emails/forms/'
    | '/_protected/_settingsLayout/settings/emails/settings/'
    | '/_protected/_settingsLayout/settings/emails/templates/'
    | '/_protected/_settingsLayout/settings/invitation_links/new/'
    | '/_protected/_settingsLayout/settings/members/invite/'
    | '/_protected/_settingsLayout/settings/members/onboarding/'
    | '/_protected/_settingsLayout/settings/newsletter/lists/'
    | '/_protected/_settingsLayout/settings/newsletter/posts/'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/'
    | '/_protected/_settingsLayout/settings/workflows/new/'
    | '/_protected/settings/admin/audience/$sqid/'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/view'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view'
    | '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id'
    | '/_protected/_settingsLayout/settings/workflows/new/one_time/$id'
    | '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/audience'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/automations'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/behavior'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/customize'
    | '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge'
    | '/_protected/_settingsLayout/settings/coupons/$id/edit/$tab'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/content'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/edit'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/visual-builder'
    | '/_protected/_settingsLayout/settings/emails/forms/$id/$tab'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit/access'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit/details'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit/paywalls'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit/subscription'
    | '/_protected/_settingsLayout/settings/newsletter/posts/$id/content'
    | '/_protected/_settingsLayout/settings/newsletter/posts/$id/overview'
    | '/_protected/_settingsLayout/settings/newsletter/posts/$id/settings'
    | '/_protected/_settingsLayout/settings/paywalls/$id/edit/{-$tab}'
    | '/_protected/_settingsLayout/settings/paywalls/new/checkout/customization'
    | '/_protected/_settingsLayout/settings/paywalls/new/upsell/customization'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/$id/edit'
    | '/_protected/_settingsLayout/settings/workflows/new/preview/$id'
    | '/_protected/_settingsLayout/settings/workflows/view/$id/runs'
    | '/_protected/settings/courses/$id/lessons/$lessonId/edit'
    | '/_protected/_settingsLayout/settings/coupons/$id/edit/'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/'
    | '/_protected/_settingsLayout/settings/emails/forms/$id/'
    | '/_protected/_settingsLayout/settings/invitation_links/$id/edit/'
    | '/_protected/_settingsLayout/settings/newsletter/lists/$listId/'
    | '/_protected/_settingsLayout/settings/newsletter/posts/$id/'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/'
    | '/_protected/_settingsLayout/settings/workflows/edit/$id/'
    | '/_protected/_settingsLayout/settings/workflows/view/$id/'
    | '/_protected/settings/admin/audience/$sqid/billing/'
    | '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/analytics'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/code_snippets'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/defaults'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/navigation'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/redirects'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/seo'
    | '/_protected/_settingsLayout/settings/paywalls/$id/edit/checkout/customization'
    | '/_protected/_settingsLayout/settings/paywalls/$id/edit/upsell/customization'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/analytics'
    | '/_protected/settings/admin/audience/$sqid/billing/subscriptions/new'
    | '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/'
    | '/_protected/_settingsLayout/settings/pages/edit/$id/settings/'
    | '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/'
    | '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/'
    | '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/'
    | '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/'
    | '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId'
    | '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId'
    | '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId'
    | '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
    | '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/'
    | '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/edit-lesson/sections/$sectionId/lessons/$lessonId'
    | '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
    | '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
    | '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'
    | '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/'
    | '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/'
    | '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MinimalRouteRoute: typeof MinimalRouteRouteWithChildren
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  FeedRoute: typeof FeedRoute
  HomeRoute: typeof HomeRoute
  FeedWelcomeRoute: typeof FeedWelcomeRoute
  Marketing_emailsMarketing_email_preferenceRoute: typeof Marketing_emailsMarketing_email_preferenceRoute
  Marketing_emailsUnsubscribeRoute: typeof Marketing_emailsUnsubscribeRoute
  PublicUnsubscribeRoute: typeof PublicUnsubscribeRoute
  NewsletterPostsSlugRoute: typeof NewsletterPostsSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_minimal': {
      id: '/_minimal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MinimalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_minimal/download_app': {
      id: '/_minimal/download_app'
      path: '/download_app'
      fullPath: '/download_app'
      preLoaderRoute: typeof MinimalDownload_appRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_minimal/eclipse': {
      id: '/_minimal/eclipse'
      path: '/eclipse'
      fullPath: '/eclipse'
      preLoaderRoute: typeof MinimalEclipseRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_minimal/two_fa': {
      id: '/_minimal/two_fa'
      path: '/two_fa'
      fullPath: '/two_fa'
      preLoaderRoute: typeof MinimalTwo_faRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_protected/_dynamicLayout': {
      id: '/_protected/_dynamicLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedDynamicLayoutRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/_embed': {
      id: '/_protected/_embed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedEmbedRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/_settingsLayout': {
      id: '/_protected/_settingsLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedSettingsLayoutRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/account': {
      id: '/_protected/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/ai': {
      id: '/_protected/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof ProtectedAiRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/bookmarks': {
      id: '/_protected/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof ProtectedBookmarksRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/connections': {
      id: '/_protected/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ProtectedConnectionsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/discover': {
      id: '/_protected/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof ProtectedDiscoverRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/leaderboard': {
      id: '/_protected/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof ProtectedLeaderboardRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/members': {
      id: '/_protected/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof ProtectedMembersRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/messages': {
      id: '/_protected/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof ProtectedMessagesRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/notifications': {
      id: '/_protected/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof ProtectedNotificationsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/threads': {
      id: '/_protected/threads'
      path: '/threads'
      fullPath: '/threads'
      preLoaderRoute: typeof ProtectedThreadsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/feed_/welcome': {
      id: '/feed_/welcome'
      path: '/feed/welcome'
      fullPath: '/feed/welcome'
      preLoaderRoute: typeof FeedWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing_emails/marketing_email_preference': {
      id: '/marketing_emails/marketing_email_preference'
      path: '/marketing_emails/marketing_email_preference'
      fullPath: '/marketing_emails/marketing_email_preference'
      preLoaderRoute: typeof Marketing_emailsMarketing_email_preferenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing_emails/unsubscribe': {
      id: '/marketing_emails/unsubscribe'
      path: '/marketing_emails/unsubscribe'
      fullPath: '/marketing_emails/unsubscribe'
      preLoaderRoute: typeof Marketing_emailsUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/unsubscribe': {
      id: '/public/unsubscribe'
      path: '/public/unsubscribe'
      fullPath: '/public/unsubscribe'
      preLoaderRoute: typeof PublicUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_minimal/live/$roomSlug': {
      id: '/_minimal/live/$roomSlug'
      path: '/live/$roomSlug'
      fullPath: '/live/$roomSlug'
      preLoaderRoute: typeof MinimalLiveRoomSlugRouteRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_minimal/questions-ai/': {
      id: '/_minimal/questions-ai/'
      path: '/questions-ai'
      fullPath: '/questions-ai/'
      preLoaderRoute: typeof MinimalQuestionsAiIndexRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_minimal/settings/cancel-plan': {
      id: '/_minimal/settings/cancel-plan'
      path: '/settings/cancel-plan'
      fullPath: '/settings/cancel-plan'
      preLoaderRoute: typeof MinimalSettingsCancelPlanRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_protected/_dynamicLayout/admin-settings': {
      id: '/_protected/_dynamicLayout/admin-settings'
      path: '/admin-settings'
      fullPath: '/admin-settings'
      preLoaderRoute: typeof ProtectedDynamicLayoutAdminSettingsRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/courses': {
      id: '/_protected/_dynamicLayout/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof ProtectedDynamicLayoutCoursesRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/events': {
      id: '/_protected/_dynamicLayout/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof ProtectedDynamicLayoutEventsRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/search': {
      id: '/_protected/_dynamicLayout/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof ProtectedDynamicLayoutSearchRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/spaces': {
      id: '/_protected/_dynamicLayout/spaces'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof ProtectedDynamicLayoutSpacesRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/account/_tabBody': {
      id: '/_protected/account/_tabBody'
      path: ''
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountTabBodyRouteRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/account/affiliate': {
      id: '/_protected/account/affiliate'
      path: '/affiliate'
      fullPath: '/account/affiliate'
      preLoaderRoute: typeof ProtectedAccountAffiliateRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/account/billing': {
      id: '/_protected/account/billing'
      path: '/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof ProtectedAccountBillingRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/account/partner_program': {
      id: '/_protected/account/partner_program'
      path: '/partner_program'
      fullPath: '/account/partner_program'
      preLoaderRoute: typeof ProtectedAccountPartner_programRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/ai/': {
      id: '/_protected/ai/'
      path: '/'
      fullPath: '/ai/'
      preLoaderRoute: typeof ProtectedAiIndexRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/$conversationId': {
      id: '/_protected/ai/$conversationId'
      path: '/$conversationId'
      fullPath: '/ai/$conversationId'
      preLoaderRoute: typeof ProtectedAiConversationIdRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/bots': {
      id: '/_protected/ai/bots'
      path: '/bots'
      fullPath: '/ai/bots'
      preLoaderRoute: typeof ProtectedAiBotsRouteRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/briefs': {
      id: '/_protected/ai/briefs'
      path: '/briefs'
      fullPath: '/ai/briefs'
      preLoaderRoute: typeof ProtectedAiBriefsRouteRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/daily-briefs': {
      id: '/_protected/ai/daily-briefs'
      path: '/daily-briefs'
      fullPath: '/ai/daily-briefs'
      preLoaderRoute: typeof ProtectedAiDailyBriefsRouteRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/projects': {
      id: '/_protected/ai/projects'
      path: '/projects'
      fullPath: '/ai/projects'
      preLoaderRoute: typeof ProtectedAiProjectsRouteRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/ai/skills': {
      id: '/_protected/ai/skills'
      path: '/skills'
      fullPath: '/ai/skills'
      preLoaderRoute: typeof ProtectedAiSkillsRouteImport
      parentRoute: typeof ProtectedAiRouteRoute
    }
    '/_protected/getting-started/': {
      id: '/_protected/getting-started/'
      path: '/getting-started'
      fullPath: '/getting-started/'
      preLoaderRoute: typeof ProtectedGettingStartedIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/getting-started/ai': {
      id: '/_protected/getting-started/ai'
      path: '/getting-started/ai'
      fullPath: '/getting-started/ai'
      preLoaderRoute: typeof ProtectedGettingStartedAiRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/members/': {
      id: '/_protected/members/'
      path: '/'
      fullPath: '/members/'
      preLoaderRoute: typeof ProtectedMembersIndexRouteImport
      parentRoute: typeof ProtectedMembersRouteRoute
    }
    '/_protected/members/$': {
      id: '/_protected/members/$'
      path: '/$'
      fullPath: '/members/$'
      preLoaderRoute: typeof ProtectedMembersSplatRouteImport
      parentRoute: typeof ProtectedMembersRouteRoute
    }
    '/_protected/members/connections': {
      id: '/_protected/members/connections'
      path: '/connections'
      fullPath: '/members/connections'
      preLoaderRoute: typeof ProtectedMembersConnectionsRouteImport
      parentRoute: typeof ProtectedMembersRouteRoute
    }
    '/_protected/members/manage': {
      id: '/_protected/members/manage'
      path: '/manage'
      fullPath: '/members/manage'
      preLoaderRoute: typeof ProtectedMembersManageRouteImport
      parentRoute: typeof ProtectedMembersRouteRoute
    }
    '/_protected/members/map': {
      id: '/_protected/members/map'
      path: '/map'
      fullPath: '/members/map'
      preLoaderRoute: typeof ProtectedMembersMapRouteImport
      parentRoute: typeof ProtectedMembersRouteRoute
    }
    '/_protected/messages/': {
      id: '/_protected/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof ProtectedMessagesIndexRouteImport
      parentRoute: typeof ProtectedMessagesRouteRoute
    }
    '/_protected/messages/$uuid': {
      id: '/_protected/messages/$uuid'
      path: '/$uuid'
      fullPath: '/messages/$uuid'
      preLoaderRoute: typeof ProtectedMessagesUuidRouteImport
      parentRoute: typeof ProtectedMessagesRouteRoute
    }
    '/_protected/settings/inbox': {
      id: '/_protected/settings/inbox'
      path: '/settings/inbox'
      fullPath: '/settings/inbox'
      preLoaderRoute: typeof ProtectedSettingsInboxRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/newsletter/posts/$slug': {
      id: '/newsletter/posts/$slug'
      path: '/newsletter/posts/$slug'
      fullPath: '/newsletter/posts/$slug'
      preLoaderRoute: typeof NewsletterPostsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_minimal/custom_logins/debug_sessions/$uuid': {
      id: '/_minimal/custom_logins/debug_sessions/$uuid'
      path: '/custom_logins/debug_sessions/$uuid'
      fullPath: '/custom_logins/debug_sessions/$uuid'
      preLoaderRoute: typeof MinimalCustom_loginsDebug_sessionsUuidRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_minimal/live/$roomSlug/_protected': {
      id: '/_minimal/live/$roomSlug/_protected'
      path: ''
      fullPath: '/live/$roomSlug'
      preLoaderRoute: typeof MinimalLiveRoomSlugProtectedRouteRouteImport
      parentRoute: typeof MinimalLiveRoomSlugRouteRoute
    }
    '/_minimal/live/$roomSlug/public': {
      id: '/_minimal/live/$roomSlug/public'
      path: '/public'
      fullPath: '/live/$roomSlug/public'
      preLoaderRoute: typeof MinimalLiveRoomSlugPublicRouteImport
      parentRoute: typeof MinimalLiveRoomSlugRouteRoute
    }
    '/_minimal/live/$roomSlug/record': {
      id: '/_minimal/live/$roomSlug/record'
      path: '/record'
      fullPath: '/live/$roomSlug/record'
      preLoaderRoute: typeof MinimalLiveRoomSlugRecordRouteImport
      parentRoute: typeof MinimalLiveRoomSlugRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug'
      path: '/c/$spaceSlug'
      fullPath: '/c/$spaceSlug'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugRouteRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/s/$spaceGroupSlug': {
      id: '/_protected/_dynamicLayout/s/$spaceGroupSlug'
      path: '/s/$spaceGroupSlug'
      fullPath: '/s/$spaceGroupSlug'
      preLoaderRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/u/$publicUid': {
      id: '/_protected/_dynamicLayout/u/$publicUid'
      path: '/u/$publicUid'
      fullPath: '/u/$publicUid'
      preLoaderRoute: typeof ProtectedDynamicLayoutUPublicUidRouteImport
      parentRoute: typeof ProtectedDynamicLayoutRouteRoute
    }
    '/_protected/_embed/c/$embedSpaceSlug': {
      id: '/_protected/_embed/c/$embedSpaceSlug'
      path: '/c/$embedSpaceSlug'
      fullPath: '/c/$embedSpaceSlug'
      preLoaderRoute: typeof ProtectedEmbedCEmbedSpaceSlugRouteRouteImport
      parentRoute: typeof ProtectedEmbedRouteRoute
    }
    '/_protected/_settingsLayout/audience/manage': {
      id: '/_protected/_settingsLayout/audience/manage'
      path: '/audience/manage'
      fullPath: '/audience/manage'
      preLoaderRoute: typeof ProtectedSettingsLayoutAudienceManageRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/contacts/import': {
      id: '/_protected/_settingsLayout/contacts/import'
      path: '/contacts/import'
      fullPath: '/contacts/import'
      preLoaderRoute: typeof ProtectedSettingsLayoutContactsImportRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/': {
      id: '/_protected/_settingsLayout/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_affiliatesLayout': {
      id: '/_protected/_settingsLayout/settings/_affiliatesLayout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_billingLayout': {
      id: '/_protected/_settingsLayout/settings/_billingLayout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics': {
      id: '/_protected/_settingsLayout/settings/analytics'
      path: '/settings/analytics'
      fullPath: '/settings/analytics'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/api': {
      id: '/_protected/_settingsLayout/settings/api'
      path: '/settings/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsApiRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/branded_apps': {
      id: '/_protected/_settingsLayout/settings/branded_apps'
      path: '/settings/branded_apps'
      fullPath: '/settings/branded_apps'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBranded_appsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/branded_apps_builder_landing_page': {
      id: '/_protected/_settingsLayout/settings/branded_apps_builder_landing_page'
      path: '/settings/branded_apps_builder_landing_page'
      fullPath: '/settings/branded_apps_builder_landing_page'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/branded_apps_builder_ui': {
      id: '/_protected/_settingsLayout/settings/branded_apps_builder_ui'
      path: '/settings/branded_apps_builder_ui'
      fullPath: '/settings/branded_apps_builder_ui'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/code_snippets': {
      id: '/_protected/_settingsLayout/settings/code_snippets'
      path: '/settings/code_snippets'
      fullPath: '/settings/code_snippets'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCode_snippetsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/community_ai': {
      id: '/_protected/_settingsLayout/settings/community_ai'
      path: '/settings/community_ai'
      fullPath: '/settings/community_ai'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCommunity_aiRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/connect': {
      id: '/_protected/_settingsLayout/settings/connect'
      path: '/settings/connect'
      fullPath: '/settings/connect'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsConnectRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/conversion_tracking': {
      id: '/_protected/_settingsLayout/settings/conversion_tracking'
      path: '/settings/conversion_tracking'
      fullPath: '/settings/conversion_tracking'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsConversion_trackingRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/courses': {
      id: '/_protected/_settingsLayout/settings/courses'
      path: '/settings/courses'
      fullPath: '/settings/courses'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCoursesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/custom_domain': {
      id: '/_protected/_settingsLayout/settings/custom_domain'
      path: '/settings/custom_domain'
      fullPath: '/settings/custom_domain'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCustom_domainRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/dashboard': {
      id: '/_protected/_settingsLayout/settings/dashboard'
      path: '/settings/dashboard'
      fullPath: '/settings/dashboard'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsDashboardRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/developers': {
      id: '/_protected/_settingsLayout/settings/developers'
      path: '/settings/developers'
      fullPath: '/settings/developers'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsDevelopersRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/discover': {
      id: '/_protected/_settingsLayout/settings/discover'
      path: '/settings/discover'
      fullPath: '/settings/discover'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsDiscoverRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/embed': {
      id: '/_protected/_settingsLayout/settings/embed'
      path: '/settings/embed'
      fullPath: '/settings/embed'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmbedRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/files': {
      id: '/_protected/_settingsLayout/settings/files'
      path: '/settings/files'
      fullPath: '/settings/files'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsFilesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/gamification': {
      id: '/_protected/_settingsLayout/settings/gamification'
      path: '/settings/gamification'
      fullPath: '/settings/gamification'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsGamificationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/general': {
      id: '/_protected/_settingsLayout/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsGeneralRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/home': {
      id: '/_protected/_settingsLayout/settings/home'
      path: '/settings/home'
      fullPath: '/settings/home'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsHomeRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/legal': {
      id: '/_protected/_settingsLayout/settings/legal'
      path: '/settings/legal'
      fullPath: '/settings/legal'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsLegalRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/live_streams': {
      id: '/_protected/_settingsLayout/settings/live_streams'
      path: '/settings/live_streams'
      fullPath: '/settings/live_streams'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/mobile_app': {
      id: '/_protected/_settingsLayout/settings/mobile_app'
      path: '/settings/mobile_app'
      fullPath: '/settings/mobile_app'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMobile_appRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/navigation': {
      id: '/_protected/_settingsLayout/settings/navigation'
      path: '/settings/navigation'
      fullPath: '/settings/navigation'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNavigationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter': {
      id: '/_protected/_settingsLayout/settings/newsletter'
      path: '/settings/newsletter'
      fullPath: '/settings/newsletter'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_bulk_logs': {
      id: '/_protected/_settingsLayout/settings/paywall_bulk_logs'
      path: '/settings/paywall_bulk_logs'
      fullPath: '/settings/paywall_bulk_logs'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_bulk_logsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_charges': {
      id: '/_protected/_settingsLayout/settings/paywall_charges'
      path: '/settings/paywall_charges'
      fullPath: '/settings/paywall_charges'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_chargesRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_groups': {
      id: '/_protected/_settingsLayout/settings/paywall_groups'
      path: '/settings/paywall_groups'
      fullPath: '/settings/paywall_groups'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_groupsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_payment_settings': {
      id: '/_protected/_settingsLayout/settings/paywall_payment_settings'
      path: '/settings/paywall_payment_settings'
      fullPath: '/settings/paywall_payment_settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_payment_settingsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_subscriptions': {
      id: '/_protected/_settingsLayout/settings/paywall_subscriptions'
      path: '/settings/paywall_subscriptions'
      fullPath: '/settings/paywall_subscriptions'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_subscriptionsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywall_tax_settings': {
      id: '/_protected/_settingsLayout/settings/paywall_tax_settings'
      path: '/settings/paywall_tax_settings'
      fullPath: '/settings/paywall_tax_settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywall_tax_settingsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plans': {
      id: '/_protected/_settingsLayout/settings/plans'
      path: '/settings/plans'
      fullPath: '/settings/plans'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlansRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/profile_fields': {
      id: '/_protected/_settingsLayout/settings/profile_fields'
      path: '/settings/profile_fields'
      fullPath: '/settings/profile_fields'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/recap-2025': {
      id: '/_protected/_settingsLayout/settings/recap-2025'
      path: '/settings/recap-2025'
      fullPath: '/settings/recap-2025'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsRecap2025RouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/redirects': {
      id: '/_protected/_settingsLayout/settings/redirects'
      path: '/settings/redirects'
      fullPath: '/settings/redirects'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsRedirectsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/segments': {
      id: '/_protected/_settingsLayout/settings/segments'
      path: '/settings/segments'
      fullPath: '/settings/segments'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSegmentsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/seo': {
      id: '/_protected/_settingsLayout/settings/seo'
      path: '/settings/seo'
      fullPath: '/settings/seo'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSeoRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/spaces': {
      id: '/_protected/_settingsLayout/settings/spaces'
      path: '/settings/spaces'
      fullPath: '/settings/spaces'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSpacesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/topics': {
      id: '/_protected/_settingsLayout/settings/topics'
      path: '/settings/topics'
      fullPath: '/settings/topics'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsTopicsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/weekly_digest': {
      id: '/_protected/_settingsLayout/settings/weekly_digest'
      path: '/settings/weekly_digest'
      fullPath: '/settings/weekly_digest'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWeekly_digestRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows': {
      id: '/_protected/_settingsLayout/settings/workflows'
      path: '/settings/workflows'
      fullPath: '/settings/workflows'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/account/_tabBody/': {
      id: '/_protected/account/_tabBody/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof ProtectedAccountTabBodyIndexRouteImport
      parentRoute: typeof ProtectedAccountTabBodyRouteRoute
    }
    '/_protected/account/_tabBody/authentication': {
      id: '/_protected/account/_tabBody/authentication'
      path: '/authentication'
      fullPath: '/account/authentication'
      preLoaderRoute: typeof ProtectedAccountTabBodyAuthenticationRouteImport
      parentRoute: typeof ProtectedAccountTabBodyRouteRoute
    }
    '/_protected/account/_tabBody/notifications': {
      id: '/_protected/account/_tabBody/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof ProtectedAccountTabBodyNotificationsRouteImport
      parentRoute: typeof ProtectedAccountTabBodyRouteRoute
    }
    '/_protected/account/_tabBody/privacy': {
      id: '/_protected/account/_tabBody/privacy'
      path: '/privacy'
      fullPath: '/account/privacy'
      preLoaderRoute: typeof ProtectedAccountTabBodyPrivacyRouteImport
      parentRoute: typeof ProtectedAccountTabBodyRouteRoute
    }
    '/_protected/ai/bots/': {
      id: '/_protected/ai/bots/'
      path: '/'
      fullPath: '/ai/bots/'
      preLoaderRoute: typeof ProtectedAiBotsIndexRouteImport
      parentRoute: typeof ProtectedAiBotsRouteRoute
    }
    '/_protected/ai/bots/history': {
      id: '/_protected/ai/bots/history'
      path: '/history'
      fullPath: '/ai/bots/history'
      preLoaderRoute: typeof ProtectedAiBotsHistoryRouteImport
      parentRoute: typeof ProtectedAiBotsRouteRoute
    }
    '/_protected/ai/briefs/': {
      id: '/_protected/ai/briefs/'
      path: '/'
      fullPath: '/ai/briefs/'
      preLoaderRoute: typeof ProtectedAiBriefsIndexRouteImport
      parentRoute: typeof ProtectedAiBriefsRouteRoute
    }
    '/_protected/ai/daily-briefs/$dailyBriefId': {
      id: '/_protected/ai/daily-briefs/$dailyBriefId'
      path: '/$dailyBriefId'
      fullPath: '/ai/daily-briefs/$dailyBriefId'
      preLoaderRoute: typeof ProtectedAiDailyBriefsDailyBriefIdRouteImport
      parentRoute: typeof ProtectedAiDailyBriefsRouteRoute
    }
    '/_protected/ai/projects/': {
      id: '/_protected/ai/projects/'
      path: '/'
      fullPath: '/ai/projects/'
      preLoaderRoute: typeof ProtectedAiProjectsIndexRouteImport
      parentRoute: typeof ProtectedAiProjectsRouteRoute
    }
    '/_protected/ai/projects/$projectId': {
      id: '/_protected/ai/projects/$projectId'
      path: '/$projectId'
      fullPath: '/ai/projects/$projectId'
      preLoaderRoute: typeof ProtectedAiProjectsProjectIdRouteImport
      parentRoute: typeof ProtectedAiProjectsRouteRoute
    }
    '/_protected/messages/bot/$id': {
      id: '/_protected/messages/bot/$id'
      path: '/bot/$id'
      fullPath: '/messages/bot/$id'
      preLoaderRoute: typeof ProtectedMessagesBotIdRouteImport
      parentRoute: typeof ProtectedMessagesRouteRoute
    }
    '/_protected/settings/inbox/': {
      id: '/_protected/settings/inbox/'
      path: '/'
      fullPath: '/settings/inbox/'
      preLoaderRoute: typeof ProtectedSettingsInboxIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/ai': {
      id: '/_protected/settings/inbox/ai'
      path: '/ai'
      fullPath: '/settings/inbox/ai'
      preLoaderRoute: typeof ProtectedSettingsInboxAiRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/chat-threads': {
      id: '/_protected/settings/inbox/chat-threads'
      path: '/chat-threads'
      fullPath: '/settings/inbox/chat-threads'
      preLoaderRoute: typeof ProtectedSettingsInboxChatThreadsRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/connection-requests': {
      id: '/_protected/settings/inbox/connection-requests'
      path: '/connection-requests'
      fullPath: '/settings/inbox/connection-requests'
      preLoaderRoute: typeof ProtectedSettingsInboxConnectionRequestsRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/course-comments': {
      id: '/_protected/settings/inbox/course-comments'
      path: '/course-comments'
      fullPath: '/settings/inbox/course-comments'
      preLoaderRoute: typeof ProtectedSettingsInboxCourseCommentsRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/human-support': {
      id: '/_protected/settings/inbox/human-support'
      path: '/human-support'
      fullPath: '/settings/inbox/human-support'
      preLoaderRoute: typeof ProtectedSettingsInboxHumanSupportRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/messages': {
      id: '/_protected/settings/inbox/messages'
      path: '/messages'
      fullPath: '/settings/inbox/messages'
      preLoaderRoute: typeof ProtectedSettingsInboxMessagesRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/moderation': {
      id: '/_protected/settings/inbox/moderation'
      path: '/moderation'
      fullPath: '/settings/inbox/moderation'
      preLoaderRoute: typeof ProtectedSettingsInboxModerationRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/notifications': {
      id: '/_protected/settings/inbox/notifications'
      path: '/notifications'
      fullPath: '/settings/inbox/notifications'
      preLoaderRoute: typeof ProtectedSettingsInboxNotificationsRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_protected/settings/inbox/priority': {
      id: '/_protected/settings/inbox/priority'
      path: '/priority'
      fullPath: '/settings/inbox/priority'
      preLoaderRoute: typeof ProtectedSettingsInboxPriorityRouteRouteImport
      parentRoute: typeof ProtectedSettingsInboxRouteRoute
    }
    '/_minimal/live/$roomSlug/_protected/': {
      id: '/_minimal/live/$roomSlug/_protected/'
      path: '/'
      fullPath: '/live/$roomSlug/'
      preLoaderRoute: typeof MinimalLiveRoomSlugProtectedIndexRouteImport
      parentRoute: typeof MinimalLiveRoomSlugProtectedRouteRoute
    }
    '/_minimal/live/$roomSlug/_protected/mobile': {
      id: '/_minimal/live/$roomSlug/_protected/mobile'
      path: '/mobile'
      fullPath: '/live/$roomSlug/mobile'
      preLoaderRoute: typeof MinimalLiveRoomSlugProtectedMobileRouteImport
      parentRoute: typeof MinimalLiveRoomSlugProtectedRouteRoute
    }
    '/_minimal/live/$roomSlug/_protected/not_supported': {
      id: '/_minimal/live/$roomSlug/_protected/not_supported'
      path: '/not_supported'
      fullPath: '/live/$roomSlug/not_supported'
      preLoaderRoute: typeof MinimalLiveRoomSlugProtectedNot_supportedRouteImport
      parentRoute: typeof MinimalLiveRoomSlugProtectedRouteRoute
    }
    '/_minimal/settings/members/onboarding/preview': {
      id: '/_minimal/settings/members/onboarding/preview'
      path: '/settings/members/onboarding/preview'
      fullPath: '/settings/members/onboarding/preview'
      preLoaderRoute: typeof MinimalSettingsMembersOnboardingPreviewRouteImport
      parentRoute: typeof MinimalRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/$postSlug': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/$postSlug'
      path: '/$postSlug'
      fullPath: '/c/$spaceSlug/$postSlug'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugPostSlugRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout'
      path: ''
      fullPath: '/c/$spaceSlug'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard'
      path: ''
      fullPath: '/c/$spaceSlug'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugRouteRoute
    }
    '/_protected/_dynamicLayout/s/$spaceGroupSlug/': {
      id: '/_protected/_dynamicLayout/s/$spaceGroupSlug/'
      path: '/'
      fullPath: '/s/$spaceGroupSlug/'
      preLoaderRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugIndexRouteImport
      parentRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute
    }
    '/_protected/_dynamicLayout/s/$spaceGroupSlug/edit': {
      id: '/_protected/_dynamicLayout/s/$spaceGroupSlug/edit'
      path: '/edit'
      fullPath: '/s/$spaceGroupSlug/edit'
      preLoaderRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugEditRouteImport
      parentRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute
    }
    '/_protected/_embed/c/$embedSpaceSlug/': {
      id: '/_protected/_embed/c/$embedSpaceSlug/'
      path: '/'
      fullPath: '/c/$embedSpaceSlug/'
      preLoaderRoute: typeof ProtectedEmbedCEmbedSpaceSlugIndexRouteImport
      parentRoute: typeof ProtectedEmbedCEmbedSpaceSlugRouteRoute
    }
    '/_protected/_embed/c/$embedSpaceSlug/$embedPostSlug': {
      id: '/_protected/_embed/c/$embedSpaceSlug/$embedPostSlug'
      path: '/$embedPostSlug'
      fullPath: '/c/$embedSpaceSlug/$embedPostSlug'
      preLoaderRoute: typeof ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRouteImport
      parentRoute: typeof ProtectedEmbedCEmbedSpaceSlugRouteRoute
    }
    '/_protected/_settingsLayout/members/invitation_links/': {
      id: '/_protected/_settingsLayout/members/invitation_links/'
      path: '/members/invitation_links'
      fullPath: '/members/invitation_links/'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersInvitation_linksIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/members/invitation_links/$': {
      id: '/_protected/_settingsLayout/members/invitation_links/$'
      path: '/members/invitation_links/$'
      fullPath: '/members/invitation_links/$'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersInvitation_linksSplatRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/members/invite/$': {
      id: '/_protected/_settingsLayout/members/invite/$'
      path: '/members/invite/$'
      fullPath: '/members/invite/$'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersInviteSplatRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/members/onboarding/$': {
      id: '/_protected/_settingsLayout/members/onboarding/$'
      path: '/members/onboarding/$'
      fullPath: '/members/onboarding/$'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersOnboardingSplatRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/members/profile_fields/': {
      id: '/_protected/_settingsLayout/members/profile_fields/'
      path: '/members/profile_fields'
      fullPath: '/members/profile_fields/'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersProfile_fieldsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/members/profile_fields/$': {
      id: '/_protected/_settingsLayout/members/profile_fields/$'
      path: '/members/profile_fields/$'
      fullPath: '/members/profile_fields/$'
      preLoaderRoute: typeof ProtectedSettingsLayoutMembersProfile_fieldsSplatRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_commissions': {
      id: '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_commissions'
      path: '/affiliates_commissions'
      fullPath: '/settings/affiliates_commissions'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_directory': {
      id: '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_directory'
      path: '/affiliates_directory'
      fullPath: '/settings/affiliates_directory'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_settings': {
      id: '/_protected/_settingsLayout/settings/_affiliatesLayout/affiliates_settings'
      path: '/affiliates_settings'
      fullPath: '/settings/affiliates_settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_billingLayout/billing': {
      id: '/_protected/_settingsLayout/settings/_billingLayout/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutBillingRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_billingLayout/invoices': {
      id: '/_protected/_settingsLayout/settings/_billingLayout/invoices'
      path: '/invoices'
      fullPath: '/settings/invoices'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/_billingLayout/payment_details': {
      id: '/_protected/_settingsLayout/settings/_billingLayout/payment_details'
      path: '/payment_details'
      fullPath: '/settings/payment_details'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/access_groups/': {
      id: '/_protected/_settingsLayout/settings/access_groups/'
      path: '/settings/access_groups'
      fullPath: '/settings/access_groups/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-inbox/': {
      id: '/_protected/_settingsLayout/settings/ai-inbox/'
      path: '/settings/ai-inbox'
      fullPath: '/settings/ai-inbox/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiInboxIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/': {
      id: '/_protected/_settingsLayout/settings/analytics/'
      path: '/'
      fullPath: '/settings/analytics/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/ai_agents': {
      id: '/_protected/_settingsLayout/settings/analytics/ai_agents'
      path: '/ai_agents'
      fullPath: '/settings/analytics/ai_agents'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/courses': {
      id: '/_protected/_settingsLayout/settings/analytics/courses'
      path: '/courses'
      fullPath: '/settings/analytics/courses'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/devices': {
      id: '/_protected/_settingsLayout/settings/analytics/devices'
      path: '/devices'
      fullPath: '/settings/analytics/devices'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/events': {
      id: '/_protected/_settingsLayout/settings/analytics/events'
      path: '/events'
      fullPath: '/settings/analytics/events'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/members': {
      id: '/_protected/_settingsLayout/settings/analytics/members'
      path: '/members'
      fullPath: '/settings/analytics/members'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/messages': {
      id: '/_protected/_settingsLayout/settings/analytics/messages'
      path: '/messages'
      fullPath: '/settings/analytics/messages'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/payments': {
      id: '/_protected/_settingsLayout/settings/analytics/payments'
      path: '/payments'
      fullPath: '/settings/analytics/payments'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/post_comments': {
      id: '/_protected/_settingsLayout/settings/analytics/post_comments'
      path: '/post_comments'
      fullPath: '/settings/analytics/post_comments'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/reviews': {
      id: '/_protected/_settingsLayout/settings/analytics/reviews'
      path: '/reviews'
      fullPath: '/settings/analytics/reviews'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/spaces': {
      id: '/_protected/_settingsLayout/settings/analytics/spaces'
      path: '/spaces'
      fullPath: '/settings/analytics/spaces'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/videos': {
      id: '/_protected/_settingsLayout/settings/analytics/videos'
      path: '/videos'
      fullPath: '/settings/analytics/videos'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/analytics/website': {
      id: '/_protected/_settingsLayout/settings/analytics/website'
      path: '/website'
      fullPath: '/settings/analytics/website'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRoute
    }
    '/_protected/_settingsLayout/settings/api/': {
      id: '/_protected/_settingsLayout/settings/api/'
      path: '/'
      fullPath: '/settings/api/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsApiIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsApiRouteRoute
    }
    '/_protected/_settingsLayout/settings/api/new': {
      id: '/_protected/_settingsLayout/settings/api/new'
      path: '/new'
      fullPath: '/settings/api/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsApiNewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsApiRouteRoute
    }
    '/_protected/_settingsLayout/settings/audience/connect': {
      id: '/_protected/_settingsLayout/settings/audience/connect'
      path: '/settings/audience/connect'
      fullPath: '/settings/audience/connect'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAudienceConnectRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/audience/manage': {
      id: '/_protected/_settingsLayout/settings/audience/manage'
      path: '/settings/audience/manage'
      fullPath: '/settings/audience/manage'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAudienceManageRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/contacts/import': {
      id: '/_protected/_settingsLayout/settings/contacts/import'
      path: '/settings/contacts/import'
      fullPath: '/settings/contacts/import'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsContactsImportRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/': {
      id: '/_protected/_settingsLayout/settings/coupons/'
      path: '/settings/coupons'
      fullPath: '/settings/coupons/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/new': {
      id: '/_protected/_settingsLayout/settings/coupons/new'
      path: '/settings/coupons/new'
      fullPath: '/settings/coupons/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/courses/': {
      id: '/_protected/_settingsLayout/settings/courses/'
      path: '/'
      fullPath: '/settings/courses/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCoursesIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCoursesRouteRoute
    }
    '/_protected/_settingsLayout/settings/courses/overview': {
      id: '/_protected/_settingsLayout/settings/courses/overview'
      path: '/overview'
      fullPath: '/settings/courses/overview'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCoursesOverviewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCoursesRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/': {
      id: '/_protected/_settingsLayout/settings/emails/'
      path: '/settings/emails'
      fullPath: '/settings/emails/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast'
      path: '/settings/emails/broadcast'
      fullPath: '/settings/emails/broadcast'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms': {
      id: '/_protected/_settingsLayout/settings/emails/forms'
      path: '/settings/emails/forms'
      fullPath: '/settings/emails/forms'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/templates': {
      id: '/_protected/_settingsLayout/settings/emails/templates'
      path: '/settings/emails/templates'
      fullPath: '/settings/emails/templates'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/events/': {
      id: '/_protected/_settingsLayout/settings/events/'
      path: '/settings/events'
      fullPath: '/settings/events/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEventsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/integrations/': {
      id: '/_protected/_settingsLayout/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsIntegrationsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/': {
      id: '/_protected/_settingsLayout/settings/invitation_links/'
      path: '/settings/invitation_links'
      fullPath: '/settings/invitation_links/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new'
      path: '/settings/invitation_links/new'
      fullPath: '/settings/invitation_links/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/live_streams/': {
      id: '/_protected/_settingsLayout/settings/live_streams/'
      path: '/'
      fullPath: '/settings/live_streams/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRoute
    }
    '/_protected/_settingsLayout/settings/live_streams/$id': {
      id: '/_protected/_settingsLayout/settings/live_streams/$id'
      path: '/$id'
      fullPath: '/settings/live_streams/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsIdRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRoute
    }
    '/_protected/_settingsLayout/settings/member_tags/': {
      id: '/_protected/_settingsLayout/settings/member_tags/'
      path: '/settings/member_tags'
      fullPath: '/settings/member_tags/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/member_tags/new': {
      id: '/_protected/_settingsLayout/settings/member_tags/new'
      path: '/settings/member_tags/new'
      fullPath: '/settings/member_tags/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsNewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/activity_logs': {
      id: '/_protected/_settingsLayout/settings/members/activity_logs'
      path: '/settings/members/activity_logs'
      fullPath: '/settings/members/activity_logs'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersActivity_logsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/bulk_import_tasks': {
      id: '/_protected/_settingsLayout/settings/members/bulk_import_tasks'
      path: '/settings/members/bulk_import_tasks'
      fullPath: '/settings/members/bulk_import_tasks'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite': {
      id: '/_protected/_settingsLayout/settings/members/invite'
      path: '/settings/members/invite'
      fullPath: '/settings/members/invite'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/onboarding': {
      id: '/_protected/_settingsLayout/settings/members/onboarding'
      path: '/settings/members/onboarding'
      fullPath: '/settings/members/onboarding'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/moderation/': {
      id: '/_protected/_settingsLayout/settings/moderation/'
      path: '/settings/moderation'
      fullPath: '/settings/moderation/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsModerationIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/moderation/edit': {
      id: '/_protected/_settingsLayout/settings/moderation/edit'
      path: '/settings/moderation/edit'
      fullPath: '/settings/moderation/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsModerationEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/': {
      id: '/_protected/_settingsLayout/settings/newsletter/'
      path: '/'
      fullPath: '/settings/newsletter/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/activate': {
      id: '/_protected/_settingsLayout/settings/newsletter/activate'
      path: '/activate'
      fullPath: '/settings/newsletter/activate'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterActivateRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/onboarding/': {
      id: '/_protected/_settingsLayout/settings/onboarding/'
      path: '/settings/onboarding'
      fullPath: '/settings/onboarding/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsOnboardingIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/': {
      id: '/_protected/_settingsLayout/settings/pages/'
      path: '/settings/pages'
      fullPath: '/settings/pages/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/': {
      id: '/_protected/_settingsLayout/settings/paywalls/'
      path: '/settings/paywalls'
      fullPath: '/settings/paywalls/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/new': {
      id: '/_protected/_settingsLayout/settings/paywalls/new'
      path: '/settings/paywalls/new'
      fullPath: '/settings/paywalls/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/onboarding': {
      id: '/_protected/_settingsLayout/settings/paywalls/onboarding'
      path: '/settings/paywalls/onboarding'
      fullPath: '/settings/paywalls/onboarding'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsOnboardingRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plans/': {
      id: '/_protected/_settingsLayout/settings/plans/'
      path: '/'
      fullPath: '/settings/plans/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlansIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlansRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/': {
      id: '/_protected/_settingsLayout/settings/plus/'
      path: '/settings/plus'
      fullPath: '/settings/plus/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/app-settings': {
      id: '/_protected/_settingsLayout/settings/plus/app-settings'
      path: '/settings/plus/app-settings'
      fullPath: '/settings/plus/app-settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusAppSettingsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/insights': {
      id: '/_protected/_settingsLayout/settings/plus/insights'
      path: '/settings/plus/insights'
      fullPath: '/settings/plus/insights'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusInsightsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/lite': {
      id: '/_protected/_settingsLayout/settings/plus/lite'
      path: '/settings/plus/lite'
      fullPath: '/settings/plus/lite'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusLiteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications'
      path: '/settings/plus/push-notifications'
      fullPath: '/settings/plus/push-notifications'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/posts/': {
      id: '/_protected/_settingsLayout/settings/posts/'
      path: '/settings/posts'
      fullPath: '/settings/posts/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPostsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/posts/bulk_actions': {
      id: '/_protected/_settingsLayout/settings/posts/bulk_actions'
      path: '/settings/posts/bulk_actions'
      fullPath: '/settings/posts/bulk_actions'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/profile_fields/': {
      id: '/_protected/_settingsLayout/settings/profile_fields/'
      path: '/'
      fullPath: '/settings/profile_fields/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute
    }
    '/_protected/_settingsLayout/settings/profile_fields/manage': {
      id: '/_protected/_settingsLayout/settings/profile_fields/manage'
      path: '/manage'
      fullPath: '/settings/profile_fields/manage'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsManageRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute
    }
    '/_protected/_settingsLayout/settings/profile_fields/new': {
      id: '/_protected/_settingsLayout/settings/profile_fields/new'
      path: '/new'
      fullPath: '/settings/profile_fields/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsNewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute
    }
    '/_protected/_settingsLayout/settings/segments/': {
      id: '/_protected/_settingsLayout/settings/segments/'
      path: '/'
      fullPath: '/settings/segments/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSegmentsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsSegmentsRouteRoute
    }
    '/_protected/_settingsLayout/settings/segments/$id': {
      id: '/_protected/_settingsLayout/settings/segments/$id'
      path: '/$id'
      fullPath: '/settings/segments/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSegmentsIdRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsSegmentsRouteRoute
    }
    '/_protected/_settingsLayout/settings/spaces/$': {
      id: '/_protected/_settingsLayout/settings/spaces/$'
      path: '/$'
      fullPath: '/settings/spaces/$'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSpacesSplatRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsSpacesRouteRoute
    }
    '/_protected/_settingsLayout/settings/sso/': {
      id: '/_protected/_settingsLayout/settings/sso/'
      path: '/settings/sso'
      fullPath: '/settings/sso/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsSsoIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/theme/': {
      id: '/_protected/_settingsLayout/settings/theme/'
      path: '/settings/theme'
      fullPath: '/settings/theme/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsThemeIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/topics/': {
      id: '/_protected/_settingsLayout/settings/topics/'
      path: '/'
      fullPath: '/settings/topics/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsTopicsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsTopicsRouteRoute
    }
    '/_protected/_settingsLayout/settings/topics/new': {
      id: '/_protected/_settingsLayout/settings/topics/new'
      path: '/new'
      fullPath: '/settings/topics/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsTopicsNewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsTopicsRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/': {
      id: '/_protected/_settingsLayout/settings/workflows/'
      path: '/'
      fullPath: '/settings/workflows/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/history': {
      id: '/_protected/_settingsLayout/settings/workflows/history'
      path: '/history'
      fullPath: '/settings/workflows/history'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsHistoryRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new': {
      id: '/_protected/_settingsLayout/settings/workflows/new'
      path: '/new'
      fullPath: '/settings/workflows/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRoute
    }
    '/_protected/admin/audience/$sqid/': {
      id: '/_protected/admin/audience/$sqid/'
      path: '/admin/audience/$sqid'
      fullPath: '/admin/audience/$sqid/'
      preLoaderRoute: typeof ProtectedAdminAudienceSqidIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/admin/audience/$sqid/$': {
      id: '/_protected/admin/audience/$sqid/$'
      path: '/admin/audience/$sqid/$'
      fullPath: '/admin/audience/$sqid/$'
      preLoaderRoute: typeof ProtectedAdminAudienceSqidSplatRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/ai/bots/$botId/': {
      id: '/_protected/ai/bots/$botId/'
      path: '/$botId'
      fullPath: '/ai/bots/$botId/'
      preLoaderRoute: typeof ProtectedAiBotsBotIdIndexRouteImport
      parentRoute: typeof ProtectedAiBotsRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid': {
      id: '/_protected/settings/admin/audience/$sqid'
      path: '/settings/admin/audience/$sqid'
      fullPath: '/settings/admin/audience/$sqid'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/settings/inbox/ai/': {
      id: '/_protected/settings/inbox/ai/'
      path: '/'
      fullPath: '/settings/inbox/ai/'
      preLoaderRoute: typeof ProtectedSettingsInboxAiIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxAiRouteRoute
    }
    '/_protected/settings/inbox/chat-threads/$id': {
      id: '/_protected/settings/inbox/chat-threads/$id'
      path: '/$id'
      fullPath: '/settings/inbox/chat-threads/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxChatThreadsIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxChatThreadsRouteRoute
    }
    '/_protected/settings/inbox/connection-requests/': {
      id: '/_protected/settings/inbox/connection-requests/'
      path: '/'
      fullPath: '/settings/inbox/connection-requests/'
      preLoaderRoute: typeof ProtectedSettingsInboxConnectionRequestsIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxConnectionRequestsRouteRoute
    }
    '/_protected/settings/inbox/connection-requests/$id': {
      id: '/_protected/settings/inbox/connection-requests/$id'
      path: '/$id'
      fullPath: '/settings/inbox/connection-requests/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxConnectionRequestsIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxConnectionRequestsRouteRoute
    }
    '/_protected/settings/inbox/course-comments/': {
      id: '/_protected/settings/inbox/course-comments/'
      path: '/'
      fullPath: '/settings/inbox/course-comments/'
      preLoaderRoute: typeof ProtectedSettingsInboxCourseCommentsIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxCourseCommentsRouteRoute
    }
    '/_protected/settings/inbox/course-comments/$chatRoomUuid': {
      id: '/_protected/settings/inbox/course-comments/$chatRoomUuid'
      path: '/$chatRoomUuid'
      fullPath: '/settings/inbox/course-comments/$chatRoomUuid'
      preLoaderRoute: typeof ProtectedSettingsInboxCourseCommentsChatRoomUuidRouteImport
      parentRoute: typeof ProtectedSettingsInboxCourseCommentsRouteRoute
    }
    '/_protected/settings/inbox/human-support/': {
      id: '/_protected/settings/inbox/human-support/'
      path: '/'
      fullPath: '/settings/inbox/human-support/'
      preLoaderRoute: typeof ProtectedSettingsInboxHumanSupportIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxHumanSupportRouteRoute
    }
    '/_protected/settings/inbox/messages/': {
      id: '/_protected/settings/inbox/messages/'
      path: '/'
      fullPath: '/settings/inbox/messages/'
      preLoaderRoute: typeof ProtectedSettingsInboxMessagesIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxMessagesRouteRoute
    }
    '/_protected/settings/inbox/messages/$uuid': {
      id: '/_protected/settings/inbox/messages/$uuid'
      path: '/$uuid'
      fullPath: '/settings/inbox/messages/$uuid'
      preLoaderRoute: typeof ProtectedSettingsInboxMessagesUuidRouteImport
      parentRoute: typeof ProtectedSettingsInboxMessagesRouteRoute
    }
    '/_protected/settings/inbox/moderation/': {
      id: '/_protected/settings/inbox/moderation/'
      path: '/'
      fullPath: '/settings/inbox/moderation/'
      preLoaderRoute: typeof ProtectedSettingsInboxModerationIndexRouteImport
      parentRoute: typeof ProtectedSettingsInboxModerationRouteRoute
    }
    '/_protected/settings/inbox/moderation/$id': {
      id: '/_protected/settings/inbox/moderation/$id'
      path: '/$id'
      fullPath: '/settings/inbox/moderation/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxModerationIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxModerationRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/'
      path: '/'
      fullPath: '/c/$spaceSlug/'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/invite': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLayout/invite'
      path: '/invite'
      fullPath: '/c/$spaceSlug/invite'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/access_groups/$id/': {
      id: '/_protected/_settingsLayout/settings/access_groups/$id/'
      path: '/settings/access_groups/$id'
      fullPath: '/settings/access_groups/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/access_groups/$id/edit': {
      id: '/_protected/_settingsLayout/settings/access_groups/$id/edit'
      path: '/settings/access_groups/$id/edit'
      fullPath: '/settings/access_groups/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/agents/': {
      id: '/_protected/_settingsLayout/settings/ai-agents/agents/'
      path: '/settings/ai-agents/agents'
      fullPath: '/settings/ai-agents/agents/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId'
      path: '/settings/ai-agents/edit/$botPublicId'
      fullPath: '/settings/ai-agents/edit/$botPublicId'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/knowledge/': {
      id: '/_protected/_settingsLayout/settings/ai-agents/knowledge/'
      path: '/settings/ai-agents/knowledge'
      fullPath: '/settings/ai-agents/knowledge/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-inbox/conversations/$id': {
      id: '/_protected/_settingsLayout/settings/ai-inbox/conversations/$id'
      path: '/settings/ai-inbox/conversations/$id'
      fullPath: '/settings/ai-inbox/conversations/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiInboxConversationsIdRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/$id/edit': {
      id: '/_protected/_settingsLayout/settings/coupons/$id/edit'
      path: '/settings/coupons/$id/edit'
      fullPath: '/settings/coupons/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/new/': {
      id: '/_protected/_settingsLayout/settings/coupons/new/'
      path: '/'
      fullPath: '/settings/coupons/new/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/new/$tab': {
      id: '/_protected/_settingsLayout/settings/coupons/new/$tab'
      path: '/$tab'
      fullPath: '/settings/coupons/new/$tab'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewTabRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/courses/$id/edit': {
      id: '/_protected/_settingsLayout/settings/courses/$id/edit'
      path: '/$id/edit'
      fullPath: '/settings/courses/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCoursesIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCoursesRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/'
      path: '/'
      fullPath: '/settings/emails/broadcast/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id'
      path: '/$id'
      fullPath: '/settings/emails/broadcast/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms/': {
      id: '/_protected/_settingsLayout/settings/emails/forms/'
      path: '/'
      fullPath: '/settings/emails/forms/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms/$id': {
      id: '/_protected/_settingsLayout/settings/emails/forms/$id'
      path: '/$id'
      fullPath: '/settings/emails/forms/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms/new': {
      id: '/_protected/_settingsLayout/settings/emails/forms/new'
      path: '/new'
      fullPath: '/settings/emails/forms/new'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsNewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/settings/': {
      id: '/_protected/_settingsLayout/settings/emails/settings/'
      path: '/settings/emails/settings'
      fullPath: '/settings/emails/settings/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsSettingsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/templates/': {
      id: '/_protected/_settingsLayout/settings/emails/templates/'
      path: '/'
      fullPath: '/settings/emails/templates/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/templates/$id': {
      id: '/_protected/_settingsLayout/settings/emails/templates/$id'
      path: '/$id'
      fullPath: '/settings/emails/templates/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit'
      path: '/settings/invitation_links/$id/edit'
      fullPath: '/settings/invitation_links/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new/': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new/'
      path: '/'
      fullPath: '/settings/invitation_links/new/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new/access': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new/access'
      path: '/access'
      fullPath: '/settings/invitation_links/new/access'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new/details': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new/details'
      path: '/details'
      fullPath: '/settings/invitation_links/new/details'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new/paywalls': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new/paywalls'
      path: '/paywalls'
      fullPath: '/settings/invitation_links/new/paywalls'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/new/subscription': {
      id: '/_protected/_settingsLayout/settings/invitation_links/new/subscription'
      path: '/subscription'
      fullPath: '/settings/invitation_links/new/subscription'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/member_tags/$id/edit': {
      id: '/_protected/_settingsLayout/settings/member_tags/$id/edit'
      path: '/settings/member_tags/$id/edit'
      fullPath: '/settings/member_tags/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/': {
      id: '/_protected/_settingsLayout/settings/members/invite/'
      path: '/'
      fullPath: '/settings/members/invite/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/access': {
      id: '/_protected/_settingsLayout/settings/members/invite/access'
      path: '/access'
      fullPath: '/settings/members/invite/access'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteAccessRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/details': {
      id: '/_protected/_settingsLayout/settings/members/invite/details'
      path: '/details'
      fullPath: '/settings/members/invite/details'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteDetailsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/emails': {
      id: '/_protected/_settingsLayout/settings/members/invite/emails'
      path: '/emails'
      fullPath: '/settings/members/invite/emails'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteEmailsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/newsletters': {
      id: '/_protected/_settingsLayout/settings/members/invite/newsletters'
      path: '/newsletters'
      fullPath: '/settings/members/invite/newsletters'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteNewslettersRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/paywalls': {
      id: '/_protected/_settingsLayout/settings/members/invite/paywalls'
      path: '/paywalls'
      fullPath: '/settings/members/invite/paywalls'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInvitePaywallsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/invite/permissions': {
      id: '/_protected/_settingsLayout/settings/members/invite/permissions'
      path: '/permissions'
      fullPath: '/settings/members/invite/permissions'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersInvitePermissionsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/onboarding/': {
      id: '/_protected/_settingsLayout/settings/members/onboarding/'
      path: '/'
      fullPath: '/settings/members/onboarding/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute
    }
    '/_protected/_settingsLayout/settings/members/onboarding/$tab': {
      id: '/_protected/_settingsLayout/settings/members/onboarding/$tab'
      path: '/$tab'
      fullPath: '/settings/members/onboarding/$tab'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingTabRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/lists/': {
      id: '/_protected/_settingsLayout/settings/newsletter/lists/'
      path: '/lists'
      fullPath: '/settings/newsletter/lists/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterListsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/'
      path: '/posts'
      fullPath: '/settings/newsletter/posts/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/$id': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/$id'
      path: '/posts/$id'
      fullPath: '/settings/newsletter/posts/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id'
      path: '/settings/pages/edit/$id'
      fullPath: '/settings/pages/edit/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/$id/edit': {
      id: '/_protected/_settingsLayout/settings/paywalls/$id/edit'
      path: '/settings/paywalls/$id/edit'
      fullPath: '/settings/paywalls/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/new/{-$tab}': {
      id: '/_protected/_settingsLayout/settings/paywalls/new/{-$tab}'
      path: '/{-$tab}'
      fullPath: '/settings/paywalls/new/{-$tab}'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125RouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/'
      path: '/'
      fullPath: '/settings/plus/push-notifications/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/$id': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/$id'
      path: '/$id'
      fullPath: '/settings/plus/push-notifications/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute
    }
    '/_protected/_settingsLayout/settings/profile_fields/$id/edit': {
      id: '/_protected/_settingsLayout/settings/profile_fields/$id/edit'
      path: '/$id/edit'
      fullPath: '/settings/profile_fields/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute
    }
    '/_protected/_settingsLayout/settings/topics/$topicId/edit': {
      id: '/_protected/_settingsLayout/settings/topics/$topicId/edit'
      path: '/$topicId/edit'
      fullPath: '/settings/topics/$topicId/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsTopicsTopicIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsTopicsRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/edit/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/edit/$id'
      path: '/edit/$id'
      fullPath: '/settings/workflows/edit/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/'
      path: '/'
      fullPath: '/settings/workflows/new/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/select_type': {
      id: '/_protected/_settingsLayout/settings/workflows/new/select_type'
      path: '/select_type'
      fullPath: '/settings/workflows/new/select_type'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/view/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/view/$id'
      path: '/view/$id'
      fullPath: '/settings/workflows/view/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRoute
    }
    '/_protected/ai/bots/$botId/conversations/$conversationId': {
      id: '/_protected/ai/bots/$botId/conversations/$conversationId'
      path: '/$botId/conversations/$conversationId'
      fullPath: '/ai/bots/$botId/conversations/$conversationId'
      preLoaderRoute: typeof ProtectedAiBotsBotIdConversationsConversationIdRouteImport
      parentRoute: typeof ProtectedAiBotsRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/': {
      id: '/_protected/settings/admin/audience/$sqid/'
      path: '/'
      fullPath: '/settings/admin/audience/$sqid/'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidIndexRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/$': {
      id: '/_protected/settings/admin/audience/$sqid/$'
      path: '/$'
      fullPath: '/settings/admin/audience/$sqid/$'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidSplatRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/access': {
      id: '/_protected/settings/admin/audience/$sqid/access'
      path: '/access'
      fullPath: '/settings/admin/audience/$sqid/access'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidAccessRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/activity_logs': {
      id: '/_protected/settings/admin/audience/$sqid/activity_logs'
      path: '/activity_logs'
      fullPath: '/settings/admin/audience/$sqid/activity_logs'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidActivity_logsRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/affiliate': {
      id: '/_protected/settings/admin/audience/$sqid/affiliate'
      path: '/affiliate'
      fullPath: '/settings/admin/audience/$sqid/affiliate'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidAffiliateRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/gamification': {
      id: '/_protected/settings/admin/audience/$sqid/gamification'
      path: '/gamification'
      fullPath: '/settings/admin/audience/$sqid/gamification'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidGamificationRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/info': {
      id: '/_protected/settings/admin/audience/$sqid/info'
      path: '/info'
      fullPath: '/settings/admin/audience/$sqid/info'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidInfoRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/notes': {
      id: '/_protected/settings/admin/audience/$sqid/notes'
      path: '/notes'
      fullPath: '/settings/admin/audience/$sqid/notes'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidNotesRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/inbox/ai/conversations/$id': {
      id: '/_protected/settings/inbox/ai/conversations/$id'
      path: '/conversations/$id'
      fullPath: '/settings/inbox/ai/conversations/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxAiConversationsIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxAiRouteRoute
    }
    '/_protected/settings/inbox/human-support/conversations/$id': {
      id: '/_protected/settings/inbox/human-support/conversations/$id'
      path: '/conversations/$id'
      fullPath: '/settings/inbox/human-support/conversations/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxHumanSupportConversationsIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxHumanSupportRouteRoute
    }
    '/_protected/settings/inbox/messages/bot/$id': {
      id: '/_protected/settings/inbox/messages/bot/$id'
      path: '/bot/$id'
      fullPath: '/settings/inbox/messages/bot/$id'
      preLoaderRoute: typeof ProtectedSettingsInboxMessagesBotIdRouteImport
      parentRoute: typeof ProtectedSettingsInboxMessagesRouteRoute
    }
    '/_protected/settings/inbox/priority/$kind/$uuid': {
      id: '/_protected/settings/inbox/priority/$kind/$uuid'
      path: '/$kind/$uuid'
      fullPath: '/settings/inbox/priority/$kind/$uuid'
      preLoaderRoute: typeof ProtectedSettingsInboxPriorityKindUuidRouteImport
      parentRoute: typeof ProtectedSettingsInboxPriorityRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/audience': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/audience'
      path: '/audience'
      fullPath: '/settings/ai-agents/edit/$botPublicId/audience'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/automations': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/automations'
      path: '/automations'
      fullPath: '/settings/ai-agents/edit/$botPublicId/automations'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/behavior': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/behavior'
      path: '/behavior'
      fullPath: '/settings/ai-agents/edit/$botPublicId/behavior'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/customize': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/customize'
      path: '/customize'
      fullPath: '/settings/ai-agents/edit/$botPublicId/customize'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge': {
      id: '/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge'
      path: '/knowledge'
      fullPath: '/settings/ai-agents/edit/$botPublicId/knowledge'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/$id/edit/': {
      id: '/_protected/_settingsLayout/settings/coupons/$id/edit/'
      path: '/'
      fullPath: '/settings/coupons/$id/edit/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/coupons/$id/edit/$tab': {
      id: '/_protected/_settingsLayout/settings/coupons/$id/edit/$tab'
      path: '/$tab'
      fullPath: '/settings/coupons/$id/edit/$tab'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditTabRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/'
      path: '/'
      fullPath: '/settings/emails/broadcast/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/content': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/content'
      path: '/content'
      fullPath: '/settings/emails/broadcast/$id/content'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/edit': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/edit'
      path: '/edit'
      fullPath: '/settings/emails/broadcast/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/view': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/view'
      path: '/view'
      fullPath: '/settings/emails/broadcast/$id/view'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/visual-builder': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/visual-builder'
      path: '/visual-builder'
      fullPath: '/settings/emails/broadcast/$id/visual-builder'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms/$id/': {
      id: '/_protected/_settingsLayout/settings/emails/forms/$id/'
      path: '/'
      fullPath: '/settings/emails/forms/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/forms/$id/$tab': {
      id: '/_protected/_settingsLayout/settings/emails/forms/$id/$tab'
      path: '/$tab'
      fullPath: '/settings/emails/forms/$id/$tab'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdTabRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit/': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit/'
      path: '/'
      fullPath: '/settings/invitation_links/$id/edit/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit/access': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit/access'
      path: '/access'
      fullPath: '/settings/invitation_links/$id/edit/access'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit/details': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit/details'
      path: '/details'
      fullPath: '/settings/invitation_links/$id/edit/details'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit/paywalls': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit/paywalls'
      path: '/paywalls'
      fullPath: '/settings/invitation_links/$id/edit/paywalls'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/invitation_links/$id/edit/subscription': {
      id: '/_protected/_settingsLayout/settings/invitation_links/$id/edit/subscription'
      path: '/subscription'
      fullPath: '/settings/invitation_links/$id/edit/subscription'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/lists/$listId/': {
      id: '/_protected/_settingsLayout/settings/newsletter/lists/$listId/'
      path: '/lists/$listId'
      fullPath: '/settings/newsletter/lists/$listId/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/$id/': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/$id/'
      path: '/'
      fullPath: '/settings/newsletter/posts/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/$id/content': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/$id/content'
      path: '/content'
      fullPath: '/settings/newsletter/posts/$id/content'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/$id/overview': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/$id/overview'
      path: '/overview'
      fullPath: '/settings/newsletter/posts/$id/overview'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/newsletter/posts/$id/settings': {
      id: '/_protected/_settingsLayout/settings/newsletter/posts/$id/settings'
      path: '/settings'
      fullPath: '/settings/newsletter/posts/$id/settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/'
      path: '/'
      fullPath: '/settings/pages/edit/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings'
      path: '/settings'
      fullPath: '/settings/pages/edit/$id/settings'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/$id/edit/{-$tab}': {
      id: '/_protected/_settingsLayout/settings/paywalls/$id/edit/{-$tab}'
      path: '/{-$tab}'
      fullPath: '/settings/paywalls/$id/edit/{-$tab}'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125RouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/new/checkout/customization': {
      id: '/_protected/_settingsLayout/settings/paywalls/new/checkout/customization'
      path: '/checkout/customization'
      fullPath: '/settings/paywalls/new/checkout/customization'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/new/upsell/customization': {
      id: '/_protected/_settingsLayout/settings/paywalls/new/upsell/customization'
      path: '/upsell/customization'
      fullPath: '/settings/paywalls/new/upsell/customization'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/$id/edit': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/$id/edit'
      path: '/edit'
      fullPath: '/settings/plus/push-notifications/$id/edit'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view'
      path: '/view'
      fullPath: '/settings/plus/push-notifications/$id/view'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/edit/$id/': {
      id: '/_protected/_settingsLayout/settings/workflows/edit/$id/'
      path: '/'
      fullPath: '/settings/workflows/edit/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id'
      path: '/dynamic/$id'
      fullPath: '/settings/workflows/new/dynamic/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/one_time/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/new/one_time/$id'
      path: '/one_time/$id'
      fullPath: '/settings/workflows/new/one_time/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/preview/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/new/preview/$id'
      path: '/preview/$id'
      fullPath: '/settings/workflows/new/preview/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id': {
      id: '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id'
      path: '/scheduled/$id'
      fullPath: '/settings/workflows/new/scheduled/$id'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/view/$id/': {
      id: '/_protected/_settingsLayout/settings/workflows/view/$id/'
      path: '/'
      fullPath: '/settings/workflows/view/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/view/$id/runs': {
      id: '/_protected/_settingsLayout/settings/workflows/view/$id/runs'
      path: '/runs'
      fullPath: '/settings/workflows/view/$id/runs'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/billing/': {
      id: '/_protected/settings/admin/audience/$sqid/billing/'
      path: '/billing'
      fullPath: '/settings/admin/audience/$sqid/billing/'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidBillingIndexRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/settings/courses/$id/lessons/$lessonId/edit': {
      id: '/_protected/settings/courses/$id/lessons/$lessonId/edit'
      path: '/settings/courses/$id/lessons/$lessonId/edit'
      fullPath: '/settings/courses/$id/lessons/$lessonId/edit'
      preLoaderRoute: typeof ProtectedSettingsCoursesIdLessonsLessonIdEditRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/'
      path: '/'
      fullPath: '/settings/emails/broadcast/$id/view/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute
    }
    '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/analytics': {
      id: '/_protected/_settingsLayout/settings/emails/broadcast/$id/view/analytics'
      path: '/analytics'
      fullPath: '/settings/emails/broadcast/$id/view/analytics'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/'
      path: '/'
      fullPath: '/settings/pages/edit/$id/settings/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/code_snippets': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/code_snippets'
      path: '/code_snippets'
      fullPath: '/settings/pages/edit/$id/settings/code_snippets'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/defaults': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/defaults'
      path: '/defaults'
      fullPath: '/settings/pages/edit/$id/settings/defaults'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/navigation': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/navigation'
      path: '/navigation'
      fullPath: '/settings/pages/edit/$id/settings/navigation'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/redirects': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/redirects'
      path: '/redirects'
      fullPath: '/settings/pages/edit/$id/settings/redirects'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/pages/edit/$id/settings/seo': {
      id: '/_protected/_settingsLayout/settings/pages/edit/$id/settings/seo'
      path: '/seo'
      fullPath: '/settings/pages/edit/$id/settings/seo'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/$id/edit/checkout/customization': {
      id: '/_protected/_settingsLayout/settings/paywalls/$id/edit/checkout/customization'
      path: '/checkout/customization'
      fullPath: '/settings/paywalls/$id/edit/checkout/customization'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/paywalls/$id/edit/upsell/customization': {
      id: '/_protected/_settingsLayout/settings/paywalls/$id/edit/upsell/customization'
      path: '/upsell/customization'
      fullPath: '/settings/paywalls/$id/edit/upsell/customization'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/'
      path: '/'
      fullPath: '/settings/plus/push-notifications/$id/view/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute
    }
    '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/analytics': {
      id: '/_protected/_settingsLayout/settings/plus/push-notifications/$id/view/analytics'
      path: '/analytics'
      fullPath: '/settings/plus/push-notifications/$id/view/analytics'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId': {
      id: '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId'
      path: '/send-email/$broadcastId'
      fullPath: '/settings/workflows/edit/$id/send-email/$broadcastId'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/'
      path: '/'
      fullPath: '/settings/workflows/new/dynamic/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/'
      path: '/'
      fullPath: '/settings/workflows/new/one_time/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/'
      path: '/'
      fullPath: '/settings/workflows/new/scheduled/$id/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute
    }
    '/_protected/settings/admin/audience/$sqid/billing/subscriptions/new': {
      id: '/_protected/settings/admin/audience/$sqid/billing/subscriptions/new'
      path: '/billing/subscriptions/new'
      fullPath: '/settings/admin/audience/$sqid/billing/subscriptions/new'
      preLoaderRoute: typeof ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRouteImport
      parentRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/sections/$sectionId/lessons/$lessonId'
      path: '/sections/$sectionId/lessons/$lessonId'
      fullPath: '/c/$spaceSlug/sections/$sectionId/lessons/$lessonId'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/': {
      id: '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/'
      path: '/'
      fullPath: '/settings/workflows/edit/$id/send-email/$broadcastId/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder': {
      id: '/_protected/_settingsLayout/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
      path: '/visual-builder'
      fullPath: '/settings/workflows/edit/$id/send-email/$broadcastId/visual-builder'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId': {
      id: '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId'
      path: '/send-email/$broadcastId'
      fullPath: '/settings/workflows/new/dynamic/$id/send-email/$broadcastId'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId': {
      id: '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId'
      path: '/send-email/$broadcastId'
      fullPath: '/settings/workflows/new/one_time/$id/send-email/$broadcastId'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId': {
      id: '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId'
      path: '/send-email/$broadcastId'
      fullPath: '/settings/workflows/new/scheduled/$id/send-email/$broadcastId'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute
    }
    '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/edit-lesson/sections/$sectionId/lessons/$lessonId': {
      id: '/_protected/_dynamicLayout/c/$spaceSlug/_spaceLockGuard/edit-lesson/sections/$sectionId/lessons/$lessonId'
      path: '/edit-lesson/sections/$sectionId/lessons/$lessonId'
      fullPath: '/c/$spaceSlug/edit-lesson/sections/$sectionId/lessons/$lessonId'
      preLoaderRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRouteImport
      parentRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/'
      path: '/'
      fullPath: '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder': {
      id: '/_protected/_settingsLayout/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
      path: '/visual-builder'
      fullPath: '/settings/workflows/new/dynamic/$id/send-email/$broadcastId/visual-builder'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/'
      path: '/'
      fullPath: '/settings/workflows/new/one_time/$id/send-email/$broadcastId/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder': {
      id: '/_protected/_settingsLayout/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
      path: '/visual-builder'
      fullPath: '/settings/workflows/new/one_time/$id/send-email/$broadcastId/visual-builder'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/': {
      id: '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/'
      path: '/'
      fullPath: '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute
    }
    '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder': {
      id: '/_protected/_settingsLayout/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'
      path: '/visual-builder'
      fullPath: '/settings/workflows/new/scheduled/$id/send-email/$broadcastId/visual-builder'
      preLoaderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRouteImport
      parentRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute
    }
  }
}

interface MinimalLiveRoomSlugProtectedRouteRouteChildren {
  MinimalLiveRoomSlugProtectedMobileRoute: typeof MinimalLiveRoomSlugProtectedMobileRoute
  MinimalLiveRoomSlugProtectedNot_supportedRoute: typeof MinimalLiveRoomSlugProtectedNot_supportedRoute
  MinimalLiveRoomSlugProtectedIndexRoute: typeof MinimalLiveRoomSlugProtectedIndexRoute
}

const MinimalLiveRoomSlugProtectedRouteRouteChildren: MinimalLiveRoomSlugProtectedRouteRouteChildren =
  {
    MinimalLiveRoomSlugProtectedMobileRoute:
      MinimalLiveRoomSlugProtectedMobileRoute,
    MinimalLiveRoomSlugProtectedNot_supportedRoute:
      MinimalLiveRoomSlugProtectedNot_supportedRoute,
    MinimalLiveRoomSlugProtectedIndexRoute:
      MinimalLiveRoomSlugProtectedIndexRoute,
  }

const MinimalLiveRoomSlugProtectedRouteRouteWithChildren =
  MinimalLiveRoomSlugProtectedRouteRoute._addFileChildren(
    MinimalLiveRoomSlugProtectedRouteRouteChildren,
  )

interface MinimalLiveRoomSlugRouteRouteChildren {
  MinimalLiveRoomSlugProtectedRouteRoute: typeof MinimalLiveRoomSlugProtectedRouteRouteWithChildren
  MinimalLiveRoomSlugPublicRoute: typeof MinimalLiveRoomSlugPublicRoute
  MinimalLiveRoomSlugRecordRoute: typeof MinimalLiveRoomSlugRecordRoute
}

const MinimalLiveRoomSlugRouteRouteChildren: MinimalLiveRoomSlugRouteRouteChildren =
  {
    MinimalLiveRoomSlugProtectedRouteRoute:
      MinimalLiveRoomSlugProtectedRouteRouteWithChildren,
    MinimalLiveRoomSlugPublicRoute: MinimalLiveRoomSlugPublicRoute,
    MinimalLiveRoomSlugRecordRoute: MinimalLiveRoomSlugRecordRoute,
  }

const MinimalLiveRoomSlugRouteRouteWithChildren =
  MinimalLiveRoomSlugRouteRoute._addFileChildren(
    MinimalLiveRoomSlugRouteRouteChildren,
  )

interface MinimalRouteRouteChildren {
  MinimalDownload_appRoute: typeof MinimalDownload_appRoute
  MinimalEclipseRoute: typeof MinimalEclipseRoute
  MinimalTwo_faRoute: typeof MinimalTwo_faRoute
  MinimalLiveRoomSlugRouteRoute: typeof MinimalLiveRoomSlugRouteRouteWithChildren
  MinimalSettingsCancelPlanRoute: typeof MinimalSettingsCancelPlanRoute
  MinimalQuestionsAiIndexRoute: typeof MinimalQuestionsAiIndexRoute
  MinimalCustom_loginsDebug_sessionsUuidRoute: typeof MinimalCustom_loginsDebug_sessionsUuidRoute
  MinimalSettingsMembersOnboardingPreviewRoute: typeof MinimalSettingsMembersOnboardingPreviewRoute
}

const MinimalRouteRouteChildren: MinimalRouteRouteChildren = {
  MinimalDownload_appRoute: MinimalDownload_appRoute,
  MinimalEclipseRoute: MinimalEclipseRoute,
  MinimalTwo_faRoute: MinimalTwo_faRoute,
  MinimalLiveRoomSlugRouteRoute: MinimalLiveRoomSlugRouteRouteWithChildren,
  MinimalSettingsCancelPlanRoute: MinimalSettingsCancelPlanRoute,
  MinimalQuestionsAiIndexRoute: MinimalQuestionsAiIndexRoute,
  MinimalCustom_loginsDebug_sessionsUuidRoute:
    MinimalCustom_loginsDebug_sessionsUuidRoute,
  MinimalSettingsMembersOnboardingPreviewRoute:
    MinimalSettingsMembersOnboardingPreviewRoute,
}

const MinimalRouteRouteWithChildren = MinimalRouteRoute._addFileChildren(
  MinimalRouteRouteChildren,
)

interface ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteChildren {
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute
}

const ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteChildren: ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteChildren =
  {
    ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLayoutInviteRoute,
    ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLayoutIndexRoute,
  }

const ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteWithChildren =
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute._addFileChildren(
    ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteChildren,
  )

interface ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteChildren {
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute
}

const ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteChildren: ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteChildren =
  {
    ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardSectionsSectionIdLessonsLessonIdRoute,
    ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardEditLessonSectionsSectionIdLessonsLessonIdRoute,
  }

const ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteWithChildren =
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute._addFileChildren(
    ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteChildren,
  )

interface ProtectedDynamicLayoutCSpaceSlugRouteRouteChildren {
  ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteWithChildren
  ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute: typeof ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteWithChildren
  ProtectedDynamicLayoutCSpaceSlugPostSlugRoute: typeof ProtectedDynamicLayoutCSpaceSlugPostSlugRoute
}

const ProtectedDynamicLayoutCSpaceSlugRouteRouteChildren: ProtectedDynamicLayoutCSpaceSlugRouteRouteChildren =
  {
    ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLayoutRouteRouteWithChildren,
    ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRoute:
      ProtectedDynamicLayoutCSpaceSlugSpaceLockGuardRouteRouteWithChildren,
    ProtectedDynamicLayoutCSpaceSlugPostSlugRoute:
      ProtectedDynamicLayoutCSpaceSlugPostSlugRoute,
  }

const ProtectedDynamicLayoutCSpaceSlugRouteRouteWithChildren =
  ProtectedDynamicLayoutCSpaceSlugRouteRoute._addFileChildren(
    ProtectedDynamicLayoutCSpaceSlugRouteRouteChildren,
  )

interface ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteChildren {
  ProtectedDynamicLayoutSSpaceGroupSlugEditRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugEditRoute
  ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute
}

const ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteChildren: ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteChildren =
  {
    ProtectedDynamicLayoutSSpaceGroupSlugEditRoute:
      ProtectedDynamicLayoutSSpaceGroupSlugEditRoute,
    ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute:
      ProtectedDynamicLayoutSSpaceGroupSlugIndexRoute,
  }

const ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteWithChildren =
  ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute._addFileChildren(
    ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteChildren,
  )

interface ProtectedDynamicLayoutRouteRouteChildren {
  ProtectedDynamicLayoutAdminSettingsRoute: typeof ProtectedDynamicLayoutAdminSettingsRoute
  ProtectedDynamicLayoutCoursesRoute: typeof ProtectedDynamicLayoutCoursesRoute
  ProtectedDynamicLayoutEventsRoute: typeof ProtectedDynamicLayoutEventsRoute
  ProtectedDynamicLayoutSearchRoute: typeof ProtectedDynamicLayoutSearchRoute
  ProtectedDynamicLayoutSpacesRoute: typeof ProtectedDynamicLayoutSpacesRoute
  ProtectedDynamicLayoutCSpaceSlugRouteRoute: typeof ProtectedDynamicLayoutCSpaceSlugRouteRouteWithChildren
  ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute: typeof ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteWithChildren
  ProtectedDynamicLayoutUPublicUidRoute: typeof ProtectedDynamicLayoutUPublicUidRoute
}

const ProtectedDynamicLayoutRouteRouteChildren: ProtectedDynamicLayoutRouteRouteChildren =
  {
    ProtectedDynamicLayoutAdminSettingsRoute:
      ProtectedDynamicLayoutAdminSettingsRoute,
    ProtectedDynamicLayoutCoursesRoute: ProtectedDynamicLayoutCoursesRoute,
    ProtectedDynamicLayoutEventsRoute: ProtectedDynamicLayoutEventsRoute,
    ProtectedDynamicLayoutSearchRoute: ProtectedDynamicLayoutSearchRoute,
    ProtectedDynamicLayoutSpacesRoute: ProtectedDynamicLayoutSpacesRoute,
    ProtectedDynamicLayoutCSpaceSlugRouteRoute:
      ProtectedDynamicLayoutCSpaceSlugRouteRouteWithChildren,
    ProtectedDynamicLayoutSSpaceGroupSlugRouteRoute:
      ProtectedDynamicLayoutSSpaceGroupSlugRouteRouteWithChildren,
    ProtectedDynamicLayoutUPublicUidRoute:
      ProtectedDynamicLayoutUPublicUidRoute,
  }

const ProtectedDynamicLayoutRouteRouteWithChildren =
  ProtectedDynamicLayoutRouteRoute._addFileChildren(
    ProtectedDynamicLayoutRouteRouteChildren,
  )

interface ProtectedEmbedCEmbedSpaceSlugRouteRouteChildren {
  ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute: typeof ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute
  ProtectedEmbedCEmbedSpaceSlugIndexRoute: typeof ProtectedEmbedCEmbedSpaceSlugIndexRoute
}

const ProtectedEmbedCEmbedSpaceSlugRouteRouteChildren: ProtectedEmbedCEmbedSpaceSlugRouteRouteChildren =
  {
    ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute:
      ProtectedEmbedCEmbedSpaceSlugEmbedPostSlugRoute,
    ProtectedEmbedCEmbedSpaceSlugIndexRoute:
      ProtectedEmbedCEmbedSpaceSlugIndexRoute,
  }

const ProtectedEmbedCEmbedSpaceSlugRouteRouteWithChildren =
  ProtectedEmbedCEmbedSpaceSlugRouteRoute._addFileChildren(
    ProtectedEmbedCEmbedSpaceSlugRouteRouteChildren,
  )

interface ProtectedEmbedRouteRouteChildren {
  ProtectedEmbedCEmbedSpaceSlugRouteRoute: typeof ProtectedEmbedCEmbedSpaceSlugRouteRouteWithChildren
}

const ProtectedEmbedRouteRouteChildren: ProtectedEmbedRouteRouteChildren = {
  ProtectedEmbedCEmbedSpaceSlugRouteRoute:
    ProtectedEmbedCEmbedSpaceSlugRouteRouteWithChildren,
}

const ProtectedEmbedRouteRouteWithChildren =
  ProtectedEmbedRouteRoute._addFileChildren(ProtectedEmbedRouteRouteChildren)

interface ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteChildren {
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute
  ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute
}

const ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteChildren: ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute:
      ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_commissionsRoute,
    ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute:
      ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_directoryRoute,
    ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute:
      ProtectedSettingsLayoutSettingsAffiliatesLayoutAffiliates_settingsRoute,
  }

const ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteChildren {
  ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute
  ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute
  ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute
}

const ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteChildren: ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute:
      ProtectedSettingsLayoutSettingsBillingLayoutBillingRoute,
    ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute:
      ProtectedSettingsLayoutSettingsBillingLayoutInvoicesRoute,
    ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute:
      ProtectedSettingsLayoutSettingsBillingLayoutPayment_detailsRoute,
  }

const ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsAnalyticsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute
  ProtectedSettingsLayoutSettingsAnalyticsIndexRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsIndexRoute
}

const ProtectedSettingsLayoutSettingsAnalyticsRouteRouteChildren: ProtectedSettingsLayoutSettingsAnalyticsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsAi_agentsRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsCoursesRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsDevicesRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsEventsRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsMembersRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsMessagesRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsPaymentsRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsPost_commentsRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsReviewsRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsSpacesRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsVideosRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsWebsiteRouteRoute,
    ProtectedSettingsLayoutSettingsAnalyticsIndexRoute:
      ProtectedSettingsLayoutSettingsAnalyticsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsAnalyticsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsAnalyticsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsAnalyticsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsApiRouteRouteChildren {
  ProtectedSettingsLayoutSettingsApiNewRouteRoute: typeof ProtectedSettingsLayoutSettingsApiNewRouteRoute
  ProtectedSettingsLayoutSettingsApiIndexRoute: typeof ProtectedSettingsLayoutSettingsApiIndexRoute
}

const ProtectedSettingsLayoutSettingsApiRouteRouteChildren: ProtectedSettingsLayoutSettingsApiRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsApiNewRouteRoute:
      ProtectedSettingsLayoutSettingsApiNewRouteRoute,
    ProtectedSettingsLayoutSettingsApiIndexRoute:
      ProtectedSettingsLayoutSettingsApiIndexRoute,
  }

const ProtectedSettingsLayoutSettingsApiRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsApiRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsApiRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsCoursesRouteRouteChildren {
  ProtectedSettingsLayoutSettingsCoursesOverviewRoute: typeof ProtectedSettingsLayoutSettingsCoursesOverviewRoute
  ProtectedSettingsLayoutSettingsCoursesIndexRoute: typeof ProtectedSettingsLayoutSettingsCoursesIndexRoute
  ProtectedSettingsLayoutSettingsCoursesIdEditRoute: typeof ProtectedSettingsLayoutSettingsCoursesIdEditRoute
}

const ProtectedSettingsLayoutSettingsCoursesRouteRouteChildren: ProtectedSettingsLayoutSettingsCoursesRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsCoursesOverviewRoute:
      ProtectedSettingsLayoutSettingsCoursesOverviewRoute,
    ProtectedSettingsLayoutSettingsCoursesIndexRoute:
      ProtectedSettingsLayoutSettingsCoursesIndexRoute,
    ProtectedSettingsLayoutSettingsCoursesIdEditRoute:
      ProtectedSettingsLayoutSettingsCoursesIdEditRoute,
  }

const ProtectedSettingsLayoutSettingsCoursesRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsCoursesRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsCoursesRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsLive_streamsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsLive_streamsIdRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsIdRoute
  ProtectedSettingsLayoutSettingsLive_streamsIndexRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsIndexRoute
}

const ProtectedSettingsLayoutSettingsLive_streamsRouteRouteChildren: ProtectedSettingsLayoutSettingsLive_streamsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsLive_streamsIdRoute:
      ProtectedSettingsLayoutSettingsLive_streamsIdRoute,
    ProtectedSettingsLayoutSettingsLive_streamsIndexRoute:
      ProtectedSettingsLayoutSettingsLive_streamsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsLive_streamsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsLive_streamsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsLive_streamsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute
  ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute
  ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute
  ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute
}

const ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteChildren: ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIdContentRoute,
    ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIdOverviewRoute,
    ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIdSettingsRoute,
    ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsNewsletterRouteRouteChildren {
  ProtectedSettingsLayoutSettingsNewsletterActivateRoute: typeof ProtectedSettingsLayoutSettingsNewsletterActivateRoute
  ProtectedSettingsLayoutSettingsNewsletterIndexRoute: typeof ProtectedSettingsLayoutSettingsNewsletterIndexRoute
  ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute: typeof ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute
  ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute: typeof ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute
  ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute: typeof ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute
}

const ProtectedSettingsLayoutSettingsNewsletterRouteRouteChildren: ProtectedSettingsLayoutSettingsNewsletterRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsNewsletterActivateRoute:
      ProtectedSettingsLayoutSettingsNewsletterActivateRoute,
    ProtectedSettingsLayoutSettingsNewsletterIndexRoute:
      ProtectedSettingsLayoutSettingsNewsletterIndexRoute,
    ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute:
      ProtectedSettingsLayoutSettingsNewsletterListsIndexRoute,
    ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute:
      ProtectedSettingsLayoutSettingsNewsletterPostsIndexRoute,
    ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute:
      ProtectedSettingsLayoutSettingsNewsletterListsListIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsNewsletterRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsNewsletterRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsNewsletterRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPlansRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPlansIndexRoute: typeof ProtectedSettingsLayoutSettingsPlansIndexRoute
}

const ProtectedSettingsLayoutSettingsPlansRouteRouteChildren: ProtectedSettingsLayoutSettingsPlansRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPlansIndexRoute:
      ProtectedSettingsLayoutSettingsPlansIndexRoute,
  }

const ProtectedSettingsLayoutSettingsPlansRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPlansRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPlansRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute
  ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute
  ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute
  ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute
}

const ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteChildren: ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute:
      ProtectedSettingsLayoutSettingsProfile_fieldsManageRoute,
    ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute:
      ProtectedSettingsLayoutSettingsProfile_fieldsNewRoute,
    ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute:
      ProtectedSettingsLayoutSettingsProfile_fieldsIndexRoute,
    ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute:
      ProtectedSettingsLayoutSettingsProfile_fieldsIdEditRoute,
  }

const ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsSegmentsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsSegmentsIdRoute: typeof ProtectedSettingsLayoutSettingsSegmentsIdRoute
  ProtectedSettingsLayoutSettingsSegmentsIndexRoute: typeof ProtectedSettingsLayoutSettingsSegmentsIndexRoute
}

const ProtectedSettingsLayoutSettingsSegmentsRouteRouteChildren: ProtectedSettingsLayoutSettingsSegmentsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsSegmentsIdRoute:
      ProtectedSettingsLayoutSettingsSegmentsIdRoute,
    ProtectedSettingsLayoutSettingsSegmentsIndexRoute:
      ProtectedSettingsLayoutSettingsSegmentsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsSegmentsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsSegmentsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsSegmentsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsSpacesRouteRouteChildren {
  ProtectedSettingsLayoutSettingsSpacesSplatRoute: typeof ProtectedSettingsLayoutSettingsSpacesSplatRoute
}

const ProtectedSettingsLayoutSettingsSpacesRouteRouteChildren: ProtectedSettingsLayoutSettingsSpacesRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsSpacesSplatRoute:
      ProtectedSettingsLayoutSettingsSpacesSplatRoute,
  }

const ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsSpacesRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsSpacesRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsTopicsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsTopicsNewRoute: typeof ProtectedSettingsLayoutSettingsTopicsNewRoute
  ProtectedSettingsLayoutSettingsTopicsIndexRoute: typeof ProtectedSettingsLayoutSettingsTopicsIndexRoute
  ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute: typeof ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute
}

const ProtectedSettingsLayoutSettingsTopicsRouteRouteChildren: ProtectedSettingsLayoutSettingsTopicsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsTopicsNewRoute:
      ProtectedSettingsLayoutSettingsTopicsNewRoute,
    ProtectedSettingsLayoutSettingsTopicsIndexRoute:
      ProtectedSettingsLayoutSettingsTopicsIndexRoute,
    ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute:
      ProtectedSettingsLayoutSettingsTopicsTopicIdEditRoute,
  }

const ProtectedSettingsLayoutSettingsTopicsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsTopicsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsTopicsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdVisualBuilderRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteWithChildren
}

const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdSendEmailBroadcastIdRouteRouteWithChildren,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdVisualBuilderRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteWithChildren
}

const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdSendEmailBroadcastIdRouteRouteWithChildren,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdVisualBuilderRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteWithChildren
}

const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdSendEmailBroadcastIdRouteRouteWithChildren,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewSelect_typeRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewDynamicIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewOne_timeIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewScheduledIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewPreviewIdRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute:
      ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdVisualBuilderRoute,
    ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteWithChildren
}

const ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsEditIdIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsEditIdSendEmailBroadcastIdRouteRouteWithChildren,
  }

const ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute
  ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute
}

const ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute:
      ProtectedSettingsLayoutSettingsWorkflowsViewIdRunsRoute,
    ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsViewIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsWorkflowsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute
  ProtectedSettingsLayoutSettingsWorkflowsIndexRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsIndexRoute
  ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteWithChildren
}

const ProtectedSettingsLayoutSettingsWorkflowsRouteRouteChildren: ProtectedSettingsLayoutSettingsWorkflowsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsWorkflowsNewRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsNewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute:
      ProtectedSettingsLayoutSettingsWorkflowsHistoryRoute,
    ProtectedSettingsLayoutSettingsWorkflowsIndexRoute:
      ProtectedSettingsLayoutSettingsWorkflowsIndexRoute,
    ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsEditIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsViewIdRouteRouteWithChildren,
  }

const ProtectedSettingsLayoutSettingsWorkflowsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsWorkflowsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsWorkflowsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsCouponsNewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsCouponsNewTabRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewTabRoute
  ProtectedSettingsLayoutSettingsCouponsNewIndexRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewIndexRoute
}

const ProtectedSettingsLayoutSettingsCouponsNewRouteRouteChildren: ProtectedSettingsLayoutSettingsCouponsNewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsCouponsNewTabRoute:
      ProtectedSettingsLayoutSettingsCouponsNewTabRoute,
    ProtectedSettingsLayoutSettingsCouponsNewIndexRoute:
      ProtectedSettingsLayoutSettingsCouponsNewIndexRoute,
  }

const ProtectedSettingsLayoutSettingsCouponsNewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsCouponsNewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsCouponsNewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewAnalyticsRoute,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdViewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdContentRoute,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdEditRoute,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdVisualBuilderRoute,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute
  ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsIdTabRoute,
    ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsFormsNewRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsNewRoute
  ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsFormsNewRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsNewRoute,
    ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteChildren {
  ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute
  ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute
}

const ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteChildren: ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsTemplatesIdRouteRoute,
    ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsTemplatesIndexRoute,
  }

const ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute
  ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute
  ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute
  ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute
  ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute
}

const ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteChildren: ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewAccessRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewDetailsRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewPaywallsRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewSubscriptionRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewIndexRoute,
  }

const ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsMembersInviteRouteRouteChildren {
  ProtectedSettingsLayoutSettingsMembersInviteAccessRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteAccessRoute
  ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute
  ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute
  ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute
  ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute: typeof ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute
  ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute: typeof ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute
  ProtectedSettingsLayoutSettingsMembersInviteIndexRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteIndexRoute
}

const ProtectedSettingsLayoutSettingsMembersInviteRouteRouteChildren: ProtectedSettingsLayoutSettingsMembersInviteRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsMembersInviteAccessRoute:
      ProtectedSettingsLayoutSettingsMembersInviteAccessRoute,
    ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute:
      ProtectedSettingsLayoutSettingsMembersInviteDetailsRoute,
    ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute:
      ProtectedSettingsLayoutSettingsMembersInviteEmailsRoute,
    ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute:
      ProtectedSettingsLayoutSettingsMembersInviteNewslettersRoute,
    ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute:
      ProtectedSettingsLayoutSettingsMembersInvitePaywallsRoute,
    ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute:
      ProtectedSettingsLayoutSettingsMembersInvitePermissionsRoute,
    ProtectedSettingsLayoutSettingsMembersInviteIndexRoute:
      ProtectedSettingsLayoutSettingsMembersInviteIndexRoute,
  }

const ProtectedSettingsLayoutSettingsMembersInviteRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsMembersInviteRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsMembersInviteRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteChildren {
  ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute
  ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute
}

const ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteChildren: ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute:
      ProtectedSettingsLayoutSettingsMembersOnboardingTabRoute,
    ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute:
      ProtectedSettingsLayoutSettingsMembersOnboardingIndexRoute,
  }

const ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route: typeof ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route
  ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute
  ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute
}

const ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteChildren: ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route:
      ProtectedSettingsLayoutSettingsPaywallsNewChar123TabChar125Route,
    ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute:
      ProtectedSettingsLayoutSettingsPaywallsNewCheckoutCustomizationRoute,
    ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute:
      ProtectedSettingsLayoutSettingsPaywallsNewUpsellCustomizationRoute,
  }

const ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute
}

const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteChildren: ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewAnalyticsRoute,
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewIndexRoute,
  }

const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute
}

const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteChildren: ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdViewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdEditRoute,
  }

const ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute
}

const ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteChildren: ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute
}

const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteChildren: ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAudienceRoute,
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdAutomationsRoute,
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdBehaviorRoute,
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdCustomizeRoute,
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdKnowledgeRoute,
  }

const ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteChildren {
  ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute
  ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute
}

const ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteChildren: ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute:
      ProtectedSettingsLayoutSettingsCouponsIdEditTabRoute,
    ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute:
      ProtectedSettingsLayoutSettingsCouponsIdEditIndexRoute,
  }

const ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteChildren {
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute
}

const ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteChildren: ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditAccessRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditDetailsRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditPaywallsRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditSubscriptionRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditIndexRoute,
  }

const ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute
}

const ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteChildren: ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsCode_snippetsRoute,
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsDefaultsRoute,
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsNavigationRoute,
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsRedirectsRoute,
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsSeoRoute,
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsIndexRoute,
  }

const ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute
}

const ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteChildren: ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdSettingsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdIndexRoute,
  }

const ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteChildren,
  )

interface ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteChildren {
  ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route
  ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute
  ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute
}

const ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteChildren: ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route:
      ProtectedSettingsLayoutSettingsPaywallsIdEditChar123TabChar125Route,
    ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute:
      ProtectedSettingsLayoutSettingsPaywallsIdEditCheckoutCustomizationRoute,
    ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute:
      ProtectedSettingsLayoutSettingsPaywallsIdEditUpsellCustomizationRoute,
  }

const ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren =
  ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute._addFileChildren(
    ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteChildren,
  )

interface ProtectedSettingsLayoutRouteRouteChildren {
  ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute: typeof ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute: typeof ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsAnalyticsRouteRoute: typeof ProtectedSettingsLayoutSettingsAnalyticsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsApiRouteRoute: typeof ProtectedSettingsLayoutSettingsApiRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsCoursesRouteRoute: typeof ProtectedSettingsLayoutSettingsCoursesRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsDevelopersRouteRoute: typeof ProtectedSettingsLayoutSettingsDevelopersRouteRoute
  ProtectedSettingsLayoutSettingsFilesRouteRoute: typeof ProtectedSettingsLayoutSettingsFilesRouteRoute
  ProtectedSettingsLayoutSettingsLive_streamsRouteRoute: typeof ProtectedSettingsLayoutSettingsLive_streamsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsNewsletterRouteRoute: typeof ProtectedSettingsLayoutSettingsNewsletterRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPlansRouteRoute: typeof ProtectedSettingsLayoutSettingsPlansRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute: typeof ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsSegmentsRouteRoute: typeof ProtectedSettingsLayoutSettingsSegmentsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsSpacesRouteRoute: typeof ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsTopicsRouteRoute: typeof ProtectedSettingsLayoutSettingsTopicsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsWorkflowsRouteRoute: typeof ProtectedSettingsLayoutSettingsWorkflowsRouteRouteWithChildren
  ProtectedSettingsLayoutAudienceManageRoute: typeof ProtectedSettingsLayoutAudienceManageRoute
  ProtectedSettingsLayoutContactsImportRoute: typeof ProtectedSettingsLayoutContactsImportRoute
  ProtectedSettingsLayoutSettingsBranded_appsRoute: typeof ProtectedSettingsLayoutSettingsBranded_appsRoute
  ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute: typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute
  ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute: typeof ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute
  ProtectedSettingsLayoutSettingsCode_snippetsRoute: typeof ProtectedSettingsLayoutSettingsCode_snippetsRoute
  ProtectedSettingsLayoutSettingsCommunity_aiRoute: typeof ProtectedSettingsLayoutSettingsCommunity_aiRoute
  ProtectedSettingsLayoutSettingsConnectRoute: typeof ProtectedSettingsLayoutSettingsConnectRoute
  ProtectedSettingsLayoutSettingsConversion_trackingRoute: typeof ProtectedSettingsLayoutSettingsConversion_trackingRoute
  ProtectedSettingsLayoutSettingsCustom_domainRoute: typeof ProtectedSettingsLayoutSettingsCustom_domainRoute
  ProtectedSettingsLayoutSettingsDashboardRoute: typeof ProtectedSettingsLayoutSettingsDashboardRoute
  ProtectedSettingsLayoutSettingsDiscoverRoute: typeof ProtectedSettingsLayoutSettingsDiscoverRoute
  ProtectedSettingsLayoutSettingsEmbedRoute: typeof ProtectedSettingsLayoutSettingsEmbedRoute
  ProtectedSettingsLayoutSettingsGamificationRoute: typeof ProtectedSettingsLayoutSettingsGamificationRoute
  ProtectedSettingsLayoutSettingsGeneralRoute: typeof ProtectedSettingsLayoutSettingsGeneralRoute
  ProtectedSettingsLayoutSettingsHomeRoute: typeof ProtectedSettingsLayoutSettingsHomeRoute
  ProtectedSettingsLayoutSettingsLegalRoute: typeof ProtectedSettingsLayoutSettingsLegalRoute
  ProtectedSettingsLayoutSettingsMobile_appRoute: typeof ProtectedSettingsLayoutSettingsMobile_appRoute
  ProtectedSettingsLayoutSettingsNavigationRoute: typeof ProtectedSettingsLayoutSettingsNavigationRoute
  ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute: typeof ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute
  ProtectedSettingsLayoutSettingsPaywall_chargesRoute: typeof ProtectedSettingsLayoutSettingsPaywall_chargesRoute
  ProtectedSettingsLayoutSettingsPaywall_groupsRoute: typeof ProtectedSettingsLayoutSettingsPaywall_groupsRoute
  ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute: typeof ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute
  ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute: typeof ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute
  ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute: typeof ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute
  ProtectedSettingsLayoutSettingsRecap2025Route: typeof ProtectedSettingsLayoutSettingsRecap2025Route
  ProtectedSettingsLayoutSettingsRedirectsRoute: typeof ProtectedSettingsLayoutSettingsRedirectsRoute
  ProtectedSettingsLayoutSettingsSeoRoute: typeof ProtectedSettingsLayoutSettingsSeoRoute
  ProtectedSettingsLayoutSettingsWeekly_digestRoute: typeof ProtectedSettingsLayoutSettingsWeekly_digestRoute
  ProtectedSettingsLayoutSettingsIndexRoute: typeof ProtectedSettingsLayoutSettingsIndexRoute
  ProtectedSettingsLayoutSettingsCouponsNewRouteRoute: typeof ProtectedSettingsLayoutSettingsCouponsNewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute: typeof ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsMembersInviteRouteRoute: typeof ProtectedSettingsLayoutSettingsMembersInviteRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute: typeof ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute: typeof ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute: typeof ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute: typeof ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute
  ProtectedSettingsLayoutMembersInvitation_linksSplatRoute: typeof ProtectedSettingsLayoutMembersInvitation_linksSplatRoute
  ProtectedSettingsLayoutMembersInviteSplatRoute: typeof ProtectedSettingsLayoutMembersInviteSplatRoute
  ProtectedSettingsLayoutMembersOnboardingSplatRoute: typeof ProtectedSettingsLayoutMembersOnboardingSplatRoute
  ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute: typeof ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute
  ProtectedSettingsLayoutSettingsAudienceConnectRoute: typeof ProtectedSettingsLayoutSettingsAudienceConnectRoute
  ProtectedSettingsLayoutSettingsAudienceManageRoute: typeof ProtectedSettingsLayoutSettingsAudienceManageRoute
  ProtectedSettingsLayoutSettingsContactsImportRoute: typeof ProtectedSettingsLayoutSettingsContactsImportRoute
  ProtectedSettingsLayoutSettingsMember_tagsNewRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsNewRoute
  ProtectedSettingsLayoutSettingsMembersActivity_logsRoute: typeof ProtectedSettingsLayoutSettingsMembersActivity_logsRoute
  ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute: typeof ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute
  ProtectedSettingsLayoutSettingsModerationEditRoute: typeof ProtectedSettingsLayoutSettingsModerationEditRoute
  ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute: typeof ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute
  ProtectedSettingsLayoutSettingsPlusAppSettingsRoute: typeof ProtectedSettingsLayoutSettingsPlusAppSettingsRoute
  ProtectedSettingsLayoutSettingsPlusInsightsRoute: typeof ProtectedSettingsLayoutSettingsPlusInsightsRoute
  ProtectedSettingsLayoutSettingsPlusLiteRoute: typeof ProtectedSettingsLayoutSettingsPlusLiteRoute
  ProtectedSettingsLayoutMembersInvitation_linksIndexRoute: typeof ProtectedSettingsLayoutMembersInvitation_linksIndexRoute
  ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute: typeof ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute
  ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute
  ProtectedSettingsLayoutSettingsAiInboxIndexRoute: typeof ProtectedSettingsLayoutSettingsAiInboxIndexRoute
  ProtectedSettingsLayoutSettingsCouponsIndexRoute: typeof ProtectedSettingsLayoutSettingsCouponsIndexRoute
  ProtectedSettingsLayoutSettingsEmailsIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsIndexRoute
  ProtectedSettingsLayoutSettingsEventsIndexRoute: typeof ProtectedSettingsLayoutSettingsEventsIndexRoute
  ProtectedSettingsLayoutSettingsIntegrationsIndexRoute: typeof ProtectedSettingsLayoutSettingsIntegrationsIndexRoute
  ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute
  ProtectedSettingsLayoutSettingsMember_tagsIndexRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsIndexRoute
  ProtectedSettingsLayoutSettingsModerationIndexRoute: typeof ProtectedSettingsLayoutSettingsModerationIndexRoute
  ProtectedSettingsLayoutSettingsOnboardingIndexRoute: typeof ProtectedSettingsLayoutSettingsOnboardingIndexRoute
  ProtectedSettingsLayoutSettingsPagesIndexRoute: typeof ProtectedSettingsLayoutSettingsPagesIndexRoute
  ProtectedSettingsLayoutSettingsPaywallsIndexRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIndexRoute
  ProtectedSettingsLayoutSettingsPlusIndexRoute: typeof ProtectedSettingsLayoutSettingsPlusIndexRoute
  ProtectedSettingsLayoutSettingsPostsIndexRoute: typeof ProtectedSettingsLayoutSettingsPostsIndexRoute
  ProtectedSettingsLayoutSettingsSsoIndexRoute: typeof ProtectedSettingsLayoutSettingsSsoIndexRoute
  ProtectedSettingsLayoutSettingsThemeIndexRoute: typeof ProtectedSettingsLayoutSettingsThemeIndexRoute
  ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute: typeof ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute: typeof ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute: typeof ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute: typeof ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren
  ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute
  ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute: typeof ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute
  ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute: typeof ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute
  ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute: typeof ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute
  ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute
  ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute: typeof ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute
  ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute: typeof ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute
}

const ProtectedSettingsLayoutRouteRouteChildren: ProtectedSettingsLayoutRouteRouteChildren =
  {
    ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRoute:
      ProtectedSettingsLayoutSettingsAffiliatesLayoutRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsBillingLayoutRouteRoute:
      ProtectedSettingsLayoutSettingsBillingLayoutRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsAnalyticsRouteRoute:
      ProtectedSettingsLayoutSettingsAnalyticsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsApiRouteRoute:
      ProtectedSettingsLayoutSettingsApiRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsCoursesRouteRoute:
      ProtectedSettingsLayoutSettingsCoursesRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsDevelopersRouteRoute:
      ProtectedSettingsLayoutSettingsDevelopersRouteRoute,
    ProtectedSettingsLayoutSettingsFilesRouteRoute:
      ProtectedSettingsLayoutSettingsFilesRouteRoute,
    ProtectedSettingsLayoutSettingsLive_streamsRouteRoute:
      ProtectedSettingsLayoutSettingsLive_streamsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsNewsletterRouteRoute:
      ProtectedSettingsLayoutSettingsNewsletterRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPlansRouteRoute:
      ProtectedSettingsLayoutSettingsPlansRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsProfile_fieldsRouteRoute:
      ProtectedSettingsLayoutSettingsProfile_fieldsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsSegmentsRouteRoute:
      ProtectedSettingsLayoutSettingsSegmentsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsSpacesRouteRoute:
      ProtectedSettingsLayoutSettingsSpacesRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsTopicsRouteRoute:
      ProtectedSettingsLayoutSettingsTopicsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsWorkflowsRouteRoute:
      ProtectedSettingsLayoutSettingsWorkflowsRouteRouteWithChildren,
    ProtectedSettingsLayoutAudienceManageRoute:
      ProtectedSettingsLayoutAudienceManageRoute,
    ProtectedSettingsLayoutContactsImportRoute:
      ProtectedSettingsLayoutContactsImportRoute,
    ProtectedSettingsLayoutSettingsBranded_appsRoute:
      ProtectedSettingsLayoutSettingsBranded_appsRoute,
    ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute:
      ProtectedSettingsLayoutSettingsBranded_apps_builder_landing_pageRoute,
    ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute:
      ProtectedSettingsLayoutSettingsBranded_apps_builder_uiRoute,
    ProtectedSettingsLayoutSettingsCode_snippetsRoute:
      ProtectedSettingsLayoutSettingsCode_snippetsRoute,
    ProtectedSettingsLayoutSettingsCommunity_aiRoute:
      ProtectedSettingsLayoutSettingsCommunity_aiRoute,
    ProtectedSettingsLayoutSettingsConnectRoute:
      ProtectedSettingsLayoutSettingsConnectRoute,
    ProtectedSettingsLayoutSettingsConversion_trackingRoute:
      ProtectedSettingsLayoutSettingsConversion_trackingRoute,
    ProtectedSettingsLayoutSettingsCustom_domainRoute:
      ProtectedSettingsLayoutSettingsCustom_domainRoute,
    ProtectedSettingsLayoutSettingsDashboardRoute:
      ProtectedSettingsLayoutSettingsDashboardRoute,
    ProtectedSettingsLayoutSettingsDiscoverRoute:
      ProtectedSettingsLayoutSettingsDiscoverRoute,
    ProtectedSettingsLayoutSettingsEmbedRoute:
      ProtectedSettingsLayoutSettingsEmbedRoute,
    ProtectedSettingsLayoutSettingsGamificationRoute:
      ProtectedSettingsLayoutSettingsGamificationRoute,
    ProtectedSettingsLayoutSettingsGeneralRoute:
      ProtectedSettingsLayoutSettingsGeneralRoute,
    ProtectedSettingsLayoutSettingsHomeRoute:
      ProtectedSettingsLayoutSettingsHomeRoute,
    ProtectedSettingsLayoutSettingsLegalRoute:
      ProtectedSettingsLayoutSettingsLegalRoute,
    ProtectedSettingsLayoutSettingsMobile_appRoute:
      ProtectedSettingsLayoutSettingsMobile_appRoute,
    ProtectedSettingsLayoutSettingsNavigationRoute:
      ProtectedSettingsLayoutSettingsNavigationRoute,
    ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute:
      ProtectedSettingsLayoutSettingsPaywall_bulk_logsRoute,
    ProtectedSettingsLayoutSettingsPaywall_chargesRoute:
      ProtectedSettingsLayoutSettingsPaywall_chargesRoute,
    ProtectedSettingsLayoutSettingsPaywall_groupsRoute:
      ProtectedSettingsLayoutSettingsPaywall_groupsRoute,
    ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute:
      ProtectedSettingsLayoutSettingsPaywall_payment_settingsRoute,
    ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute:
      ProtectedSettingsLayoutSettingsPaywall_subscriptionsRoute,
    ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute:
      ProtectedSettingsLayoutSettingsPaywall_tax_settingsRoute,
    ProtectedSettingsLayoutSettingsRecap2025Route:
      ProtectedSettingsLayoutSettingsRecap2025Route,
    ProtectedSettingsLayoutSettingsRedirectsRoute:
      ProtectedSettingsLayoutSettingsRedirectsRoute,
    ProtectedSettingsLayoutSettingsSeoRoute:
      ProtectedSettingsLayoutSettingsSeoRoute,
    ProtectedSettingsLayoutSettingsWeekly_digestRoute:
      ProtectedSettingsLayoutSettingsWeekly_digestRoute,
    ProtectedSettingsLayoutSettingsIndexRoute:
      ProtectedSettingsLayoutSettingsIndexRoute,
    ProtectedSettingsLayoutSettingsCouponsNewRouteRoute:
      ProtectedSettingsLayoutSettingsCouponsNewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsBroadcastRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsFormsRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsFormsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRoute:
      ProtectedSettingsLayoutSettingsEmailsTemplatesRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksNewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsMembersInviteRouteRoute:
      ProtectedSettingsLayoutSettingsMembersInviteRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsMembersOnboardingRouteRoute:
      ProtectedSettingsLayoutSettingsMembersOnboardingRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPaywallsNewRouteRoute:
      ProtectedSettingsLayoutSettingsPaywallsNewRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRoute:
      ProtectedSettingsLayoutSettingsPlusPushNotificationsRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute:
      ProtectedSettingsLayoutSettingsPostsBulk_actionsRouteRoute,
    ProtectedSettingsLayoutMembersInvitation_linksSplatRoute:
      ProtectedSettingsLayoutMembersInvitation_linksSplatRoute,
    ProtectedSettingsLayoutMembersInviteSplatRoute:
      ProtectedSettingsLayoutMembersInviteSplatRoute,
    ProtectedSettingsLayoutMembersOnboardingSplatRoute:
      ProtectedSettingsLayoutMembersOnboardingSplatRoute,
    ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute:
      ProtectedSettingsLayoutMembersProfile_fieldsSplatRoute,
    ProtectedSettingsLayoutSettingsAudienceConnectRoute:
      ProtectedSettingsLayoutSettingsAudienceConnectRoute,
    ProtectedSettingsLayoutSettingsAudienceManageRoute:
      ProtectedSettingsLayoutSettingsAudienceManageRoute,
    ProtectedSettingsLayoutSettingsContactsImportRoute:
      ProtectedSettingsLayoutSettingsContactsImportRoute,
    ProtectedSettingsLayoutSettingsMember_tagsNewRoute:
      ProtectedSettingsLayoutSettingsMember_tagsNewRoute,
    ProtectedSettingsLayoutSettingsMembersActivity_logsRoute:
      ProtectedSettingsLayoutSettingsMembersActivity_logsRoute,
    ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute:
      ProtectedSettingsLayoutSettingsMembersBulk_import_tasksRoute,
    ProtectedSettingsLayoutSettingsModerationEditRoute:
      ProtectedSettingsLayoutSettingsModerationEditRoute,
    ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute:
      ProtectedSettingsLayoutSettingsPaywallsOnboardingRoute,
    ProtectedSettingsLayoutSettingsPlusAppSettingsRoute:
      ProtectedSettingsLayoutSettingsPlusAppSettingsRoute,
    ProtectedSettingsLayoutSettingsPlusInsightsRoute:
      ProtectedSettingsLayoutSettingsPlusInsightsRoute,
    ProtectedSettingsLayoutSettingsPlusLiteRoute:
      ProtectedSettingsLayoutSettingsPlusLiteRoute,
    ProtectedSettingsLayoutMembersInvitation_linksIndexRoute:
      ProtectedSettingsLayoutMembersInvitation_linksIndexRoute,
    ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute:
      ProtectedSettingsLayoutMembersProfile_fieldsIndexRoute,
    ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute:
      ProtectedSettingsLayoutSettingsAccess_groupsIndexRoute,
    ProtectedSettingsLayoutSettingsAiInboxIndexRoute:
      ProtectedSettingsLayoutSettingsAiInboxIndexRoute,
    ProtectedSettingsLayoutSettingsCouponsIndexRoute:
      ProtectedSettingsLayoutSettingsCouponsIndexRoute,
    ProtectedSettingsLayoutSettingsEmailsIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsIndexRoute,
    ProtectedSettingsLayoutSettingsEventsIndexRoute:
      ProtectedSettingsLayoutSettingsEventsIndexRoute,
    ProtectedSettingsLayoutSettingsIntegrationsIndexRoute:
      ProtectedSettingsLayoutSettingsIntegrationsIndexRoute,
    ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIndexRoute,
    ProtectedSettingsLayoutSettingsMember_tagsIndexRoute:
      ProtectedSettingsLayoutSettingsMember_tagsIndexRoute,
    ProtectedSettingsLayoutSettingsModerationIndexRoute:
      ProtectedSettingsLayoutSettingsModerationIndexRoute,
    ProtectedSettingsLayoutSettingsOnboardingIndexRoute:
      ProtectedSettingsLayoutSettingsOnboardingIndexRoute,
    ProtectedSettingsLayoutSettingsPagesIndexRoute:
      ProtectedSettingsLayoutSettingsPagesIndexRoute,
    ProtectedSettingsLayoutSettingsPaywallsIndexRoute:
      ProtectedSettingsLayoutSettingsPaywallsIndexRoute,
    ProtectedSettingsLayoutSettingsPlusIndexRoute:
      ProtectedSettingsLayoutSettingsPlusIndexRoute,
    ProtectedSettingsLayoutSettingsPostsIndexRoute:
      ProtectedSettingsLayoutSettingsPostsIndexRoute,
    ProtectedSettingsLayoutSettingsSsoIndexRoute:
      ProtectedSettingsLayoutSettingsSsoIndexRoute,
    ProtectedSettingsLayoutSettingsThemeIndexRoute:
      ProtectedSettingsLayoutSettingsThemeIndexRoute,
    ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRoute:
      ProtectedSettingsLayoutSettingsAiAgentsEditBotPublicIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsCouponsIdEditRouteRoute:
      ProtectedSettingsLayoutSettingsCouponsIdEditRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRoute:
      ProtectedSettingsLayoutSettingsInvitation_linksIdEditRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPagesEditIdRouteRoute:
      ProtectedSettingsLayoutSettingsPagesEditIdRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRoute:
      ProtectedSettingsLayoutSettingsPaywallsIdEditRouteRouteWithChildren,
    ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute:
      ProtectedSettingsLayoutSettingsAccess_groupsIdEditRoute,
    ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute:
      ProtectedSettingsLayoutSettingsAiInboxConversationsIdRoute,
    ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute:
      ProtectedSettingsLayoutSettingsMember_tagsIdEditRoute,
    ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute:
      ProtectedSettingsLayoutSettingsAccess_groupsIdIndexRoute,
    ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute:
      ProtectedSettingsLayoutSettingsAiAgentsAgentsIndexRoute,
    ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute:
      ProtectedSettingsLayoutSettingsAiAgentsKnowledgeIndexRoute,
    ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute:
      ProtectedSettingsLayoutSettingsEmailsSettingsIndexRoute,
  }

const ProtectedSettingsLayoutRouteRouteWithChildren =
  ProtectedSettingsLayoutRouteRoute._addFileChildren(
    ProtectedSettingsLayoutRouteRouteChildren,
  )

interface ProtectedAccountTabBodyRouteRouteChildren {
  ProtectedAccountTabBodyAuthenticationRoute: typeof ProtectedAccountTabBodyAuthenticationRoute
  ProtectedAccountTabBodyNotificationsRoute: typeof ProtectedAccountTabBodyNotificationsRoute
  ProtectedAccountTabBodyPrivacyRoute: typeof ProtectedAccountTabBodyPrivacyRoute
  ProtectedAccountTabBodyIndexRoute: typeof ProtectedAccountTabBodyIndexRoute
}

const ProtectedAccountTabBodyRouteRouteChildren: ProtectedAccountTabBodyRouteRouteChildren =
  {
    ProtectedAccountTabBodyAuthenticationRoute:
      ProtectedAccountTabBodyAuthenticationRoute,
    ProtectedAccountTabBodyNotificationsRoute:
      ProtectedAccountTabBodyNotificationsRoute,
    ProtectedAccountTabBodyPrivacyRoute: ProtectedAccountTabBodyPrivacyRoute,
    ProtectedAccountTabBodyIndexRoute: ProtectedAccountTabBodyIndexRoute,
  }

const ProtectedAccountTabBodyRouteRouteWithChildren =
  ProtectedAccountTabBodyRouteRoute._addFileChildren(
    ProtectedAccountTabBodyRouteRouteChildren,
  )

interface ProtectedAccountRouteRouteChildren {
  ProtectedAccountTabBodyRouteRoute: typeof ProtectedAccountTabBodyRouteRouteWithChildren
  ProtectedAccountAffiliateRoute: typeof ProtectedAccountAffiliateRoute
  ProtectedAccountBillingRoute: typeof ProtectedAccountBillingRoute
  ProtectedAccountPartner_programRoute: typeof ProtectedAccountPartner_programRoute
}

const ProtectedAccountRouteRouteChildren: ProtectedAccountRouteRouteChildren = {
  ProtectedAccountTabBodyRouteRoute:
    ProtectedAccountTabBodyRouteRouteWithChildren,
  ProtectedAccountAffiliateRoute: ProtectedAccountAffiliateRoute,
  ProtectedAccountBillingRoute: ProtectedAccountBillingRoute,
  ProtectedAccountPartner_programRoute: ProtectedAccountPartner_programRoute,
}

const ProtectedAccountRouteRouteWithChildren =
  ProtectedAccountRouteRoute._addFileChildren(
    ProtectedAccountRouteRouteChildren,
  )

interface ProtectedAiBotsRouteRouteChildren {
  ProtectedAiBotsHistoryRoute: typeof ProtectedAiBotsHistoryRoute
  ProtectedAiBotsIndexRoute: typeof ProtectedAiBotsIndexRoute
  ProtectedAiBotsBotIdIndexRoute: typeof ProtectedAiBotsBotIdIndexRoute
  ProtectedAiBotsBotIdConversationsConversationIdRoute: typeof ProtectedAiBotsBotIdConversationsConversationIdRoute
}

const ProtectedAiBotsRouteRouteChildren: ProtectedAiBotsRouteRouteChildren = {
  ProtectedAiBotsHistoryRoute: ProtectedAiBotsHistoryRoute,
  ProtectedAiBotsIndexRoute: ProtectedAiBotsIndexRoute,
  ProtectedAiBotsBotIdIndexRoute: ProtectedAiBotsBotIdIndexRoute,
  ProtectedAiBotsBotIdConversationsConversationIdRoute:
    ProtectedAiBotsBotIdConversationsConversationIdRoute,
}

const ProtectedAiBotsRouteRouteWithChildren =
  ProtectedAiBotsRouteRoute._addFileChildren(ProtectedAiBotsRouteRouteChildren)

interface ProtectedAiBriefsRouteRouteChildren {
  ProtectedAiBriefsIndexRoute: typeof ProtectedAiBriefsIndexRoute
}

const ProtectedAiBriefsRouteRouteChildren: ProtectedAiBriefsRouteRouteChildren =
  {
    ProtectedAiBriefsIndexRoute: ProtectedAiBriefsIndexRoute,
  }

const ProtectedAiBriefsRouteRouteWithChildren =
  ProtectedAiBriefsRouteRoute._addFileChildren(
    ProtectedAiBriefsRouteRouteChildren,
  )

interface ProtectedAiDailyBriefsRouteRouteChildren {
  ProtectedAiDailyBriefsDailyBriefIdRoute: typeof ProtectedAiDailyBriefsDailyBriefIdRoute
}

const ProtectedAiDailyBriefsRouteRouteChildren: ProtectedAiDailyBriefsRouteRouteChildren =
  {
    ProtectedAiDailyBriefsDailyBriefIdRoute:
      ProtectedAiDailyBriefsDailyBriefIdRoute,
  }

const ProtectedAiDailyBriefsRouteRouteWithChildren =
  ProtectedAiDailyBriefsRouteRoute._addFileChildren(
    ProtectedAiDailyBriefsRouteRouteChildren,
  )

interface ProtectedAiProjectsRouteRouteChildren {
  ProtectedAiProjectsProjectIdRoute: typeof ProtectedAiProjectsProjectIdRoute
  ProtectedAiProjectsIndexRoute: typeof ProtectedAiProjectsIndexRoute
}

const ProtectedAiProjectsRouteRouteChildren: ProtectedAiProjectsRouteRouteChildren =
  {
    ProtectedAiProjectsProjectIdRoute: ProtectedAiProjectsProjectIdRoute,
    ProtectedAiProjectsIndexRoute: ProtectedAiProjectsIndexRoute,
  }

const ProtectedAiProjectsRouteRouteWithChildren =
  ProtectedAiProjectsRouteRoute._addFileChildren(
    ProtectedAiProjectsRouteRouteChildren,
  )

interface ProtectedAiRouteRouteChildren {
  ProtectedAiBotsRouteRoute: typeof ProtectedAiBotsRouteRouteWithChildren
  ProtectedAiBriefsRouteRoute: typeof ProtectedAiBriefsRouteRouteWithChildren
  ProtectedAiDailyBriefsRouteRoute: typeof ProtectedAiDailyBriefsRouteRouteWithChildren
  ProtectedAiProjectsRouteRoute: typeof ProtectedAiProjectsRouteRouteWithChildren
  ProtectedAiConversationIdRoute: typeof ProtectedAiConversationIdRoute
  ProtectedAiSkillsRoute: typeof ProtectedAiSkillsRoute
  ProtectedAiIndexRoute: typeof ProtectedAiIndexRoute
}

const ProtectedAiRouteRouteChildren: ProtectedAiRouteRouteChildren = {
  ProtectedAiBotsRouteRoute: ProtectedAiBotsRouteRouteWithChildren,
  ProtectedAiBriefsRouteRoute: ProtectedAiBriefsRouteRouteWithChildren,
  ProtectedAiDailyBriefsRouteRoute:
    ProtectedAiDailyBriefsRouteRouteWithChildren,
  ProtectedAiProjectsRouteRoute: ProtectedAiProjectsRouteRouteWithChildren,
  ProtectedAiConversationIdRoute: ProtectedAiConversationIdRoute,
  ProtectedAiSkillsRoute: ProtectedAiSkillsRoute,
  ProtectedAiIndexRoute: ProtectedAiIndexRoute,
}

const ProtectedAiRouteRouteWithChildren =
  ProtectedAiRouteRoute._addFileChildren(ProtectedAiRouteRouteChildren)

interface ProtectedMembersRouteRouteChildren {
  ProtectedMembersSplatRoute: typeof ProtectedMembersSplatRoute
  ProtectedMembersConnectionsRoute: typeof ProtectedMembersConnectionsRoute
  ProtectedMembersManageRoute: typeof ProtectedMembersManageRoute
  ProtectedMembersMapRoute: typeof ProtectedMembersMapRoute
  ProtectedMembersIndexRoute: typeof ProtectedMembersIndexRoute
}

const ProtectedMembersRouteRouteChildren: ProtectedMembersRouteRouteChildren = {
  ProtectedMembersSplatRoute: ProtectedMembersSplatRoute,
  ProtectedMembersConnectionsRoute: ProtectedMembersConnectionsRoute,
  ProtectedMembersManageRoute: ProtectedMembersManageRoute,
  ProtectedMembersMapRoute: ProtectedMembersMapRoute,
  ProtectedMembersIndexRoute: ProtectedMembersIndexRoute,
}

const ProtectedMembersRouteRouteWithChildren =
  ProtectedMembersRouteRoute._addFileChildren(
    ProtectedMembersRouteRouteChildren,
  )

interface ProtectedMessagesRouteRouteChildren {
  ProtectedMessagesUuidRoute: typeof ProtectedMessagesUuidRoute
  ProtectedMessagesIndexRoute: typeof ProtectedMessagesIndexRoute
  ProtectedMessagesBotIdRoute: typeof ProtectedMessagesBotIdRoute
}

const ProtectedMessagesRouteRouteChildren: ProtectedMessagesRouteRouteChildren =
  {
    ProtectedMessagesUuidRoute: ProtectedMessagesUuidRoute,
    ProtectedMessagesIndexRoute: ProtectedMessagesIndexRoute,
    ProtectedMessagesBotIdRoute: ProtectedMessagesBotIdRoute,
  }

const ProtectedMessagesRouteRouteWithChildren =
  ProtectedMessagesRouteRoute._addFileChildren(
    ProtectedMessagesRouteRouteChildren,
  )

interface ProtectedSettingsInboxAiRouteRouteChildren {
  ProtectedSettingsInboxAiIndexRoute: typeof ProtectedSettingsInboxAiIndexRoute
  ProtectedSettingsInboxAiConversationsIdRoute: typeof ProtectedSettingsInboxAiConversationsIdRoute
}

const ProtectedSettingsInboxAiRouteRouteChildren: ProtectedSettingsInboxAiRouteRouteChildren =
  {
    ProtectedSettingsInboxAiIndexRoute: ProtectedSettingsInboxAiIndexRoute,
    ProtectedSettingsInboxAiConversationsIdRoute:
      ProtectedSettingsInboxAiConversationsIdRoute,
  }

const ProtectedSettingsInboxAiRouteRouteWithChildren =
  ProtectedSettingsInboxAiRouteRoute._addFileChildren(
    ProtectedSettingsInboxAiRouteRouteChildren,
  )

interface ProtectedSettingsInboxChatThreadsRouteRouteChildren {
  ProtectedSettingsInboxChatThreadsIdRoute: typeof ProtectedSettingsInboxChatThreadsIdRoute
}

const ProtectedSettingsInboxChatThreadsRouteRouteChildren: ProtectedSettingsInboxChatThreadsRouteRouteChildren =
  {
    ProtectedSettingsInboxChatThreadsIdRoute:
      ProtectedSettingsInboxChatThreadsIdRoute,
  }

const ProtectedSettingsInboxChatThreadsRouteRouteWithChildren =
  ProtectedSettingsInboxChatThreadsRouteRoute._addFileChildren(
    ProtectedSettingsInboxChatThreadsRouteRouteChildren,
  )

interface ProtectedSettingsInboxConnectionRequestsRouteRouteChildren {
  ProtectedSettingsInboxConnectionRequestsIdRoute: typeof ProtectedSettingsInboxConnectionRequestsIdRoute
  ProtectedSettingsInboxConnectionRequestsIndexRoute: typeof ProtectedSettingsInboxConnectionRequestsIndexRoute
}

const ProtectedSettingsInboxConnectionRequestsRouteRouteChildren: ProtectedSettingsInboxConnectionRequestsRouteRouteChildren =
  {
    ProtectedSettingsInboxConnectionRequestsIdRoute:
      ProtectedSettingsInboxConnectionRequestsIdRoute,
    ProtectedSettingsInboxConnectionRequestsIndexRoute:
      ProtectedSettingsInboxConnectionRequestsIndexRoute,
  }

const ProtectedSettingsInboxConnectionRequestsRouteRouteWithChildren =
  ProtectedSettingsInboxConnectionRequestsRouteRoute._addFileChildren(
    ProtectedSettingsInboxConnectionRequestsRouteRouteChildren,
  )

interface ProtectedSettingsInboxCourseCommentsRouteRouteChildren {
  ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute: typeof ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute
  ProtectedSettingsInboxCourseCommentsIndexRoute: typeof ProtectedSettingsInboxCourseCommentsIndexRoute
}

const ProtectedSettingsInboxCourseCommentsRouteRouteChildren: ProtectedSettingsInboxCourseCommentsRouteRouteChildren =
  {
    ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute:
      ProtectedSettingsInboxCourseCommentsChatRoomUuidRoute,
    ProtectedSettingsInboxCourseCommentsIndexRoute:
      ProtectedSettingsInboxCourseCommentsIndexRoute,
  }

const ProtectedSettingsInboxCourseCommentsRouteRouteWithChildren =
  ProtectedSettingsInboxCourseCommentsRouteRoute._addFileChildren(
    ProtectedSettingsInboxCourseCommentsRouteRouteChildren,
  )

interface ProtectedSettingsInboxHumanSupportRouteRouteChildren {
  ProtectedSettingsInboxHumanSupportIndexRoute: typeof ProtectedSettingsInboxHumanSupportIndexRoute
  ProtectedSettingsInboxHumanSupportConversationsIdRoute: typeof ProtectedSettingsInboxHumanSupportConversationsIdRoute
}

const ProtectedSettingsInboxHumanSupportRouteRouteChildren: ProtectedSettingsInboxHumanSupportRouteRouteChildren =
  {
    ProtectedSettingsInboxHumanSupportIndexRoute:
      ProtectedSettingsInboxHumanSupportIndexRoute,
    ProtectedSettingsInboxHumanSupportConversationsIdRoute:
      ProtectedSettingsInboxHumanSupportConversationsIdRoute,
  }

const ProtectedSettingsInboxHumanSupportRouteRouteWithChildren =
  ProtectedSettingsInboxHumanSupportRouteRoute._addFileChildren(
    ProtectedSettingsInboxHumanSupportRouteRouteChildren,
  )

interface ProtectedSettingsInboxMessagesRouteRouteChildren {
  ProtectedSettingsInboxMessagesUuidRoute: typeof ProtectedSettingsInboxMessagesUuidRoute
  ProtectedSettingsInboxMessagesIndexRoute: typeof ProtectedSettingsInboxMessagesIndexRoute
  ProtectedSettingsInboxMessagesBotIdRoute: typeof ProtectedSettingsInboxMessagesBotIdRoute
}

const ProtectedSettingsInboxMessagesRouteRouteChildren: ProtectedSettingsInboxMessagesRouteRouteChildren =
  {
    ProtectedSettingsInboxMessagesUuidRoute:
      ProtectedSettingsInboxMessagesUuidRoute,
    ProtectedSettingsInboxMessagesIndexRoute:
      ProtectedSettingsInboxMessagesIndexRoute,
    ProtectedSettingsInboxMessagesBotIdRoute:
      ProtectedSettingsInboxMessagesBotIdRoute,
  }

const ProtectedSettingsInboxMessagesRouteRouteWithChildren =
  ProtectedSettingsInboxMessagesRouteRoute._addFileChildren(
    ProtectedSettingsInboxMessagesRouteRouteChildren,
  )

interface ProtectedSettingsInboxModerationRouteRouteChildren {
  ProtectedSettingsInboxModerationIdRoute: typeof ProtectedSettingsInboxModerationIdRoute
  ProtectedSettingsInboxModerationIndexRoute: typeof ProtectedSettingsInboxModerationIndexRoute
}

const ProtectedSettingsInboxModerationRouteRouteChildren: ProtectedSettingsInboxModerationRouteRouteChildren =
  {
    ProtectedSettingsInboxModerationIdRoute:
      ProtectedSettingsInboxModerationIdRoute,
    ProtectedSettingsInboxModerationIndexRoute:
      ProtectedSettingsInboxModerationIndexRoute,
  }

const ProtectedSettingsInboxModerationRouteRouteWithChildren =
  ProtectedSettingsInboxModerationRouteRoute._addFileChildren(
    ProtectedSettingsInboxModerationRouteRouteChildren,
  )

interface ProtectedSettingsInboxPriorityRouteRouteChildren {
  ProtectedSettingsInboxPriorityKindUuidRoute: typeof ProtectedSettingsInboxPriorityKindUuidRoute
}

const ProtectedSettingsInboxPriorityRouteRouteChildren: ProtectedSettingsInboxPriorityRouteRouteChildren =
  {
    ProtectedSettingsInboxPriorityKindUuidRoute:
      ProtectedSettingsInboxPriorityKindUuidRoute,
  }

const ProtectedSettingsInboxPriorityRouteRouteWithChildren =
  ProtectedSettingsInboxPriorityRouteRoute._addFileChildren(
    ProtectedSettingsInboxPriorityRouteRouteChildren,
  )

interface ProtectedSettingsInboxRouteRouteChildren {
  ProtectedSettingsInboxAiRouteRoute: typeof ProtectedSettingsInboxAiRouteRouteWithChildren
  ProtectedSettingsInboxChatThreadsRouteRoute: typeof ProtectedSettingsInboxChatThreadsRouteRouteWithChildren
  ProtectedSettingsInboxConnectionRequestsRouteRoute: typeof ProtectedSettingsInboxConnectionRequestsRouteRouteWithChildren
  ProtectedSettingsInboxCourseCommentsRouteRoute: typeof ProtectedSettingsInboxCourseCommentsRouteRouteWithChildren
  ProtectedSettingsInboxHumanSupportRouteRoute: typeof ProtectedSettingsInboxHumanSupportRouteRouteWithChildren
  ProtectedSettingsInboxMessagesRouteRoute: typeof ProtectedSettingsInboxMessagesRouteRouteWithChildren
  ProtectedSettingsInboxModerationRouteRoute: typeof ProtectedSettingsInboxModerationRouteRouteWithChildren
  ProtectedSettingsInboxNotificationsRouteRoute: typeof ProtectedSettingsInboxNotificationsRouteRoute
  ProtectedSettingsInboxPriorityRouteRoute: typeof ProtectedSettingsInboxPriorityRouteRouteWithChildren
  ProtectedSettingsInboxIndexRoute: typeof ProtectedSettingsInboxIndexRoute
}

const ProtectedSettingsInboxRouteRouteChildren: ProtectedSettingsInboxRouteRouteChildren =
  {
    ProtectedSettingsInboxAiRouteRoute:
      ProtectedSettingsInboxAiRouteRouteWithChildren,
    ProtectedSettingsInboxChatThreadsRouteRoute:
      ProtectedSettingsInboxChatThreadsRouteRouteWithChildren,
    ProtectedSettingsInboxConnectionRequestsRouteRoute:
      ProtectedSettingsInboxConnectionRequestsRouteRouteWithChildren,
    ProtectedSettingsInboxCourseCommentsRouteRoute:
      ProtectedSettingsInboxCourseCommentsRouteRouteWithChildren,
    ProtectedSettingsInboxHumanSupportRouteRoute:
      ProtectedSettingsInboxHumanSupportRouteRouteWithChildren,
    ProtectedSettingsInboxMessagesRouteRoute:
      ProtectedSettingsInboxMessagesRouteRouteWithChildren,
    ProtectedSettingsInboxModerationRouteRoute:
      ProtectedSettingsInboxModerationRouteRouteWithChildren,
    ProtectedSettingsInboxNotificationsRouteRoute:
      ProtectedSettingsInboxNotificationsRouteRoute,
    ProtectedSettingsInboxPriorityRouteRoute:
      ProtectedSettingsInboxPriorityRouteRouteWithChildren,
    ProtectedSettingsInboxIndexRoute: ProtectedSettingsInboxIndexRoute,
  }

const ProtectedSettingsInboxRouteRouteWithChildren =
  ProtectedSettingsInboxRouteRoute._addFileChildren(
    ProtectedSettingsInboxRouteRouteChildren,
  )

interface ProtectedSettingsAdminAudienceSqidRouteRouteChildren {
  ProtectedSettingsAdminAudienceSqidSplatRoute: typeof ProtectedSettingsAdminAudienceSqidSplatRoute
  ProtectedSettingsAdminAudienceSqidAccessRoute: typeof ProtectedSettingsAdminAudienceSqidAccessRoute
  ProtectedSettingsAdminAudienceSqidActivity_logsRoute: typeof ProtectedSettingsAdminAudienceSqidActivity_logsRoute
  ProtectedSettingsAdminAudienceSqidAffiliateRoute: typeof ProtectedSettingsAdminAudienceSqidAffiliateRoute
  ProtectedSettingsAdminAudienceSqidGamificationRoute: typeof ProtectedSettingsAdminAudienceSqidGamificationRoute
  ProtectedSettingsAdminAudienceSqidInfoRoute: typeof ProtectedSettingsAdminAudienceSqidInfoRoute
  ProtectedSettingsAdminAudienceSqidNotesRoute: typeof ProtectedSettingsAdminAudienceSqidNotesRoute
  ProtectedSettingsAdminAudienceSqidIndexRoute: typeof ProtectedSettingsAdminAudienceSqidIndexRoute
  ProtectedSettingsAdminAudienceSqidBillingIndexRoute: typeof ProtectedSettingsAdminAudienceSqidBillingIndexRoute
  ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute: typeof ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute
}

const ProtectedSettingsAdminAudienceSqidRouteRouteChildren: ProtectedSettingsAdminAudienceSqidRouteRouteChildren =
  {
    ProtectedSettingsAdminAudienceSqidSplatRoute:
      ProtectedSettingsAdminAudienceSqidSplatRoute,
    ProtectedSettingsAdminAudienceSqidAccessRoute:
      ProtectedSettingsAdminAudienceSqidAccessRoute,
    ProtectedSettingsAdminAudienceSqidActivity_logsRoute:
      ProtectedSettingsAdminAudienceSqidActivity_logsRoute,
    ProtectedSettingsAdminAudienceSqidAffiliateRoute:
      ProtectedSettingsAdminAudienceSqidAffiliateRoute,
    ProtectedSettingsAdminAudienceSqidGamificationRoute:
      ProtectedSettingsAdminAudienceSqidGamificationRoute,
    ProtectedSettingsAdminAudienceSqidInfoRoute:
      ProtectedSettingsAdminAudienceSqidInfoRoute,
    ProtectedSettingsAdminAudienceSqidNotesRoute:
      ProtectedSettingsAdminAudienceSqidNotesRoute,
    ProtectedSettingsAdminAudienceSqidIndexRoute:
      ProtectedSettingsAdminAudienceSqidIndexRoute,
    ProtectedSettingsAdminAudienceSqidBillingIndexRoute:
      ProtectedSettingsAdminAudienceSqidBillingIndexRoute,
    ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute:
      ProtectedSettingsAdminAudienceSqidBillingSubscriptionsNewRoute,
  }

const ProtectedSettingsAdminAudienceSqidRouteRouteWithChildren =
  ProtectedSettingsAdminAudienceSqidRouteRoute._addFileChildren(
    ProtectedSettingsAdminAudienceSqidRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedDynamicLayoutRouteRoute: typeof ProtectedDynamicLayoutRouteRouteWithChildren
  ProtectedEmbedRouteRoute: typeof ProtectedEmbedRouteRouteWithChildren
  ProtectedSettingsLayoutRouteRoute: typeof ProtectedSettingsLayoutRouteRouteWithChildren
  ProtectedAccountRouteRoute: typeof ProtectedAccountRouteRouteWithChildren
  ProtectedAiRouteRoute: typeof ProtectedAiRouteRouteWithChildren
  ProtectedMembersRouteRoute: typeof ProtectedMembersRouteRouteWithChildren
  ProtectedMessagesRouteRoute: typeof ProtectedMessagesRouteRouteWithChildren
  ProtectedBookmarksRoute: typeof ProtectedBookmarksRoute
  ProtectedConnectionsRoute: typeof ProtectedConnectionsRoute
  ProtectedDiscoverRoute: typeof ProtectedDiscoverRoute
  ProtectedLeaderboardRoute: typeof ProtectedLeaderboardRoute
  ProtectedNotificationsRoute: typeof ProtectedNotificationsRoute
  ProtectedThreadsRoute: typeof ProtectedThreadsRoute
  ProtectedSettingsInboxRouteRoute: typeof ProtectedSettingsInboxRouteRouteWithChildren
  ProtectedGettingStartedAiRoute: typeof ProtectedGettingStartedAiRoute
  ProtectedGettingStartedIndexRoute: typeof ProtectedGettingStartedIndexRoute
  ProtectedSettingsAdminAudienceSqidRouteRoute: typeof ProtectedSettingsAdminAudienceSqidRouteRouteWithChildren
  ProtectedAdminAudienceSqidSplatRoute: typeof ProtectedAdminAudienceSqidSplatRoute
  ProtectedAdminAudienceSqidIndexRoute: typeof ProtectedAdminAudienceSqidIndexRoute
  ProtectedSettingsCoursesIdLessonsLessonIdEditRoute: typeof ProtectedSettingsCoursesIdLessonsLessonIdEditRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedDynamicLayoutRouteRoute:
    ProtectedDynamicLayoutRouteRouteWithChildren,
  ProtectedEmbedRouteRoute: ProtectedEmbedRouteRouteWithChildren,
  ProtectedSettingsLayoutRouteRoute:
    ProtectedSettingsLayoutRouteRouteWithChildren,
  ProtectedAccountRouteRoute: ProtectedAccountRouteRouteWithChildren,
  ProtectedAiRouteRoute: ProtectedAiRouteRouteWithChildren,
  ProtectedMembersRouteRoute: ProtectedMembersRouteRouteWithChildren,
  ProtectedMessagesRouteRoute: ProtectedMessagesRouteRouteWithChildren,
  ProtectedBookmarksRoute: ProtectedBookmarksRoute,
  ProtectedConnectionsRoute: ProtectedConnectionsRoute,
  ProtectedDiscoverRoute: ProtectedDiscoverRoute,
  ProtectedLeaderboardRoute: ProtectedLeaderboardRoute,
  ProtectedNotificationsRoute: ProtectedNotificationsRoute,
  ProtectedThreadsRoute: ProtectedThreadsRoute,
  ProtectedSettingsInboxRouteRoute:
    ProtectedSettingsInboxRouteRouteWithChildren,
  ProtectedGettingStartedAiRoute: ProtectedGettingStartedAiRoute,
  ProtectedGettingStartedIndexRoute: ProtectedGettingStartedIndexRoute,
  ProtectedSettingsAdminAudienceSqidRouteRoute:
    ProtectedSettingsAdminAudienceSqidRouteRouteWithChildren,
  ProtectedAdminAudienceSqidSplatRoute: ProtectedAdminAudienceSqidSplatRoute,
  ProtectedAdminAudienceSqidIndexRoute: ProtectedAdminAudienceSqidIndexRoute,
  ProtectedSettingsCoursesIdLessonsLessonIdEditRoute:
    ProtectedSettingsCoursesIdLessonsLessonIdEditRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MinimalRouteRoute: MinimalRouteRouteWithChildren,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  FeedRoute: FeedRoute,
  HomeRoute: HomeRoute,
  FeedWelcomeRoute: FeedWelcomeRoute,
  Marketing_emailsMarketing_email_preferenceRoute:
    Marketing_emailsMarketing_email_preferenceRoute,
  Marketing_emailsUnsubscribeRoute: Marketing_emailsUnsubscribeRoute,
  PublicUnsubscribeRoute: PublicUnsubscribeRoute,
  NewsletterPostsSlugRoute: NewsletterPostsSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
